import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy, ChangeDetectorRef, NgZone, ChangeDetectionStrategy } from '@angular/core';
import { ProgressiveController } from '../progressive/progressiveController';
import { CubeController } from '../cube/cubeController';
import { OzonetelController } from '../ozonetel/ozonetelController';
import { CentroController } from '../centro/centroController';
import { CentroSipService } from '../centro/centro-sip.service';
import { CentroControlWsService } from '../centro/centro-control-ws.service';
import { CallingService } from '../calling.service';
import { OzonetelSDKCoreService } from '../ozonetel/ozonetel-sdk-core.service';
import { IncomeCallService } from '../../../_Common/_Services/income-call.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntypedFormControl } from '@angular/forms';
import { UserService } from '../../../_Common/_Services/user.service';
import { Subscription, firstValueFrom } from 'rxjs';
import { OzonetelDialerFlowService } from '../ozonetel/ozonetel-dialer-flow.service';
import { OzonetelService } from '../ozonetel/ozonetel.service';
import { isOzonetelSdkDialer } from '../ozonetel/ozonetel-dialer-mode';
import {
  isCubeDialerAllowed,
  isOzonetelDialerEnabled,
  resolveCallingDialerType,
  toWidgetCallingType,
} from '../calling-dialer-mode';
import { CubeCallUiState, CubeDialerFlowService } from '../cube/cube-dialer-flow.service';
import { CUBE_BREAK_UI_OPTIONS, getCubeBreakIcon } from '../cube/cube-break-types';
import { CubeConnectorCoreService, CubeTransferAgent } from '../cube/cube-connector-core.service';
import { cubeDebugLog, cubeDebugSnapshot } from '../cube/cube-debug-log';
import {
  CubeConnectorUiStatus,
  cubeConnectorStatusIsLoggedIn,
  getCubeAutoAnswerEnabled,
  getCubeAutoTransferProfile,
  CubeAutoTransferProfile,
  isCubeAutoTransferDummySession,
  isCubeWebphoneConnector,
} from '../cube/cube-dialer-mode';
import {
  isCubeAutoTransferDummyEligible,
  resolveCubeAutoTransferProfile,
} from '../cube/cube-auto-transfer-config';
import { shouldUseCubeSdk } from '../cube-sdk/cube-sdk-mode';
import { OzonetelTransferService } from '../ozonetel/ozonetel-transfer.service';
import {
  OzonetelDispositionOption,
  OzonetelWrapUpService,
} from '../ozonetel/ozonetel-wrap-up.service';
import {
  getOzonetelAutoTransferCampaigns,
  isOzonetelAutoTransferConfigReady,
  isOzonetelAutoTransferDummyAgent,
  pickOzonetelAutoTransferTarget,
} from '../ozonetel/ozonetel-auto-transfer-config';
import {
  CubeDispositionOption,
  CubeWrapUpService,
} from '../cube/cube-wrap-up.service';
import {
  CentroDialerFlowService,
} from '../centro/centro-dialer-flow.service';
import {
  CentroDispositionOption,
  CentroWrapUpService,
} from '../centro/centro-wrap-up.service';
import { CentroUiStateService } from '../centro/centro-ui-state.service';
import { IgnosisTransferService } from '../ignosis/ignosis-transfer.service';
import {
  getCentroAutoTransferProfile,
  isCentroAutoTransferSourceCampaign,
} from '../centro/centro-dialer-mode';
import {
  isCubeAutoTransferSourceCampaign as isCubeJsonSourceCampaign,
} from '../cube/cube-auto-transfer-config';

@Component({
    selector: 'mt-calling',
    templateUrl: 'calling.component.html',
    styleUrls: ['calling.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CallingComponent implements OnInit, OnChanges, OnDestroy {
  @Input() inputObj: any;
  @Output() onAction = new EventEmitter<any>();

  // UI State
  fullScreen = true;
  showDialpad = false;
  dialpadNumber = '';
  isMuted = false;
  showGotoCase = true;
  loader = false;
  showBody = false;
  isSdkDialer = isOzonetelSdkDialer();
  isCubeDialer = false;
  isCubeWebphone = false;
  showSdkManualDial = false;
  showCubeManualDial = false;
  showCentroManualDial = false;
  showCentroTools = false;
  centroToolsTab: 'transfer' | 'conference' = 'transfer';
  centroSelectedTransferAgent = '';
  centroTransferAgents: Array<{ AgentId: string; Extension?: string; label?: string }> = [];
  centroTransferAgentsLoading = false;
  centroConferenceDialStarted = false;
  centroConferenceNumber = '';
  centroAutoTransferRouting = false;
  centroAutoTransferTargetLabel = '';
  private centroAutoTransferExhausted = false;
  private centroAutoTransferTotalSends = 0;
  private centroAutoTransferRunner: Promise<void> | null = null;
  private static readonly CENTRO_AUTO_TRANSFER_MAX_ATTEMPTS = 3;
  showCubeTools = false;
  cubeToolsTab: 'transfer' | 'conference' = 'transfer';
  cubeSelectedTransferAgent = '';
  cubeTransferAgents: CubeTransferAgent[] = [];
  cubeTransferAgentsLoading = false;
  cubeConferenceDialStarted = false;
  cubeDisposition = 'No Requirment';
  cubeTransferNumber = '';
  cubeConferenceNumber = '';
  cubeAutoAnswer = getCubeAutoAnswerEnabled();
  private cubeWebphoneEventsStarted = false;
  private centroBootstrapStarted = false;
  private centroReady = false;
  centroBrowserSipReady = false;
  centroRequiresFreeAgent = false;
  centroPendingUserStatusId = '';
  centroFreeAgentLoading = false;
  centroSipRinging = false;
  centroStatusDetail = '';
  private centroAgentLegLive = false;
  private centroOutboundActive = false;
  private centroSipEndTimer: ReturnType<typeof setTimeout> | null = null;
  private centroRemoteHangup = false;
  private centroLiveLegEpoch = 0;
  private centroControlLineSub?: Subscription;
  private centroLiveSubs: Subscription[] = [];
  private lastCubeSyncKey = '';
  sdkDialNumber = '';

  /**
   * OZONETEL SDK WRAP-UP (ACW) — UI state for post-call disposition.
   *
   * Triggered by: OzonetelSDKCoreService DROP event → enterOzonetelWrapUp()
   * List source:  OzonetelWrapUpService.loadDispositions() → dialersDispositionList.json (S3)
   * Submit path:  submitOzonetelDisposition() → OzonetelWrapUpService → dc.setDisposition()
   * Panel shown:  showOzonetelDispositionPanel (SDK + ozonetel + Disconnected + wrap-up active)
   * Auto-submit:  wrap timer (featureList.wrapDuration) → autoDisposeCall() → first disposition
   *
   * While ozonetelWrapUpActive: caller info stays visible; new calls / manual dial / agent toggle blocked.
   */
  ozonetelWrapUpActive = false;
  ozonetelDispositions: OzonetelDispositionOption[] = [];
  selectedOzonetelDisposition = '';
  ozonetelDispositionComment = '';
  ozonetelDispositionLoading = false;
  ozonetelDispositionError = '';
  private ozonetelWrapUpSubmitInFlight = false;

  /**
   * Cube wrap-up (ACW): after call end, caller stays on screen until disposition is submitted.
   * List is Moneytor dialersDispositionList (S3 / local JSON), not Cube's iframe WRAP form.
   * Panel: showCubeDispositionPanel (cube + Disconnected + cubeWrapUpActive).
   */
  cubeWrapUpActive = false;
  cubeDispositions: CubeDispositionOption[] = [];
  selectedCubeDisposition = '';
  cubeDispositionComment = '';
  cubeDispositionLoading = false;
  cubeDispositionError = '';
  private cubeWrapUpSubmitInFlight = false;
  private cubeAutoDisposeTriggered = false;
  private static readonly CUBE_AUTO_DISPOSE_REASON = 'Auto Dispose';

  centroWrapUpActive = false;
  centroDispositions: CentroDispositionOption[] = [];
  selectedCentroDisposition = '';
  centroDispositionComment = '';
  centroDispositionLoading = false;
  centroDispositionError = '';
  private centroWrapUpSubmitInFlight = false;
  private centroAutoDisposeTriggered = false;
  private centroWrapUpContext: {
    recordId: string;
    crmDataId: string;
    crmLeadId: string;
    phoneNo: string;
    callType: string;
  } = { recordId: '', crmDataId: '', crmLeadId: '', phoneNo: '', callType: '' };
  private static readonly CENTRO_AUTO_DISPOSE_REASON = 'not connected';

  // Timer
  timerMinutes = 0;
  timerSeconds = 0;
  showTimer = false;
  timerInterval: any;
  wrapUpElapsedSeconds = 0;
  private wrapUpElapsedInterval: any;
  /** One-shot guard so 30s wrap-up auto-dispose fires only once per wrap-up session. */
  private ozonetelAutoDisposeTriggered = false;
  private static readonly OZONETEL_AUTO_DISPOSE_REASON = 'Auto Dispose';
  private static readonly OZONETEL_WRAPUP_AUTO_DISPOSE_SECONDS = 30;

  // Agent State
  agentStatus = 'UNKNOWN';
  callData: any = null;

  // Dialer
  diallerController: any;
  myControl = new UntypedFormControl();
  extensionNumbers: any[] = [];
  transferAgentSearch = '';

  // Break Types
  breakTypes = [
    { name: "DND", id: 0 },
    { name: "Tea Break", id: 1 },
    { name: "Lunch Break", id: 2 },
    { name: "Bio Break", id: 3 },
    { name: "Training", id: 4 },
    { name: "Meeting", id: 5 },
    { name: "Other", id: 6 }
  ];

  get activeBreakTypes() {
    return this.inputObj?.callingType === 'cube' || this.isCubeWebphone
      ? CUBE_BREAK_UI_OPTIONS
      : this.breakTypes;
  }

  // Dialpad Keys
  dialpadKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

  // Subscriptions
  private subscriptions: Subscription[] = [];
  private sdkAutoInitializeStarted = false;
  private lastCaseSyncKey = '';
  private lastCaseSyncAt = 0;
  private lastCubeCaseSyncKey = '';
  private lastCubeCaseSyncAt = 0;
  private lastCentroCaseSyncKey = '';
  private lastCentroCaseSyncAt = 0;
  private autoUnholdInFlight = false;
  private lastAutoUnholdUcid = '';
  private callUiEpoch = 0;
  private manualDialWatchTimer: ReturnType<typeof setTimeout> | null = null;
  private ignosisPresenceTimer: ReturnType<typeof setInterval> | null = null;
  /** Tracks ucid::targetAgentId pairs already attempted — prevents duplicate auto-transfers per call leg. */
  private autoTransferAttemptedKeys = new Set<string>();
  /** Blocks concurrent auto-transfer attempts for the same call leg while transfer API is in flight. */
  private autoTransferInFlightKeys = new Set<string>();
  /** Blocks parallel dummy-connection waits for the same transfer leg. */
  private cubeAutoTransferWaitKeys = new Set<string>();
  /** Transfer API sends per call leg — hard stop after 3. */
  private cubeAutoTransferSendCounts = new Map<string, number>();
  /** Total transfer sends this call session — stops duplicate invocations from syncCubeCallState. */
  private cubeAutoTransferTotalSends = 0;
  private cubeAutoTransferExhausted = false;
  /** One auto-transfer attempt per call leg — failed transfer keeps call on dummy. */
  private cubeAutoTransferLegAttempted = false;
  private cubeAutoTransferRunner: Promise<void> | null = null;
  private cubeAutoTransferTimerIds: ReturnType<typeof setTimeout>[] = [];
  private cubeActiveLegKey = '';
  private cubeCallLegResetInProgress = false;
  private cubeRestoreSyncInFlight = false;
  private cubeCallEndHandledAt = 0;
  private cubeReconcileTimer: ReturnType<typeof setTimeout> | null = null;
  private lastCubeReconcileKey = '';
  private static readonly CUBE_AUTO_TRANSFER_MAX_ATTEMPTS = 2;

  private cubeLog(method: string, detail?: Record<string, unknown>): void {
    cubeDebugLog('Widget', method, detail);
  }

  /** Debug snapshot of widget + connector state (filter console: CUBE_DEBUG). */
  private logCubeStateSnapshot(reason: string): void {
    if (!this.isCubeWebphone && this.inputObj?.callingType !== 'cube') {
      return;
    }
    cubeDebugSnapshot('Widget', reason, {
      agentStatus: this.agentStatus,
      inputStatus: this.inputObj?.Status,
      phoneNo: this.inputObj?.phoneNo || '',
      fullName: this.inputObj?.fullName || '',
      cubeWrapUpActive: this.cubeWrapUpActive,
      showCubeDispositionPanel: this.showCubeDispositionPanel,
      cubeDispositionsCount: this.cubeDispositions.length,
      selectedCubeDisposition: this.selectedCubeDisposition,
      cubeDummyTransferReleased: this.cubeDummyTransferReleased,
      cubeAutoTransferRouting: this.cubeAutoTransferRouting,
      connectorStatus: this.cubeConnector.getCurrentStatus(),
      isAgentLoggedIn: this.cubeConnector.isAgentLoggedIn(),
      isLoginInFlight: this.cubeConnector.isLoginInFlight(),
      isWrapUpPending: this.cubeConnector.isWrapUpPending(),
      isCallSessionActive: this.cubeConnector.isCallSessionActive(),
      isCallLegActive: this.cubeConnector.isCallLegActive(),
      isCubeIframeAgentConnected: this.cubeConnector.isCubeIframeAgentConnected(),
    });
  }
  /** Dummy agent UI cleared once after blind transfer completes. */
  private cubeDummyTransferReleased = false;
  /** True while blind transfer is routing to activeUser (shows "Transferring to…"). */
  cubeAutoTransferRouting = false;
  cubeAutoTransferTargetLabel = '';
  private cubeAutoTransferPendingRelease = false;
  private cubeAutoTransferPendingKey = '';
  private cubeAutoTransferPendingCampaign = '';
  private cubeAutoTransferPendingTarget = '';
  private cubeAutoTransferResolvedCampaign = '';
  private cubeAutoTransferResolvedTarget = '';
  /** One-shot marker: next Agent A release came from transfer, so skip wrap-up/disposition. */
  private pendingTransferReleaseBypass = false;
  private skipNextInputChange = false;
  private callerIdentityCache: {
    ucid?: string;
    legKey?: string;
    fullName?: string;
    phoneNo?: string;
    dueId?: string;
    custData?: unknown;
  } = {};
  private cubeCampaignAgentsCacheKey = '';
  private cubeCampaignAgentsCache: CubeTransferAgent[] = [];

  constructor(
    private callingService: CallingService,
    private router: Router,
    private snackbar: MatSnackBar,
    private incomeCallService: IncomeCallService,
    private userService: UserService,
    private ozonetelSDKCore: OzonetelSDKCoreService,
    private ozonetelDialerFlow: OzonetelDialerFlowService,
    private ozonetelService: OzonetelService,
    private cubeDialerFlow: CubeDialerFlowService,
    private cubeConnector: CubeConnectorCoreService,
    private centroDialerFlow: CentroDialerFlowService,
    private centroSip: CentroSipService,
    private centroControlWs: CentroControlWsService,
    private cdr: ChangeDetectorRef,
    private ozonetelTransfer: OzonetelTransferService,
    private ozonetelWrapUp: OzonetelWrapUpService,
    private cubeWrapUp: CubeWrapUpService,
    private centroWrapUp: CentroWrapUpService,
    private centroUiState: CentroUiStateService,
    private ngZone: NgZone,
    private ignosisTransfer: IgnosisTransferService
  ) { }

  ngOnInit() {
    const autoRedirection = localStorage.getItem('autoRedirection');
    this.showGotoCase = autoRedirection !== 'true';
    this.fullScreen = true;
    this.showBody = false;
    this.getAgentIds();
    this.syncDialerTypeFromSession();
    this.reportIgnosisPresence();
    this.ignosisPresenceTimer = setInterval(() => this.reportIgnosisPresence(), 5000);
    // Centro only: timeline4 CRM disposition → complete wrap-up in this widget (same path as the wrap-up panel).
    this.subscriptions.push(
      this.centroUiState.crmDisposition$.subscribe((payload) => {
        void this.applyCentroDispositionFromCrm(payload);
      })
    );
    if (this.isCubeDialer) {
      this.initCubeAgentStatus();
    } else if (this.inputObj?.callingType === 'ozonetel') {
      this.ensureOzonetelSDKInitialized();
    } else if (this.inputObj?.callingType === 'centro') {
      this.initCentroAgentStatus();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const fromSelfSync = this.skipNextInputChange;
    if (fromSelfSync) {
      this.skipNextInputChange = false;
    }

    // Initialize inputObj if it doesn't exist
    this.syncDialerTypeFromSession();

    if (!this.inputObj) {
      this.inputObj = {
        Status: 'Idle',
        isToggled: false,
        pauseCall: false,
        holdCall: false,
        callingType: toWidgetCallingType(this.getResolvedDialerType()) || this.defaultWidgetCallingType(),
        transferCall: false,
      };
    } else if (!this.inputObj.callingType) {
      this.inputObj.callingType = toWidgetCallingType(this.getResolvedDialerType()) || this.defaultWidgetCallingType();
    }

    this.isCubeDialer = this.inputObj.callingType === 'cube';
    this.isCubeWebphone = this.isCubeDialer && isCubeWebphoneConnector();
    this.isSdkDialer = this.inputObj.callingType === 'ozonetel' && isOzonetelSdkDialer();

    if (this.inputObj.Status === 'Completed') {
      setTimeout(() => this.clearCallDisplayState(), 500);
    }

    if (this.inputObj.Status === 'stopped') {
      this.onActions(true);
    }

    if (this.inputObj.Status === 'Disconnected') {
      this.timer().start();
    } else {
      this.timer().stop();
    }

    // Initialize controller based on calling type
    if (this.inputObj.callingType === 'progressive') {
      this.diallerController = new ProgressiveController(this.callingService);
    } else if (this.inputObj.callingType === 'cube') {
      if (!this.diallerController) {
        this.diallerController = new CubeController(this.callingService);
      }
      this.initCubeAgentStatus();
      if (!fromSelfSync && this.isCubeWebphone) {
        this.scheduleReconcileStaleCubeCallDisplay();
      }
    } else if (this.inputObj.callingType === 'ozonetel') {
      if (!this.diallerController) {
        this.diallerController = new OzonetelController(this.callingService, this.ozonetelSDKCore);
      }
      this.ensureOzonetelSDKInitialized();
      this.subscribeToOzonetelEvents();
      if (!fromSelfSync) {
        this.reconcileStaleCallDisplay();
      }
    } else if (this.inputObj.callingType === 'centro') {
      if (!this.diallerController) {
        this.diallerController = new CentroController(this.callingService);
      }
      this.initCentroAgentStatus();
    }

    if (!fromSelfSync && this.isOnCall) {
      this.fetchCallData();
    }
  }

  ngOnDestroy() {
    if (this.ignosisPresenceTimer) {
      clearInterval(this.ignosisPresenceTimer);
      this.ignosisPresenceTimer = null;
    }
    this.ignosisTransfer.reportDialerBusy(false);
    if (this.cubeReconcileTimer) {
      clearTimeout(this.cubeReconcileTimer);
      this.cubeReconcileTimer = null;
    }
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.timer().stop();
    this.stopWrapUpElapsedTimer();
    this.stopManualDialConnectWatch();
    if (this.inputObj?.callingType === 'centro') {
      this.centroReady = false;
      this.centroBrowserSipReady = false;
      this.centroSip.teardown();
      this.centroControlWs.disconnect();
    }
  }

  get wrapUpElapsedDisplay(): string {
    const mins = Math.floor(this.wrapUpElapsedSeconds / 60);
    const secs = this.wrapUpElapsedSeconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  }

  /**
   * True when disposition panel should render (calling.component.html).
   * Requires SDK Ozonetel dialer, wrap-up entered, and post-call Disconnected status.
   */
  get showOzonetelDispositionPanel(): boolean {
    return (
      this.isSdkDialer &&
      this.inputObj?.callingType === 'ozonetel' &&
      this.ozonetelWrapUpActive &&
      this.inputObj?.Status === 'Disconnected'
    );
  }

  /** True when wrap-up active and Status Disconnected — shows disposition dropdown. */
  get showCubeDispositionPanel(): boolean {
    return (
      this.isCubeWebphone &&
      this.inputObj?.callingType === 'cube' &&
      (this.cubeWrapUpActive || this.cubeConnector.isWrapUpPending()) &&
      this.inputObj?.Status === 'Disconnected'
    );
  }

  get showCentroDispositionPanel(): boolean {
    // Wrap-up panel only when disposition is pending and SIP is not live again.
    return (
      this.isCentroDialer &&
      this.centroWrapUpActive &&
      !this.centroSip.isInCall() &&
      !this.centroSip.isRinging() &&
      !this.centroSipRinging &&
      (this.inputObj?.Status === 'Disconnected' || this.inputObj?.Status === 'CONNECTED')
    );
  }

  /** Cube on-call: iframe live, awaiting answer, or widget CALLING/CONNECTED with active leg. */
  get isOnCall(): boolean {
    if (this.inputObj?.callingType === 'centro') {
      // Live SIP is always on-call UI, even if wrap-up flag was left stuck from previous call.
      if (this.centroSip.isInCall() || this.centroSip.isRinging() || this.centroSipRinging) {
        return true;
      }
      if (this.centroWrapUpActive) {
        return false;
      }
      return ['CALLING', 'CONNECTED'].includes(this.inputObj?.Status);
    }
    if (this.inputObj?.callingType === 'cube') {
      if (this.cubeWrapUpActive || this.cubeConnector.isWrapUpPending()) {
        return false;
      }
      const status = this.inputObj?.Status;
      const sessionActive = this.cubeConnector.isCallSessionActive();
      if ((status === 'Idle' || status === 'Disconnected') && !sessionActive) {
        return false;
      }
      if (this.cubeConnector.isAwaitingAgentAnswer() && status !== 'CONNECTED' && this.cubeConnector.getCurrentStatus() !== 'on_call' && !this.cubeConnector.isAnswerInFlight()) {
        return false;
      }
      if (this.cubeConnector.isCallConnected() || this.cubeConnector.isCubeIframeAgentConnected()) {
        return sessionActive;
      }
      if (
        (status === 'CALLING' || status === 'CONNECTED') &&
        (sessionActive || this.cubeConnector.isCallLegActive() || !!this.inputObj?.phoneNo)
      ) {
        return true;
      }
      return false;
    }
    return ['CALLING', 'CONNECTED'].includes(this.inputObj?.Status);
  }

  get isCubeCampaignDialing(): boolean {
    return false;
  }

  /** Agent leg ringing before customer connect or answer (shows Answer / Reject). */
  get isCubeAgentRinging(): boolean {
    if (!this.isCubeWebphone) {
      return false;
    }
    if (this.cubeWrapUpActive || this.cubeConnector.isWrapUpPending()) {
      return false;
    }
    if (this.inputObj?.Status === 'Disconnected' || this.inputObj?.Status === 'Idle') {
      return false;
    }
    if (this.inputObj?.Status === 'CONNECTED' || this.cubeConnector.isCallConnected()) {
      return false;
    }
    if (this.cubeConnector.isCubeIframeAgentConnected() && this.inputObj?.Status !== 'CALLING') {
      return false;
    }
    if (this.isCubeAutoTransferRouting) {
      return false;
    }
    if (
      this.cubeConnector.getCurrentStatus() === 'failed' ||
      this.agentStatus === 'ERROR' ||
      this.agentStatus === 'DISCONNECTED' ||
      !this.cubeConnector.isAgentLoggedIn()
    ) {
      return false;
    }
    if (this.cubeConnector.isAnswerInFlight()) {
      return false;
    }
    if (
      this.cubeConnector.isAwaitingAgentAnswer() &&
      this.cubeConnector.getCurrentStatus() !== 'on_call' &&
      !this.cubeConnector.isCallConnected()
    ) {
      const phone = String(this.inputObj?.phoneNo || '').replace(/\D/g, '').slice(-10);
      const status = this.inputObj?.Status;
      if (
        status === 'Idle' ||
        status === 'Disconnected' ||
        status === 'CONNECTED' ||
        (phone.length < 10 && status !== 'CALLING' && status !== 'CONNECTED')
      ) {
        return false;
      }
      return true;
    }
    return false;
  }

  get isCubeAutoTransferRouting(): boolean {
    return this.isCubeWebphone && this.cubeAutoTransferRouting;
  }

  get isCubeConnecting(): boolean {
    return this.isCubeWebphone && this.cubeConnector.isAnswerInFlight();
  }

  get showCubeCallPanel(): boolean {
    return this.isOnCall || this.isCubeAgentRinging || this.isCubeConnecting || this.isCubeAutoTransferRouting;
  }

  get showCentroCallPanel(): boolean {
    if (!this.isCentroDialer) {
      return false;
    }
    if (this.showCentroDispositionPanel) {
      return false;
    }
    return this.isOnCall || this.centroSipRinging || this.centroSip.isInCall() || this.centroSip.isRinging();
  }

  get showCubeCallDetailsCard(): boolean {
    if (!this.isOnCall || this.cubeWrapUpActive) {
      return false;
    }
    return !!(
      this.inputObj?.dueId ||
      this.inputObj?.fullName ||
      this.inputObj?.phoneNo ||
      this.callData?.campaignName ||
      this.callData?.ucid
    );
  }

  get displayCallerName(): string {
    const name = String(
      this.inputObj?.fullName ||
      this.callerIdentityCache?.fullName ||
      ''
    ).trim();
    if (!name || /^unknown$/i.test(name)) {
      return this.inputObj?.phoneNo ? '' : 'Unknown';
    }
    return name;
  }

  get displayCallerLoanId(): string {
    return String(this.inputObj?.dueId || this.callerIdentityCache?.dueId || '').trim();
  }

  get isCubeTransferMergeEnabled(): boolean {
    return this.isCubeWebphone && this.isOnCall && this.cubeConnector.isCallConnected();
  }

  get isCubeConferenceMergeReady(): boolean {
    return this.cubeConferenceDialStarted || this.cubeConnector.isConferenceMergeReady();
  }

  get cubeConferenceBlockedReason(): string | null {
    if (!this.isCubeWebphone || !this.isCubeTransferMergeEnabled) {
      return null;
    }
    if (this.cubeConnector.isCallOnHold() || this.inputObj?.holdCall) {
      return 'The call is on hold — resume it before dialling a 3rd party.';
    }
    if (this.cubeConnector.isAgentOnBreak()) {
      return 'You are on break — end break before conference.';
    }
    return null;
  }

  // Auto-initialize SDK if credentials exist
  async autoInitializeSDK() {
    if (!this.ozonetelDialerFlow.isSdkMode()) {
      return;
    }

    console.log('[CallingWidget] Auto-initialize check...');

    // Check if agent is already initialized
    if (this.ozonetelSDKCore.isAgentInitialized()) {
      const state = this.ozonetelSDKCore.getAgentState();
      this.agentStatus = state.status;
      console.log('[CallingWidget] SDK already initialized, agent status:', this.agentStatus);
      return;
    }

    try {
      let ozonetelDetails: any = null;
      const dbConfig = await this.ozonetelSDKCore.getAgentConfigFromDB();
      if (dbConfig?.resultShort === 'success' && dbConfig.ozonetelDetails) {
        ozonetelDetails = dbConfig.ozonetelDetails;
        const remarks = localStorage.getItem('remarks');
        if (remarks) {
          try {
            const remarksObj = JSON.parse(remarks);
            remarksObj.ozonetelDetails = ozonetelDetails;
            localStorage.setItem('remarks', JSON.stringify(remarksObj));
          } catch (_e) { }
        }
      } else {
        const remarks = localStorage.getItem('remarks');
        if (remarks) {
          const remarksObj = JSON.parse(remarks);
          ozonetelDetails = remarksObj?.ozonetelDetails;
        }
      }

      if (!ozonetelDetails || !ozonetelDetails.agentId) {
        console.log('[CallingWidget] No Ozonetel details found in DB/localStorage');
        this.agentStatus = 'DISCONNECTED';
        return;
      }

      const customer = ozonetelDetails.customer || ozonetelDetails.userName;
      const agentId = ozonetelDetails.agentId;
      const password = ozonetelDetails.password || ozonetelDetails.pin;
      const phoneNumber = ozonetelDetails.phoneNumber || '';
      const userName = ozonetelDetails.userName;

      if (!customer || !agentId || !password) {
        console.log('[CallingWidget] Incomplete credentials');
        this.agentStatus = 'DISCONNECTED';
        return;
      }

      console.log('[CallingWidget] Credentials found, auto-initializing SDK...', {
        customer,
        agentId,
        userName
      });

      this.loader = true;
      this.agentStatus = 'CONNECTING...';

      // usId/agentUniqId enable MDL hold/mute when server login returns "already logged in"
      const config = {
        customer,
        agentId,
        password,
        phoneNumber,
        userName,
        sip: ozonetelDetails.sip !== false,
        usId: ozonetelDetails.usId || ozonetelDetails.usid,
        agentUniqId:
          ozonetelDetails.agentUniqId != null
            ? Number(ozonetelDetails.agentUniqId)
            : ozonetelDetails.agentuniqId != null
              ? Number(ozonetelDetails.agentuniqId)
              : undefined,
      };

      await this.ozonetelSDKCore.initializeAgent(config);

      const state = this.ozonetelSDKCore.getAgentState();
      this.agentStatus = state.status;
      this.loader = false;

      console.log('[CallingWidget] SDK auto-initialized successfully, status:', this.agentStatus);

      void this.refreshTransferAgents();

      // Subscribe to SDK events after initialization
      this.subscribeToOzonetelEvents();
      void this.recoverStaleOzonetelWrapUpState();
      this.reconcileStaleCallDisplay();

      try {
        const ready = await this.ozonetelSDKCore.setAgentInboundReady();
        if (ready) {
          this.agentStatus = 'IDLE';
          console.log('[CallingWidget] Agent INBOUND/IDLE — ready for inbound calls');
        } else {
          console.warn('[CallingWidget] Failed to set agent INBOUND ready');
        }
      } catch (error: any) {
        console.error('[CallingWidget] Error setting inbound ready:', error.message || error);
      }
    } catch (error: any) {
      console.error('[CallingWidget] Auto-initialization failed:', error);
      this.agentStatus = 'ERROR';
      this.loader = false;
      this.showErr(error.message || 'SDK initialization failed', 'Error');
    }
  }

  private getResolvedDialerType() {
    let remarks = null;
    const remarksRaw = localStorage.getItem('remarks');
    if (remarksRaw) {
      try {
        remarks = JSON.parse(remarksRaw);
      } catch (_e) { }
    }
    return resolveCallingDialerType(localStorage.getItem('callingService'), remarks);
  }

  private defaultWidgetCallingType(): string {
    if (isOzonetelDialerEnabled()) {
      return 'ozonetel';
    }
    if (isCubeDialerAllowed()) {
      return 'cube';
    }
    return 'ozonetel';
  }

  private reportIgnosisPresence() {
    const busy = this.isOnCall || this.isCubeAgentRinging || this.isCubeConnecting || this.centroSip.isInCall() || this.centroSip.isRinging() || this.centroSipRinging;
    this.ignosisTransfer.reportDialerBusy(busy);
  }

  private syncDialerTypeFromSession() {
    const dialerType = this.getResolvedDialerType();
    this.isCubeDialer = dialerType === 'cube';
    this.isCubeWebphone = dialerType === 'cube' && isCubeWebphoneConnector();
    this.isSdkDialer = dialerType === 'ozonetel' && isOzonetelSdkDialer();
    if (this.inputObj && dialerType !== 'none') {
      this.inputObj.callingType = toWidgetCallingType(dialerType);
    }
  }

  /** Boots Cube webphone UI or legacy flow agent status refresh. */
  private initCubeAgentStatus() {
    if (this.inputObj?.callingType !== 'cube') {
      return;
    }
    if (this.isCubeWebphone) {
      this.initCubeWebphoneUi();
      return;
    }
    this.agentStatus = 'CONNECTING...';
    this.cubeDialerFlow.refreshAgentStatus().subscribe(
      (status) => {
        this.agentStatus = status;
      },
      () => {
        this.agentStatus = 'IDLE';
      }
    );
  }

  private initCentroAgentStatus() {
    if (this.inputObj?.callingType !== 'centro' || !this.diallerController || this.centroBootstrapStarted) {
      return;
    }
    this.centroBootstrapStarted = true;
    this.agentStatus = 'CONNECTING...';
    this.centroStatusDetail = 'Connecting to Centro...';
    this.centroRequiresFreeAgent = false;
    const ctrl = this.diallerController as CentroController;
    const startCentroFlow = (loginRes: any) => {
      ctrl.activate({ browserControlWs: true }).subscribe({
        next: (res: any) => this.finishCentroBootstrap(ctrl, res, loginRes),
        error: (err: any) => this.handleCentroConnectError(err),
      });
    };

    ctrl.getAgentStatus().subscribe({
      next: (statusRes: any) => {
        this.applyCentroServerStatus(statusRes);
        this.runCentroLogin(ctrl, startCentroFlow);
      },
      error: () => this.runCentroLogin(ctrl, startCentroFlow),
    });
  }

  private runCentroLogin(ctrl: CentroController, startCentroFlow: (loginRes: any) => void): void {
    ctrl.login().subscribe({
      next: (loginRes: any) => {
        if (loginRes?.resultShort !== 'success') {
          this.handleCentroConnectError(null, loginRes);
          return;
        }
        startCentroFlow(loginRes);
      },
      error: (err: any) => this.handleCentroConnectError(err),
    });
  }

  private applyCentroServerStatus(statusRes?: any): void {
    if (!statusRes || this.inputObj?.callingType !== 'centro') return;
    if (statusRes.statusDetail) {
      this.centroStatusDetail = String(statusRes.statusDetail);
    }
    const status = String(statusRes.agentStatus || '').toUpperCase();
    if (status === 'DISCONNECTED') {
      this.agentStatus = 'DISCONNECTED';
      this.centroReady = false;
      return;
    }
    if (status === 'PAUSED') {
      this.agentStatus = 'PAUSED';
      this.inputObj.pauseCall = true;
      return;
    }
    if (status === 'RINGING') {
      this.agentStatus = 'RINGING';
      this.inputObj.Status = 'CALLING';
      this.centroOutboundActive = true;
    } else if (status === 'BUSY' || statusRes.isOnCall) {
      this.agentStatus = 'ONCALL';
      this.inputObj.Status = 'CONNECTED';
      this.centroOutboundActive = true;
    }
    const phone = String(statusRes.currentPhone || statusRes.phoneNo || '').replace(/\D/g, '').slice(-10);
    if (phone.length >= 10) {
      this.inputObj.phoneNo = phone;
    }
    if (statusRes.recordId && !this.inputObj.recordId) {
      this.inputObj.recordId = statusRes.recordId;
    }
    if (status === 'IDLE' && statusRes.sessionActive && !this.centroReady) {
      this.agentStatus = 'CONNECTING...';
    }
  }

  private handleCentroConnectError(err: any, loginRes?: any) {
    this.agentStatus = 'ERROR';
    this.centroBootstrapStarted = false;
    this.centroReady = false;
    this.centroBrowserSipReady = false;
    const body = err?.error || loginRes || {};
    if (body.centroHttpBase) {
      this.centroStatusDetail = `${body.resultLong || 'Centro connect failed'} (${body.centroHttpProtocol || 'HTTP'} ${body.centroHttpBase})`;
      console.warn('[Centro] connect failed', {
        centroHttpBase: body.centroHttpBase,
        centroHttpProtocol: body.centroHttpProtocol,
        resultLong: body.resultLong,
        centroCode: body.centroCode || body.centroMsg
      });
    } else {
      this.centroStatusDetail = body.resultLong || err?.message || 'Centro connect failed';
    }
    if (body.requiresFreeAgent || body.centroCode === 'already') {
      this.centroRequiresFreeAgent = true;
      const data = body.centroData ?? body.data ?? null;
      const id = data?.id ?? data?.ID ?? data?.User_Status_ID;
      if (id != null && String(id) !== '') {
        this.centroPendingUserStatusId = String(id);
      }
    } else if (body.centroCode === 'clientid') {
      const host = body.centroHttpBase || 'unknown';
      this.showErr(`Centro client/extension mismatch on ${host} — verify CENTRO_UAT_BASE_URL in server env and restart backend.`, 'Error');
      this.cdr.markForCheck();
      return;
    }
    const msg = body.resultLong || err?.message || 'Centro connect failed';
    this.showErr(msg, 'Error');
    this.cdr.markForCheck();
  }

  private async connectCentroBrowserSip(loginRes?: any): Promise<void> {
    let sipUsername = String(loginRes?.sipUsername || loginRes?.extension || '').trim();
    let sipPassword = String(loginRes?.sipPassword || loginRes?.crmPassword || '').trim();
    let sipDomain = String(loginRes?.sipConnection?.sipDomain || loginRes?.sipDomain || '').trim();
    let wsUrl = String(
      loginRes?.sipConnection?.vpnWsUrl ||
      loginRes?.sipConnection?.sipUaWsUrl ||
      ''
    ).trim();
    const iceServers = Array.isArray(loginRes?.sipConnection?.iceServers)
      ? loginRes.sipConnection.iceServers
      : [];

    if (!wsUrl || !sipDomain || !sipUsername || !sipPassword) {
      const cfg: any = await firstValueFrom(this.callingService.getCentroAgentConfig());
      sipDomain = sipDomain || cfg?.sipConnection?.sipDomain || cfg?.centroDetails?.sipDomain || '';
      wsUrl = wsUrl || cfg?.sipConnection?.vpnWsUrl || cfg?.sipConnection?.sipUaWsUrl || '';
      sipUsername = sipUsername || cfg?.centroDetails?.sipUsername || cfg?.centroDetails?.extension || '';
      sipPassword = sipPassword || cfg?.centroDetails?.sipPassword || '';
    }
    if (!wsUrl || !sipDomain || !sipUsername || !sipPassword) {
      throw new Error('Centro SIP config incomplete');
    }
    console.log('[CentroSIP] using sister server', { sipDomain, wsUrl });
    await this.centroSip.connect({ sipUsername, sipPassword, sipDomain, sipUaWsUrl: wsUrl, iceServers });
    this.centroBrowserSipReady = this.centroSip.isRegistered();
    if (!this.centroBrowserSipReady) {
      throw new Error('SIP registration failed');
    }
    console.log('[CentroSIP] connected via', wsUrl);
  }

  private unbindCentroLiveHandlers(): void {
    this.centroControlLineSub?.unsubscribe();
    this.centroControlLineSub = undefined;
    this.centroLiveSubs.forEach((sub) => sub.unsubscribe());
    this.centroLiveSubs = [];
  }

  private bindCentroLiveHandler(sub: Subscription): void {
    this.centroLiveSubs.push(sub);
    this.subscriptions.push(sub);
  }

  private async connectCentroBrowserControlWs(ctrl: CentroController, activateRes?: any, loginRes?: any): Promise<void> {
    let controlWsUrl = String(loginRes?.sipConnection?.controlWsUrl || activateRes?.sipConnection?.controlWsUrl || '').trim();
    let agentId = String(loginRes?.agentId || activateRes?.agentId || '').trim();
    let extension = String(loginRes?.extension || loginRes?.sipUsername || activateRes?.extension || '').trim();
    if (!controlWsUrl || !agentId || !extension) {
      const cfg: any = await firstValueFrom(this.callingService.getCentroAgentConfig());
      controlWsUrl = controlWsUrl || cfg?.sipConnection?.controlWsUrl || '';
      agentId = agentId || cfg?.centroDetails?.agentId || '';
      extension = extension || cfg?.centroDetails?.extension || cfg?.centroDetails?.sipUsername || '';
    }
    if (!controlWsUrl || !agentId || !extension) {
      throw new Error('Centro control WS config incomplete');
    }
    this.centroControlLineSub?.unsubscribe();
    const template = activateRes?.controlPayloadTemplate || null;
    await this.centroControlWs.connect(controlWsUrl, agentId, extension, {
      template: template || undefined,
      controlStatus: async (inCall, ringing) => {
        const res: any = await firstValueFrom(
          this.callingService.getCentroControlStatus(inCall, ringing)
        );
        return res?.payload || null;
      },
      sipSync: async (inCall, ringing, refresh) => {
        const res: any = await firstValueFrom(
          this.callingService.postCentroSipSync(inCall, ringing, !!refresh)
        );
        return {
          payload: res?.payload || null,
          lineStatus: res?.lineStatus || '',
          remoteEnded: res?.remoteEnded === true
        };
      },
      lineEvent: async (event) => {
        await firstValueFrom(this.callingService.postCentroLineEvent(event));
      }
    });
    this.centroControlLineSub = this.centroControlWs.lineState$.subscribe((state) => this.handleCentroRemoteLineState(state));
    this.subscriptions.push(this.centroControlLineSub);
  }

  private handleCentroRemoteLineState(state: string): void {
    const st = String(state || '').toUpperCase();
    if (!['HANGUP', 'HUNGUP', 'DISCONNECTED'].includes(st)) {
      return;
    }
    if (this.centroSip.isRinging() || this.centroSipRinging) {
      return;
    }
    if (!this.centroSip.isInCall()) {
      return;
    }
    if (this.centroWrapUpActive || this.inputObj?.callingType !== 'centro') {
      return;
    }
    const uiOnCall = ['CALLING', 'CONNECTED'].includes(String(this.inputObj?.Status || ''));
    if (!uiOnCall && !this.centroOutboundActive) {
      return;
    }
    this.centroRemoteHangup = true;
    void this.handleCentroSipLegEnded(true, this.centroLiveLegEpoch);
  }

  private refreshCentroSipStatus(ctrl: CentroController, onReady?: () => void) {
    ctrl.getSipStatus(
      this.centroSip.isRegistered(),
      this.centroSip.isInCall(),
      this.centroSip.isRinging()
    ).subscribe({
      next: (res: any) => {
        this.centroBrowserSipReady = !!res?.browserSipRegistered;
        if (res?.sessionActive === false) {
          this.agentStatus = 'DISCONNECTED';
          this.centroReady = false;
          this.centroStatusDetail = 'Centro HTTP session ended';
        } else if (!res?.readyForDial) {
          this.centroReady = false;
          if (!['ERROR', 'CONNECTING...', 'BUSY', 'ONCALL', 'RINGING', 'PAUSED'].includes(this.agentStatus)) {
            this.agentStatus = 'NOT_READY';
          }
          this.centroStatusDetail = res?.browserSipRegistered
            ? 'Centro session not ready for dial'
            : 'Browser SIP not registered';
        } else {
          this.centroReady = true;
          this.centroStatusDetail = 'Ready';
          if (!['BUSY', 'ONCALL', 'RINGING', 'PAUSED', 'ERROR'].includes(this.agentStatus)) {
            this.agentStatus = 'IDLE';
          }
          onReady?.();
        }
        this.cdr.markForCheck();
      },
      error: () => {
        this.cdr.markForCheck();
      },
    });
  }

  private finishCentroBootstrap(ctrl: CentroController, activateRes?: any, loginRes?: any) {
    this.unbindCentroLiveHandlers();
    this.centroRequiresFreeAgent = false;
    this.centroPendingUserStatusId = '';
    this.agentStatus = 'CONNECTING...';
    if (activateRes?.controlWsReady === false) {
      console.warn('[Centro] HTTP session ready; control websocket pending');
    }
    this.connectCentroBrowserSip(loginRes)
      .then(() => firstValueFrom(ctrl.getSipStatus(
        this.centroSip.isRegistered(),
        this.centroSip.isInCall(),
        this.centroSip.isRinging()
      )))
      .then(() => this.connectCentroBrowserControlWs(ctrl, activateRes, loginRes))
      .then(() => {
        this.centroControlWs.setSipState(false, false);
        this.centroReady = true;
        this.centroBrowserSipReady = true;
        this.agentStatus = 'IDLE';
        this.inputObj.Status = 'Idle';
        this.centroStatusDetail = 'Ready';
        this.bindCentroLiveHandler(
          this.centroSip.isRinging$.subscribe((ringing) => {
            this.centroSipRinging = ringing;
            this.centroControlWs.setSipState(this.centroSip.isInCall(), ringing);
            if (ringing) {
              this.beginCentroLiveCallUi('CALLING');
            }
            this.cdr.markForCheck();
          })
        );
        this.bindCentroLiveHandler(
          this.centroSip.isInCall$.subscribe((inCall) => {
            this.centroControlWs.setSipState(inCall, this.centroSip.isRinging());
            if (inCall) {
              this.clearCentroSipEndTimer();
              this.beginCentroLiveCallUi('CONNECTED');
              void this.refreshCentroCallDisplay().then(() => {
                this.syncCentroCaseFromCall();
                void this.queueCentroAutoTransfer();
              });
              this.cdr.markForCheck();
              return;
            }
            if (this.inputObj?.callingType !== 'centro') {
              this.cdr.markForCheck();
              return;
            }
            if (this.centroWrapUpActive && this.centroUiState.getPhase() === 'wrapup') {
              this.cdr.markForCheck();
              return;
            }
            if (!this.centroUiState.shouldHandleSipEnd(this.centroLiveLegEpoch)) {
              this.cdr.markForCheck();
              return;
            }
            if (this.centroSip.hasActiveSession() || this.centroSip.isRinging()) {
              this.cdr.markForCheck();
              return;
            }
            this.centroAgentLegLive = false;
            this.clearCentroSipEndTimer();
            this.centroSipEndTimer = setTimeout(() => {
              this.centroSipEndTimer = null;
              void this.handleCentroSipLegEnded(false, this.centroLiveLegEpoch);
            }, 1500);
            this.cdr.markForCheck();
          })
        );
        this.bindCentroLiveHandler(
          this.centroSip.isMuted$.subscribe((muted) => {
            this.isMuted = muted;
            this.cdr.markForCheck();
          })
        );
        this.bindCentroLiveHandler(
          this.centroSip.onCallEnded$.subscribe(() => {
            if (this.centroWrapUpActive || this.inputObj?.callingType !== 'centro') {
              return;
            }
            if (!this.centroUiState.shouldHandleSipEnd(this.centroLiveLegEpoch)) {
              return;
            }
            if (!['CALLING', 'CONNECTED'].includes(String(this.inputObj?.Status || '')) && !this.centroOutboundActive) {
              return;
            }
            this.centroAgentLegLive = false;
            this.clearCentroSipEndTimer();
            this.centroSipEndTimer = setTimeout(() => {
              this.centroSipEndTimer = null;
              void this.handleCentroSipLegEnded(false, this.centroLiveLegEpoch);
            }, 500);
          })
        );
        this.bindCentroLiveHandler(
          this.centroSip.isHeld$.subscribe((held) => {
            if (this.inputObj) {
              this.inputObj.holdCall = held;
            }
            this.cdr.markForCheck();
          })
        );
        this.refreshCentroSipStatus(ctrl, () => this.applyCentroDefaultAutoMode(ctrl));
      })
      .catch((err: any) => {
        console.warn('[Centro] browser SIP registration failed', err);
        this.centroReady = false;
        this.centroBrowserSipReady = false;
        this.agentStatus = 'NOT_READY';
        this.inputObj.Status = 'Idle';
        this.centroStatusDetail = 'Browser SIP not registered';
        this.showErr(
          'Browser SIP not registered — close any external softphone on this extension, then relogin.',
          'Error'
        );
        this.refreshCentroSipStatus(ctrl);
      });
  }

  private applyCentroDefaultAutoMode(ctrl: CentroController): void {
    if (this.inputObj?.isToggled === true) return;
    ctrl.toggleStartMode().subscribe(
      (res: any) => {
        if (res?.resultShort !== 'failure') {
          this.inputObj.isToggled = true;
        }
        this.saveDiallingObj();
        this.cdr.markForCheck();
      },
      () => {}
    );
  }

  get isCentroDialer(): boolean {
    return this.inputObj?.callingType === 'centro';
  }

  get centroAutoMode(): boolean {
    return this.inputObj?.isToggled === true;
  }

  toggleCentroAutoMode(): void {
    if (this.centroWrapUpActive) {
      this.showErr('Complete call disposition before changing auto mode', 'Error');
      return;
    }
    if (this.isOnCall || this.agentStatus === 'BUSY' || this.agentStatus === 'ONCALL') {
      this.showErr('Cannot change mode while on a call', 'Error');
      return;
    }
    if (!this.centroReady || !this.diallerController) {
      this.showErr('Centro agent is not ready yet', 'Error');
      return;
    }
    if (this.centroAutoMode) {
      this.toggleStopMode();
      return;
    }
    this.showCentroManualDial = false;
    this.dialpadNumber = '';
    this.toggleStartMode();
  }

  /** Maps connector status$ to widget agentStatus; guards wrap-up UI from premature clear. */
  private applyCubeConnectorUiStatus(status: CubeConnectorUiStatus): void {
    const incomingStatus = status;
    if (
      this.cubeConnector.isAgentLoggedIn() &&
      (status === 'logging_in' || status === 'loading_webphone' || status === 'initializing')
    ) {
      status = 'ready';
    }
    switch (status) {
      case 'ready':
        if (
          this.cubeConnector.isCallSessionActive() ||
          this.cubeConnector.isAwaitingAgentAnswer() ||
          this.cubeConnector.getCurrentStatus() === 'on_call' ||
          this.inputObj?.Status === 'CONNECTED' ||
          this.inputObj?.Status === 'CALLING'
        ) {
          break;
        }
        if (!this.cubeConnector.isCubeSessionReady()) {
          if (this.cubeConnector.isAgentOnBreak()) {
            this.agentStatus = 'PAUSED';
            this.inputObj.pauseCall = true;
            if (this.inputObj?.Status !== 'CALLING' && this.inputObj?.Status !== 'CONNECTED') {
              this.inputObj.Status = 'Break';
            }
          } else if (this.cubeConnector.isAgentLoggedIn()) {
            this.agentStatus = 'IDLE';
          } else {
            this.agentStatus = 'CONNECTING...';
          }
          break;
        }
        if (this.cubeConnector.isAgentOnBreak()) {
          this.agentStatus = 'PAUSED';
          this.inputObj.pauseCall = true;
          if (this.inputObj?.Status !== 'CALLING' && this.inputObj?.Status !== 'CONNECTED') {
            this.inputObj.Status = 'Break';
          }
          break;
        }
        this.agentStatus = 'IDLE';
        const wrapUpDisplayActive =
          this.cubeWrapUpActive || this.cubeConnector.isWrapUpPending();
        if (
          this.inputObj?.Status === 'CONNECTED' ||
          this.inputObj?.Status === 'CALLING' ||
          this.inputObj?.phoneNo ||
          this.inputObj?.fullName
        ) {
          if (!this.cubeConnector.isCallSessionActive() && !wrapUpDisplayActive) {
            // CUBE_DEBUG
            this.cubeLog('applyCubeConnectorUiStatus', {
              branch: 'ready_clear_ui',
              incomingStatus,
              cubeWrapUpActive: this.cubeWrapUpActive,
              inputStatus: this.inputObj?.Status,
            });
            this.logCubeStateSnapshot('applyCubeConnectorUiStatus_ready_clear');
            this.cancelCubeAutoTransferRouting('connector-ready');
            this.clearCubeCallUiOnly('connector-ready');
            break;
          }
        }
        if (
          !wrapUpDisplayActive &&
          !this.isOnCall &&
          this.inputObj?.Status !== 'Break' &&
          this.inputObj?.Status !== 'Disconnected' &&
          !this.cubeConnector.isCallConnected() &&
          !this.cubeConnector.isAnswerInFlight() &&
          !this.cubeConnector.isAgentOnBreak()
        ) {
          this.inputObj.Status = 'Idle';
        }
        if (!this.cubeConnector.isAgentOnBreak()) {
          this.inputObj.isToggled = false;
          this.inputObj.pauseCall = false;
        }
        this.scheduleReconcileStaleCubeCallDisplay();
        break;
      case 'on_call': {
        const callStatus = this.cubeConnector.callState$.getValue()?.Status;
        this.expandWidgetUi();
        if (
          callStatus === 'CONNECTED' ||
          this.cubeConnector.isCallConnected() ||
          this.cubeConnector.isCubeIframeAgentConnected() ||
          this.cubeConnector.isAnswerInFlight()
        ) {
          this.cubeConnector.resolveAwaitingForConnectedState();
          this.agentStatus = 'BUSY';
          if (this.inputObj?.Status !== 'Break') {
            this.inputObj.Status = 'CONNECTED';
          }
          if (!isCubeAutoTransferDummySession()) {
            void this.syncCubeCaseFromEvent(
              {
                ...this.inputObj,
                Status: 'CONNECTED',
                customerAnswered: this.inputObj?.customerAnswered ?? true,
              },
              'CONNECTED'
            );
          }
          break;
        }
        if (
          this.cubeConnector.isAwaitingAgentAnswer() &&
          callStatus !== 'CONNECTED' &&
          !this.cubeConnector.isCallConnected() &&
          !this.cubeConnector.isAnswerInFlight()
        ) {
          this.agentStatus = 'RINGING';
          if (this.inputObj?.Status !== 'Break') {
            this.inputObj.Status = 'CALLING';
          }
          break;
        }
        if (callStatus === 'CALLING') {
          this.agentStatus = 'RINGING';
          if (this.inputObj?.Status !== 'Break') {
            this.inputObj.Status = 'CALLING';
          }
        } else {
          this.agentStatus = 'BUSY';
          if (this.inputObj?.Status !== 'Break' && this.inputObj?.Status !== 'CALLING') {
            this.inputObj.Status = 'CONNECTED';
          }
        }
        break;
      }
      case 'on_break':
        this.agentStatus = 'PAUSED';
        this.inputObj.pauseCall = true;
        this.inputObj.isToggled = false;
        this.inputObj.Status = 'Break';
        break;
      case 'failed':
        this.agentStatus = 'ERROR';
        break;
      case 'logged_out':
        this.agentStatus = 'DISCONNECTED';
        break;
      case 'logging_in':
      case 'loading_webphone':
        this.agentStatus = 'CONNECTING...';
        break;
      default:
        if (!cubeConnectorStatusIsLoggedIn(status)) {
          this.agentStatus = 'CONNECTING...';
        }
        break;
    }
    // CUBE_DEBUG
    this.cubeLog('applyCubeConnectorUiStatus', { incomingStatus, resolvedStatus: status, agentStatus: this.agentStatus });
    this.logCubeStateSnapshot('applyCubeConnectorUiStatus');
    this.cdr.markForCheck();
  }

  /** Subscribes to connector streams and boots Cube webphone + login flow. */
  private initCubeWebphoneUi() {
    this.cubeConnector.requestLoginStatePing();
    this.applyCubeConnectorUiStatus(this.cubeConnector.getCurrentStatus());
    this.syncCubeCallState(this.cubeConnector.callState$.getValue());
    this.scheduleReconcileStaleCubeCallDisplay();
    if (this.cubeWebphoneEventsStarted) {
      return;
    }
    this.cubeWebphoneEventsStarted = true;
    this.subscriptions.push(
      this.cubeConnector.status$.subscribe((status) => {
        this.applyCubeConnectorUiStatus(status);
      }),
      this.cubeConnector.loginFailed$.subscribe((data) => {
        const msg = String(
          typeof data === 'string'
            ? data
            : (data as { reason?: string })?.reason || this.cubeLoginErrorMessage
        );
        if (
          /agentstatus|no response from server/i.test(msg) &&
          (this.cubeConnector.isAgentLoggedIn() || this.cubeConnector.isCubeSessionReady())
        ) {
          this.cubeConnector.requestLoginStatePing();
          return;
        }
        this.agentStatus = 'ERROR';
        if (this.isOnCall || this.inputObj?.Status === 'CONNECTED' || this.inputObj?.Status === 'CALLING') {
          this.onCubeCallEnded({ reason: 'login_failed' });
        }
        this.showErr(msg, 'Error');
        this.cdr.markForCheck();
      }),
      this.cubeConnector.loginState$.subscribe((loggedIn) => {
        // CUBE_DEBUG
        this.cubeLog('loginState$', {
          loggedIn,
          isAgentLoggedIn: this.cubeConnector.isAgentLoggedIn(),
          connectorStatus: this.cubeConnector.getCurrentStatus(),
        });
        if (loggedIn && this.cubeConnector.isAgentLoggedIn()) {
          if (
            this.cubeConnector.isCallSessionActive() ||
            this.cubeConnector.isAwaitingAgentAnswer() ||
            this.cubeConnector.getCurrentStatus() === 'on_call' ||
            this.inputObj?.Status === 'CONNECTED' ||
            this.inputObj?.Status === 'CALLING'
          ) {
            this.cdr.markForCheck();
            return;
          }
          if (this.cubeConnector.isAgentOnBreak()) {
            this.applyCubeConnectorUiStatus('on_break');
          } else {
            this.applyCubeConnectorUiStatus('ready');
          }
        } else if (!loggedIn && !this.cubeConnector.isAgentLoggedIn()) {
          if (
            (this.inputObj?.Status === 'CONNECTED' || this.inputObj?.Status === 'CALLING') &&
            !this.cubeConnector.isCubeIframeAgentConnected() &&
            !this.cubeConnector.isCallSessionActive()
          ) {
            this.onCubeCallEnded({ reason: 'auth_lost' });
          }
          this.agentStatus =
            this.cubeConnector.isLoginInFlight() ||
            this.cubeConnector.getCurrentStatus() === 'logging_in' ||
            this.cubeConnector.getCurrentStatus() === 'loading_webphone'
              ? 'CONNECTING...'
              : this.agentStatus === 'ERROR'
                ? 'ERROR'
                : 'DISCONNECTED';
        }
        this.logCubeStateSnapshot('loginState$');
        this.cdr.markForCheck();
      }),
      this.cubeConnector.callState$.subscribe((state) => {
        if (!state) {
          this.lastCubeSyncKey = '';
          return;
        }
        if (this.cubeCallLegResetInProgress) {
          return;
        }
        this.syncCubeCallState(state);
        this.scheduleReconcileStaleCubeCallDisplay();
      }),
      this.cubeConnector.callAnswered$.subscribe(() => {
        this.applyCubeConnectedWidget('callAnswered');
      }),
      this.cubeConnector.breakStarted$.subscribe(() => {
        this.agentStatus = 'PAUSED';
        this.inputObj.pauseCall = true;
        this.inputObj.isToggled = false;
        this.inputObj.Status = 'Break';
        this.inputObj.breakValue =
          this.cubeConnector.callState$.getValue()?.breakValue || this.inputObj.breakValue || 'On Break';
        this.cdr.markForCheck();
      }),
      this.cubeConnector.breakEnded$.subscribe(() => {
        if (this.cubeConnector.isAgentOnBreak()) {
          return;
        }
        if (!this.isOnCall && this.inputObj?.Status !== 'CONNECTED' && this.inputObj?.Status !== 'CALLING') {
          this.agentStatus = 'IDLE';
          this.inputObj.pauseCall = false;
          this.inputObj.Status = 'Idle';
          this.inputObj.breakValue = '';
        }
        this.cdr.markForCheck();
      }),
      this.cubeConnector.callEnded$.subscribe((payload) => {
        this.onCubeCallEnded(payload);
      }),
      this.cubeConnector.wrapUpStarted$.subscribe((payload) => {
        if (this.cubeWrapUpActive) {
          this.ensureCubeDispositionOptions();
          return;
        }
        void this.enterCubeWrapUp(payload);
      }),
      this.cubeConnector.campaignCustomerAnswered$.subscribe((payload) => {
        const state = this.cubeConnector.callState$.getValue();
        if (!state) {
          return;
        }
        if (this.isCubeCampaignAutoTransferCall(state)) {
          console.log('[CubeAutoTransfer] campaign customer answered — queue dummy → real');
          this.queueCubeAutoTransfer({ ...state, ...(payload as object) });
        }
        this.syncCubeCallState({
          ...state,
          ...(payload as object),
          customerAnswered: true,
          callDirection: state.callDirection || 'campaign',
        });
      }),
      this.cubeConnector.inboundCall$.subscribe((payload) => {
        const state = this.cubeConnector.callState$.getValue();
        this.syncCubeCallState({
          ...(state || { callingType: 'cube', Status: 'CALLING' }),
          ...(payload as object),
          callingType: 'cube',
        });
      }),
      this.cubeConnector.transferCompleted$.subscribe((payload) => {
        if (this.cubeDummyTransferReleased) {
          return;
        }
        if (!this.cubeConnector.isCubeTransferConfirmedForRelease(payload)) {
          return;
        }
        const targetCampaign =
          this.cubeAutoTransferPendingCampaign || this.cubeAutoTransferResolvedCampaign;
        const targetAgentId =
          this.cubeAutoTransferPendingTarget || this.cubeAutoTransferResolvedTarget;
        if (!targetCampaign || !targetAgentId) {
          return;
        }
        const state = this.cubeConnector.callState$.getValue();
        const callRef = this.resolveCubeAutoTransferCallRef(state || this.inputObj);
        if (!callRef) {
          return;
        }
        const transferKey = this.buildCubeAutoTransferKey(callRef, targetCampaign, targetAgentId);
        this.completeCubeAutoTransfer(transferKey, targetCampaign, targetAgentId);
      }),
      this.cubeConnector.error$.subscribe((msg) => {
        if (!this.isOnCall) {
          this.showErr(msg, 'Error');
        }
      })
    );
  }

  /** Promotes widget to CONNECTED when auto-answer completes (header, hold/mute, timeline). */
  private applyCubeConnectedWidget(source = 'sync'): void {
    if (!this.isCubeWebphone) {
      return;
    }
    if (!this.inputObj) {
      this.inputObj = { callingType: 'cube', Status: 'Idle' };
    }
    if (this.inputObj.callingType !== 'cube') {
      return;
    }
    const connectorState = this.cubeConnector.callState$.getValue();
    const live =
      this.inputObj.Status === 'CONNECTED' ||
      connectorState?.Status === 'CONNECTED' ||
      this.cubeConnector.isCallConnected() ||
      this.cubeConnector.isAnswerInFlight() ||
      this.cubeConnector.getCurrentStatus() === 'on_call' ||
      this.cubeConnector.isCubeIframeAgentConnected();
    if (!live) {
      return;
    }
    this.expandWidgetUi();
    const prevStatus = this.inputObj.Status;
    this.cubeConnector.resolveAwaitingForConnectedState();
    this.agentStatus = 'BUSY';
    const nextStatus = this.inputObj.Status === 'Break' ? 'Break' : 'CONNECTED';
    if (this.inputObj.Status !== 'Break') {
      this.inputObj.Status = 'CONNECTED';
    }
    this.inputObj.customerAnswered = true;
    if (connectorState) {
      const displayState = this.cubeDialerFlow.enrichCallDisplayData(
        this.withCallerIdentity({
          ...this.inputObj,
          ...connectorState,
          callingType: 'cube',
          Status: nextStatus,
          customerAnswered: true,
        })
      );
      this.applyCallerDisplayFields(this.inputObj, displayState);
      this.inputObj = {
        ...this.inputObj,
        ...connectorState,
        ...displayState,
        callingType: 'cube',
        Status: nextStatus,
        customerAnswered: true,
        phoneNo: displayState.phoneNo || connectorState.phoneNo || this.inputObj.phoneNo || '',
        phoneNumber:
          displayState.phoneNumber ||
          connectorState.phoneNumber ||
          displayState.phoneNo ||
          this.inputObj.phoneNumber ||
          '',
        fullName: displayState.fullName || connectorState.fullName || this.inputObj.fullName || '',
      };
    }
    this.incomeCallService.setCallingRes({
      ...this.inputObj,
      callingType: 'cube',
      Status: nextStatus === 'Break' ? 'Break' : 'CONNECTED',
    });
    if (prevStatus !== 'CONNECTED' && nextStatus === 'CONNECTED') {
      this.timer().start();
    }
    this.lastCubeSyncKey = '';
    this.mergeCubeCallContextFromSession();
    if (!isCubeAutoTransferDummySession()) {
      void this.syncCubeCaseFromEvent(this.inputObj, 'CONNECTED');
    }
    this.cdr.markForCheck();
  }

  private reconcileCubeWidgetCallState(state: CubeCallUiState): CubeCallUiState {
    const connectorStatus = this.cubeConnector.callState$.getValue()?.Status;
    const agentLegLive =
      state.Status === 'CONNECTED' ||
      connectorStatus === 'CONNECTED' ||
      this.cubeConnector.isCallConnected() ||
      this.cubeConnector.isAnswerInFlight() ||
      this.cubeConnector.getCurrentStatus() === 'on_call';
    if (!agentLegLive) {
      return state;
    }
    this.cubeConnector.resolveAwaitingForConnectedState();
    if (state.Status !== 'CONNECTED') {
      return {
        ...state,
        Status: 'CONNECTED',
        customerAnswered: state.customerAnswered ?? true,
      };
    }
    return state;
  }

  private mergeCubeCallContextFromSession(): void {
    if (!this.inputObj || this.inputObj.callingType !== 'cube') {
      return;
    }
    const callRes = this.incomeCallService.getCallingRes();
    if (!callRes || callRes.callingType !== 'cube') {
      return;
    }
    const sessionStatus = String(callRes.Status || '').toUpperCase();
    if (callRes.dueId && !this.inputObj.dueId) {
      this.inputObj.dueId = callRes.dueId;
      this.inputObj.DueId = callRes.dueId;
    }
    if (callRes.clientId && !this.inputObj.clientId) {
      this.inputObj.clientId = callRes.clientId;
    }
    if (callRes.fullName && !this.inputObj.fullName) {
      this.inputObj.fullName = callRes.fullName;
    }
    const sessionPhone = String(callRes.phoneNo || callRes.phoneNumber || '').replace(/\D/g, '').slice(-10);
    const currentPhone = String(this.inputObj.phoneNo || '').replace(/\D/g, '').slice(-10);
    if (sessionPhone.length >= 10) {
      if (!currentPhone || sessionPhone === currentPhone) {
        this.inputObj.phoneNo = sessionPhone;
        this.inputObj.phoneNumber = sessionPhone;
      }
    }
    if (!this.inputObj.callDirection && callRes.callDirection) {
      this.inputObj.callDirection = callRes.callDirection;
    }
    if (callRes.customerAnswered) {
      this.inputObj.customerAnswered = true;
    }
    if (sessionStatus === 'CONNECTED' || sessionStatus === 'CALLING') {
      if (this.inputObj.Status !== 'Break') {
        this.inputObj.Status = sessionStatus === 'CONNECTED' ? 'CONNECTED' : 'CALLING';
      }
      if (sessionStatus === 'CONNECTED') {
        this.agentStatus = 'BUSY';
      } else if (this.cubeConnector.isAwaitingAgentAnswer()) {
        this.agentStatus = 'RINGING';
      }
    }
  }

  /** Applies connector callState$ to widget inputObj; triggers auto-transfer queue on CALLING/CONNECTED. */
  private syncCubeCallState(state: CubeCallUiState | null): void {
    if (!state || this.inputObj?.callingType !== 'cube') {
      return;
    }
    this.mergeCubeCallContextFromSession();
    if (this.cubeCallLegResetInProgress) {
      return;
    }
    this.cubeLog('syncCubeCallState', {
      status: state.Status,
      phone: state.phoneNo || '',
      connector: this.cubeConnector.getCurrentStatus(),
      sessionActive: this.cubeConnector.isCallSessionActive(),
    });
    const prevStatus = this.inputObj?.Status;
    if (
      this.cubeConnector.isCallCleanupActive() &&
      (state.Status === 'CALLING' || state.Status === 'CONNECTED')
    ) {
      return;
    }
    if (
      this.cubeConnector.getCurrentStatus() === 'ready' &&
      !this.cubeConnector.isCallSessionActive() &&
      !this.cubeConnector.isCubeIframeAgentConnected() &&
      !this.cubeConnector.isAwaitingAgentAnswer() &&
      !this.cubeConnector.isCallLegActive() &&
      (state.Status === 'CONNECTED' || state.Status === 'CALLING') &&
      !state.phoneNo &&
      !this.inputObj?.phoneNo &&
      !this.isCubeCampaignAutoTransferCall(state)
    ) {
      this.cancelCubeAutoTransferRouting('sync-no-phone');
      state = {
        ...state,
        Status: 'Idle',
        holdCall: false,
        customerAnswered: false,
      };
    }
    if (state.Status === 'CALLING' || state.Status === 'CONNECTED') {
      if (this.cubeWrapUpActive || this.cubeConnector.isWrapUpPending()) {
        // Do not wipe the wrap-up dropdown if Cube still emits CONNECTED after hangup.
        this.cubeLog('syncCubeCallState', { skip: 'active_during_wrap', status: state.Status });
        this.ensureCubeDispositionOptions();
        return;
      }
      this.syncCubeActiveLeg(state);
    }
    if (
      this.cubeConnector.getCurrentStatus() === 'failed' ||
      !this.cubeConnector.isAgentLoggedIn()
    ) {
      if (
        (state.Status === 'CALLING' || state.Status === 'CONNECTED') &&
        !state.phoneNo &&
        !this.inputObj?.phoneNo
      ) {
        state = {
          ...state,
          Status: 'Idle',
          customerAnswered: false,
        };
      }
    }
    if (this.cubeConnector.isAwaitingAgentAnswer() && state.Status === 'CONNECTED') {
      this.cubeConnector.resolveAwaitingForConnectedState();
    }
    state = this.reconcileCubeWidgetCallState(state);
    if (state.Status === 'CALLING' && this.inputObj?.Status === 'CONNECTED') {
      return;
    }
    if (
      state.callDirection === 'campaign' &&
      state.Status === 'CALLING' &&
      !state.customerAnswered &&
      !this.cubeConnector.isAwaitingAgentAnswer() &&
      !this.cubeConnector.isCallLegActive() &&
      this.cubeConnector.getCurrentStatus() !== 'on_call' &&
      !this.cubeConnector.isAnswerInFlight() &&
      !state.phoneNo &&
      !this.inputObj?.phoneNo
    ) {
      return;
    }
    if (!state.phoneNo && (state.customerAnswered || this.cubeConnector.isAwaitingAgentAnswer() || state.Status === 'CONNECTED' || state.Status === 'CALLING')) {
      const fromLead = this.cubeConnector.getPendingLeadDisplayMeta(state.phoneNo);
      if (fromLead?.phoneNo || fromLead?.dueId || fromLead?.fullName) {
        state = { ...state, ...fromLead };
      }
      if (!state.phoneNo && this.inputObj?.phoneNo) {
        state = {
          ...state,
          phoneNo: this.inputObj.phoneNo,
          phoneNumber: this.inputObj.phoneNumber || this.inputObj.phoneNo,
          fullName: state.fullName || this.inputObj.fullName,
          dueId: state.dueId || this.inputObj.dueId,
          clientId: state.clientId || this.inputObj.clientId,
        };
      }
    }
    const iframeLive = this.cubeConnector.isCubeIframeAgentConnected();
    const realConnectedCall =
      state.Status === 'CONNECTED' &&
      (state.phoneNo || this.inputObj?.phoneNo || state.dueId || state.customerAnswered);
    if (
      state.Status === 'CONNECTED' &&
      !iframeLive &&
      !realConnectedCall &&
      !this.cubeConnector.isAwaitingAgentAnswer() &&
      this.cubeConnector.getCurrentStatus() === 'ready' &&
      !this.cubeAutoTransferRouting &&
      !this.cubeConnector.isTransferRouting() &&
      !this.cubeWrapUpActive &&
      !this.cubeConnector.isWrapUpPending() &&
      !this.cubeConnector.isCallLegActive() &&
      state.callDirection !== 'manual' &&
      !this.cubeConnector.isManualDialerCall()
    ) {
      this.cubeLog('syncCubeCallState', { flush: 'iframe_idle_ready' });
      this.cubeConnector.flushIframeCallState({ reason: 'widget_iframe_idle' }, false);
      return;
    }
    if (iframeLive && state.Status === 'CALLING') {
      this.cubeConnector.resolveAwaitingForConnectedState();
      state = { ...state, Status: 'CONNECTED', customerAnswered: true };
    }
    const profile = getCubeAutoTransferProfile();
    const dummyAutoTransfer = this.isCubeCampaignAutoTransferCall(state);
    const sourceForRoute = dummyAutoTransfer ? this.resolveCubeConnectedCampaignName(state) : '';
    const callRefForRoute = sourceForRoute
      ? String(
          state?.clientId ||
          this.inputObj?.clientId ||
          state?.dueId ||
          this.inputObj?.dueId ||
          state?.phoneNo ||
          this.inputObj?.phoneNo ||
          ''
        ).trim()
      : '';
    const routeKey =
      profile.enabled && profile.targetAgentId && profile.targetCampaign && callRefForRoute
        ? this.buildCubeAutoTransferKey(callRefForRoute, profile.targetCampaign, profile.targetAgentId)
        : '';
    const willAutoRoute =
      this.cubeAutoTransferRouting ||
      (!!routeKey && this.autoTransferInFlightKeys.has(routeKey));
    const suppressCaseOpenForDummyTransfer = dummyAutoTransfer;
    const transferDispatched =
      this.cubeAutoTransferPendingRelease ||
      this.cubeDummyTransferReleased ||
      this.cubeConnector.isCubeTransferDispatched();
    const alreadyRouted =
      !!routeKey &&
      transferDispatched &&
      this.autoTransferAttemptedKeys.has(routeKey);
    if (alreadyRouted && sourceForRoute) {
      this.cubeAutoTransferRouting = false;
      this.cubeAutoTransferTargetLabel = '';
      if (
        this.isCubeAutoTransferSourceCampaign(sourceForRoute) &&
        !this.cubeDummyTransferReleased
      ) {
        this.cubeDummyTransferReleased = true;
        this.cubeConnector.setTransferRouting(false);
        this.cubeConnector.releaseAfterBlindTransfer();
        return;
      }
    } else if (!this.cubeAutoTransferRouting && !this.autoTransferInFlightKeys.size) {
      this.cubeConnector.setTransferRouting(false);
    }
    const awaitingAnswer = this.cubeConnector.isAwaitingAgentAnswer() ? 1 : 0;
    const iframeLiveFlag = iframeLive ? 1 : 0;
    const syncKey = `${state.Status}|${state.holdCall ? 1 : 0}|${state.phoneNo || ''}|${state.dueId || ''}|${state.customerAnswered ? 1 : 0}|${state.callDirection || ''}|${awaitingAnswer}|${iframeLiveFlag}|${willAutoRoute ? 1 : 0}`;
    if (syncKey === this.lastCubeSyncKey) {
      return;
    }
    this.lastCubeSyncKey = syncKey;
    if (!this.inputObj) {
      this.inputObj = { callingType: 'cube', Status: 'Idle' };
    }
    const displayState = this.cubeDialerFlow.enrichCallDisplayData(
      this.withCallerIdentity({
        ...this.inputObj,
        ...state,
        callingType: 'cube',
      })
    );
    this.applyCallerDisplayFields(this.inputObj, displayState);
    this.inputObj = {
      ...this.inputObj,
      ...state,
      ...displayState,
      callingType: 'cube',
      holdCall: willAutoRoute ? false : state.holdCall,
      phoneNo: displayState.phoneNo || state.phoneNo || this.inputObj?.phoneNo || '',
      phoneNumber:
        displayState.phoneNumber ||
        state.phoneNumber ||
        displayState.phoneNo ||
        this.inputObj?.phoneNumber ||
        '',
      fullName: displayState.fullName || state.fullName || this.inputObj?.fullName || '',
    };
    if (state.Status === 'CALLING') {
      const dummyXfer = this.isCubeCampaignAutoTransferCall(state);
      if (iframeLive && dummyXfer) {
        this.agentStatus = 'BUSY';
        this.queueCubeAutoTransfer(state);
        this.applyCubeConnectedWidget('sync_dummy_live');
      } else if (iframeLive) {
        this.cubeConnector.resolveAwaitingForConnectedState();
        this.agentStatus = 'BUSY';
        if (prevStatus !== 'CONNECTED' && !willAutoRoute) {
          this.timer().start();
        }
        if (!suppressCaseOpenForDummyTransfer) {
          void this.syncCubeCaseFromEvent(this.inputObj, 'CONNECTED');
        }
        if (this.isCubeCampaignAutoTransferCall(state)) {
          this.queueCubeAutoTransfer(state);
        }
      } else {
        this.agentStatus = willAutoRoute ? 'BUSY' : (state.customerAnswered ? 'RINGING' : 'BUSY');
        if (
          state.customerAnswered ||
          this.cubeConnector.isAwaitingAgentAnswer() ||
          state.callDirection === 'manual' ||
          this.cubeConnector.isManualDialerCall()
        ) {
          if (!suppressCaseOpenForDummyTransfer) {
            void this.syncCubeCaseFromEvent(this.inputObj, 'CALLING');
          }
          if (this.isCubeCampaignAutoTransferCall(state)) {
            this.queueCubeAutoTransfer(state);
          }
        }
      }
    } else if (state.Status === 'CONNECTED') {
      if (this.cubeConnector.isCubeIframeAgentConnected()) {
        this.cubeAutoTransferRouting = false;
        this.cubeAutoTransferTargetLabel = '';
        this.cubeConnector.setTransferRouting(false);
      }
      if (!willAutoRoute) {
        this.cubeConnector.resolveAwaitingForConnectedState();
      }
      this.agentStatus = 'BUSY';
      if (prevStatus !== 'CONNECTED' && !willAutoRoute) {
        this.timer().start();
      }
      if (!suppressCaseOpenForDummyTransfer) {
        void this.syncCubeCaseFromEvent(this.inputObj, 'CONNECTED');
      }
      if (this.isCubeCampaignAutoTransferCall(state)) {
        this.queueCubeAutoTransfer(state);
      }
      this.applyCubeConnectedWidget('sync_connected');
    } else if (state.Status === 'Disconnected') {
      if (this.cubeWrapUpActive || this.cubeConnector.isWrapUpPending()) {
        if (!this.cubeWrapUpActive && this.cubeConnector.isWrapUpPending()) {
          this.enterCubeWrapUp({ ...state, reason: 'remote' });
        }
        this.ensureCubeDispositionOptions();
        this.inputObj = {
          ...this.inputObj,
          ...state,
          callingType: 'cube',
          Status: 'Disconnected',
          holdCall: false,
          phoneNo: this.inputObj?.phoneNo || state.phoneNo || '',
          fullName: this.inputObj?.fullName || state.fullName || '',
        };
        this.agentStatus = 'IDLE';
        this.incomeCallService.setCallingRes(this.inputObj);
        this.cdr.markForCheck();
        return;
      }
      if (
        this.cubeConnector.wasCallConnected() ||
        prevStatus === 'CONNECTED'
      ) {
        this.enterCubeWrapUp({ ...state, reason: 'remote' });
        return;
      }
      if (
        (prevStatus === 'CALLING' || this.cubeConnector.isRingingUnanswered() || this.cubeConnector.isCallLegActive()) &&
        !this.cubeConnector.isCallCleanupActive()
      ) {
        this.cubeLog('syncCubeCallState', { skip: 'disconnect_while_ringing' });
        this.inputObj = {
          ...this.inputObj,
          Status: 'CALLING',
          holdCall: false,
          phoneNo: this.inputObj?.phoneNo || state.phoneNo || '',
          fullName: this.inputObj?.fullName || state.fullName || '',
        };
        this.agentStatus = 'RINGING';
        this.incomeCallService.setCallingRes(this.inputObj);
        this.cdr.markForCheck();
        return;
      }
    } else if (state.Status === 'Idle') {
      if (this.cubeWrapUpActive || this.cubeConnector.isWrapUpPending() || this.cubeConnector.isCallLegActive()) {
        this.cubeLog('syncCubeCallState', { skip: 'idle_while_leg_or_wrap' });
        this.incomeCallService.setCallingRes(this.inputObj);
        this.cdr.markForCheck();
        return;
      }
      const hadActiveCall = prevStatus === 'CONNECTED' || prevStatus === 'CALLING';
      const connectorBooting =
        this.cubeConnector.getCurrentStatus() === 'logging_in' ||
        this.cubeConnector.getCurrentStatus() === 'loading_webphone' ||
        this.cubeConnector.getCurrentStatus() === 'initializing';
      this.cubeConnector.clearRingState();
      this.cubeConnector.setTransferRouting(false);
      this.cubeAutoTransferRouting = false;
      this.cubeAutoTransferTargetLabel = '';
      this.agentStatus = cubeConnectorStatusIsLoggedIn(this.cubeConnector.getCurrentStatus()) ? 'IDLE' : this.agentStatus;
      if (hadActiveCall) {
        this.isMuted = false;
        this.inputObj.holdCall = false;
        this.timer().stop();
      }
      const endReason = 'idle-sync';
      const recentlyHandled = Date.now() - this.cubeCallEndHandledAt < 400;
      const widgetIdle =
        this.inputObj?.Status === 'Idle' &&
        !this.inputObj?.phoneNo &&
        !this.inputObj?.fullName &&
        this.agentStatus === 'IDLE';
      if (hadActiveCall && !recentlyHandled && !widgetIdle && !connectorBooting) {
        this.onCubeCallEnded({ reason: endReason });
      } else {
        this.cubeLog('syncCubeCallState', {
          skipEndCleanup: true,
          reason: endReason,
          widgetIdle,
          recentlyHandled,
          hadActiveCall,
          connectorBooting,
        });
      }
      this.incomeCallService.setCallingRes(this.inputObj);
      this.cdr.markForCheck();
      return;
    }
    if (
      state.Status === 'CONNECTED' &&
      this.inputObj?.Status !== 'CONNECTED' &&
      (this.inputObj?.phoneNo || state.phoneNo)
    ) {
      this.applyCubeConnectedWidget('sync_tail');
    }
    this.incomeCallService.setCallingRes(this.inputObj);
    this.cdr.markForCheck();
  }

  /** On CONNECTED, loads case/defaulter data into widget caller display (skipped for auto-transfer dummy). */
  private async syncCubeCaseFromEvent(eventData: CubeCallUiState, status: string) {
    if (eventData?.callDirection === 'campaign' && !eventData?.customerAnswered) {
      return;
    }
    if (status === 'CALLING') {
      return;
    }
    if (status !== 'CONNECTED') {
      return;
    }
    const enriched = this.cubeDialerFlow.enrichCallDisplayData({
      ...this.inputObj,
      ...(eventData || {}),
    });
    const callingState = this.cubeDialerFlow.toCallingState(enriched, status);
    const key = `${this.cubeDialerFlow.getCallKey(callingState)}|${status}`;
    const now = Date.now();
    if (key && key === this.lastCubeCaseSyncKey && now - this.lastCubeCaseSyncAt < 2500) {
      return;
    }
    try {
      const caseData = await this.cubeDialerFlow.openCaseFromCall(
        {
          ...callingState,
          Status: 'CONNECTED',
        },
        'CONNECTED'
      );
      if (!caseData) {
        return;
      }
      this.lastCubeCaseSyncKey = key;
      this.lastCubeCaseSyncAt = now;
      const activeCall = this.cubeDialerFlow.toCallingState(
        this.withCallerIdentity({
          ...this.inputObj,
          ...caseData,
        }),
        status
      );
      if (!this.inputObj) {
        this.inputObj = { callingType: 'cube', Status: status };
      }
      this.applyCallerDisplayFields(this.inputObj, activeCall);
      this.inputObj = {
        ...this.inputObj,
        ...activeCall,
        callingType: 'cube',
        Status: status,
        phoneNo: activeCall.phoneNo || this.inputObj.phoneNo || '',
        phoneNumber: activeCall.phoneNumber || activeCall.phoneNo || this.inputObj.phoneNumber || '',
        fullName: activeCall.fullName || this.inputObj.fullName || '',
      };
      this.callData = { ...activeCall };
      this.incomeCallService.setCallingRes(this.inputObj);
      if (status === 'CONNECTED') {
        if (activeCall.clientId) {
          localStorage.setItem('clientId', String(activeCall.clientId));
        }
        localStorage.setItem('incomingCall', 'true');
      }
      this.cdr.markForCheck();
    } catch (_e) { }
  }

  private ensureOzonetelSDKInitialized() {
    if (
      this.sdkAutoInitializeStarted ||
      !this.inputObj ||
      this.inputObj.callingType !== 'ozonetel' ||
      !this.ozonetelDialerFlow.isSdkMode()
    ) {
      return;
    }

    this.sdkAutoInitializeStarted = true;
    this.autoInitializeSDK();
  }

  /**
   * Ozonetel SDK → widget UI bridge (OzonetelSDKCoreService).
   *
   * Two streams drive the calling widget:
   * - agentState$: BUSY/IDLE/PAUSED — agent availability and fallback disconnect detection.
   * - callEvent$: NEW_CALL / BUSY / DROP — per-leg UI (number, ucid, campaign, buttons).
   *
   * inputObj.Status controls isOnCall (CALLING | CONNECTED show End/Hold).
   * _isDisconnecting prevents agentState$ IDLE from racing with DROP during disconnect.
   * NEW_CALL/BUSY clear _isDisconnecting so the next leg after disconnect can sync UI.
   */
  subscribeToOzonetelEvents() {
    // Only subscribe once
    if (this.subscriptions.length > 0) {
      console.log('[CallingWidget] Already subscribed to events');
      return;
    }

    console.log('[CallingWidget] Subscribing to SDK Core events...');

    // Subscribe to the CORE service, not the old SDK service
    const stateSub = this.ozonetelSDKCore.agentState$.subscribe(state => {
      console.log('[CallingWidget] Agent state updated from CORE:', state);
      this.agentStatus = state.status;

      if (state.status === 'BUSY') {
        if (
          this.inputObj &&
          !(this.inputObj as any)._isDisconnecting &&
          this.ozonetelSDKCore.isCallSessionActive()
        ) {
          delete (this.inputObj as any)._isDisconnecting;
          this.inputObj.Status = 'CONNECTED';
          this.inputObj.holdCall = false;
          this.inputObj = { ...this.inputObj };
          void this.ensureTransferLegUnheld(this.callData || this.inputObj);
          this.fetchCallData();
        }
      } else if (state.status === 'IDLE') {
        if (
          this.inputObj &&
          !this.isOnCall &&
          !(this.inputObj as any)._isDisconnecting &&
          !this.ozonetelWrapUpActive &&
          !this.ozonetelSDKCore.isManualDialConnectPending() &&
          (this.inputObj.phoneNo || this.inputObj.fullName || this.callData)
        ) {
          this.clearCallDisplayState();
        } else if (
          this.inputObj &&
          !this.isOnCall &&
          !this.ozonetelSDKCore.isCallSessionActive() &&
          !this.ozonetelSDKCore.isManualDialConnectPending() &&
          this.inputObj.Status !== 'Disconnected' &&
          this.inputObj.Status !== 'Idle' &&
          !(this.inputObj as any)._isDisconnecting
        ) {
          // Do not reset CALLING → Idle on transient SDK IDLE while manual dial is still connecting.
          this.inputObj.Status = 'Idle';
          this.inputObj = { ...this.inputObj };
        }
      } else if (state.status === 'PAUSED') {
        if (this.inputObj) this.inputObj.Status = 'Break';
      }
    });
    this.subscriptions.push(stateSub);

    const callSub = this.ozonetelSDKCore.callEvent$.subscribe(event => {
      console.log('[CallingWidget] Call event from CORE:', event);

      switch (event.type) {
        // Ringing — populate caller/campaign before audio connects
        case 'NEW_CALL': {
          if (this.inputObj) {
            delete (this.inputObj as any)._isDisconnecting;
            const incomingUcid = this.ozonetelDialerFlow.getUcid(event.data || {});
            const currentUcid = String(this.inputObj.ucid || '').trim();
            const isNewLeg =
              !this.isOnCall ||
              (incomingUcid && currentUcid && incomingUcid !== currentUcid);
            if (isNewLeg) {
              this.stripCallDisplayFields(this.inputObj);
              this.clearCallerIdentityCache();
            }
          }
          const display = this.ozonetelDialerFlow.enrichCallDisplayData(
            this.withCallerIdentity(event.data || {})
          );
          if (this.inputObj) {
            this.inputObj.Status = 'CALLING';
            this.applyCallerDisplayFields(this.inputObj, display);
            this.inputObj.transferCall = this.ozonetelTransfer.isTransferredCall(event.data);
            this.inputObj = { ...this.inputObj };
          }
          this.syncOzonetelCaseFromEvent(display, 'CALLING');
          this.publishCallState();
          this.fetchCallData();
          break;
        }

        // Connected — show End/Hold buttons and fetch UCID/campaign card data
        case 'INBOUND_SCREEN_POP':
        case 'BUSY': {
          if (this.inputObj) {
            delete (this.inputObj as any)._isDisconnecting;
            const incomingUcid = this.ozonetelDialerFlow.enrichCallDisplayData(event.data || {}).ucid;
            const currentUcid = String(this.inputObj.ucid || '').trim();
            if (incomingUcid && currentUcid && incomingUcid !== currentUcid) {
              this.stripCallDisplayFields(this.inputObj);
              this.clearCallerIdentityCache();
            }
          }
          const display = this.ozonetelDialerFlow.enrichCallDisplayData(
            this.withCallerIdentity({
              ...this.inputObj,
              ...(event.data || {}),
            })
          );
          if (this.inputObj) {
            this.inputObj.Status = 'CONNECTED';
            this.inputObj.holdCall = false;
            this.applyCallerDisplayFields(this.inputObj, display);
            this.inputObj.transferCall = this.ozonetelTransfer.isTransferredCall(event.data);
            this.inputObj = { ...this.inputObj };
          }
          this.agentStatus = 'BUSY';
          this.stopManualDialConnectWatch();
          void this.ensureTransferLegUnheld(event.data || display);
          this.syncOzonetelCaseFromEvent(display, 'CONNECTED');
          this.publishCallState();
          void this.fetchCallData();
          break;
        }

        /**
         * DROP — call leg ended.
         * Ozonetel SDK: enter wrap-up (disposition UI); other dialers: clear display immediately.
         * Disposition is NOT submitted here; handleCallEnded in sdk-core only sets wrapUpPending + DROP.
         */
        case 'DROP':
          this.agentStatus = 'IDLE';
          // Defensive gate: never show wrap-up if SDK explicitly marks transfer-release bypass.
          if (
            this.isSdkDialer &&
            this.inputObj?.callingType === 'ozonetel' &&
            this.ozonetelSDKCore.isWrapUpPending() &&
            !event?.data?.transferReleaseBypass
          ) {
            void this.enterOzonetelWrapUp(event.data);
          } else {
            this.resetOzonetelWrapUpState();
            this.clearCallDisplayState();
          }
          break;
      }
    });
    this.subscriptions.push(callSub);
  }

  private async syncOzonetelCaseFromEvent(eventData: any, status: string) {
    if (!this.canUpdateCallDisplay()) {
      return;
    }
    const epoch = this.callUiEpoch;
    const enriched = this.ozonetelDialerFlow.enrichCallDisplayData(
      this.withCallerIdentity({
        ...this.inputObj,
        ...(eventData || {}),
      })
    );
    const callingState = this.ozonetelDialerFlow.toCallingState(enriched, status);
    if (epoch !== this.callUiEpoch || !this.canUpdateCallDisplay()) {
      return;
    }
    this.applyOzonetelCallingState(callingState, status);

    const key = this.ozonetelDialerFlow.getCallKey(callingState);
    const now = Date.now();
    const hasToolbarCustData = !!eventData?.custData;
    if (
      !hasToolbarCustData &&
      key &&
      key === this.lastCaseSyncKey &&
      now - this.lastCaseSyncAt < 1500
    ) {
      return;
    }

    try {
      const caseData = await this.ozonetelDialerFlow.openCaseFromCall(
        {
          ...enriched,
          Status: status === 'CONNECTED' ? 'CONNECTED' : 'CALLING',
        },
        status
      );

      if (!caseData || epoch !== this.callUiEpoch || !this.canUpdateCallDisplay()) {
        return;
      }

      this.lastCaseSyncKey = key;
      this.lastCaseSyncAt = Date.now();

      const activeCall = this.ozonetelDialerFlow.toCallingState(caseData, status);
      this.applyOzonetelCallingState(activeCall, status);
      localStorage.setItem('incomingCall', 'true');
      if (activeCall.clientId) {
        localStorage.setItem('clientId', activeCall.clientId);
      }
      this.publishCallState();
    } catch (error) {
      console.error('[CallingWidget] Failed to sync Ozonetel case from SDK event:', error);
    }
  }

  private bumpCallUiEpoch(): number {
    this.callUiEpoch += 1;
    return this.callUiEpoch;
  }

  private canUpdateCallDisplay(): boolean {
    if (!this.inputObj) {
      return false;
    }
    if ((this.inputObj as any)._isDisconnecting) {
      return false;
    }
    if (this.inputObj.callingType === 'centro') {
      return ['CALLING', 'CONNECTED'].includes(this.inputObj.Status)
        || this.centroUiState.getPhase() === 'ringing'
        || this.centroUiState.getPhase() === 'connected';
    }
    return ['CALLING', 'CONNECTED'].includes(this.inputObj.Status);
  }

  private beginCallDisconnect(): void {
    this.bumpCallUiEpoch();
    this.stopManualDialConnectWatch();
    this.callData = null;
    this.lastAutoUnholdUcid = '';
    this.lastCaseSyncKey = '';
    this.lastCaseSyncAt = 0;
    this.timer().stop();
    this.timerMinutes = 0;
    this.timerSeconds = 0;
    this.showTimer = false;
    this.agentStatus = 'IDLE';
    if (this.inputObj) {
      (this.inputObj as any)._isDisconnecting = true;
      this.isMuted = false;
      this.inputObj.holdCall = false;
      this.inputObj.transferCall = false;
      this.stripCallDisplayFields(this.inputObj);
      this.inputObj.Status = 'Disconnected';
      this.inputObj = { ...this.inputObj };
    }
  }

  private publishCallState(syncParent = true): void {
    if (!this.inputObj) {
      return;
    }
    if (this.inputObj.Status === 'Idle') {
      this.incomeCallService.removeCallingRes();
      localStorage.removeItem('incomingCall');
    } else {
      this.incomeCallService.setCallingRes(this.inputObj);
    }
    if (!syncParent) {
      return;
    }
    this.skipNextInputChange = true;
    this.onAction.emit({ sync: true, inputObj: { ...this.inputObj } });
  }

  private stripCallDisplayFields(target: any): void {
    if (!target) {
      return;
    }
    [
      'phoneNo',
      'phoneNumber',
      'fullName',
      'ucid',
      'dueId',
      'DueId',
      'clientId',
      'campaignName',
      'communicationDetailId',
      'commDetId',
      'did',
      'custData',
    ].forEach((key) => delete target[key]);
  }

  private clearCallerIdentityCache(): void {
    this.callerIdentityCache = {};
  }

  private rememberCallerIdentity(source: any): void {
    if (!source || typeof source !== 'object') {
      return;
    }
    const isCube =
      this.inputObj?.callingType === 'cube' || source.callingType === 'cube';
    const isCentro =
      this.inputObj?.callingType === 'centro' || source.callingType === 'centro';
    if (isCentro) {
      const phoneNo = this.centroDialerFlow.getPhoneNumber(source);
      if (
        phoneNo &&
        this.callerIdentityCache.phoneNo &&
        phoneNo !== this.callerIdentityCache.phoneNo
      ) {
        this.callerIdentityCache = {};
      }
    }
    if (isCube) {
      const legKey = this.cubeDialerFlow.getCallKey(source);
      if (legKey) {
        if (
          this.callerIdentityCache.legKey &&
          this.callerIdentityCache.legKey !== legKey
        ) {
          this.callerIdentityCache = {};
        }
        this.callerIdentityCache.legKey = legKey;
      }
    }
    const ucid = this.ozonetelDialerFlow.getUcid(source);
    const fullName =
      this.inputObj?.callingType === 'cube'
        ? this.cubeDialerFlow.resolveFullName(source)
        : this.ozonetelDialerFlow.resolveFullName(source);
    const phoneNo =
      this.inputObj?.callingType === 'cube'
        ? this.cubeDialerFlow.getPhoneNumber(source)
        : this.ozonetelDialerFlow.getPhoneNumber(source);
    if (ucid) {
      if (this.callerIdentityCache.ucid && this.callerIdentityCache.ucid !== ucid) {
        this.callerIdentityCache = {};
      }
      this.callerIdentityCache.ucid = ucid;
    }
    if (fullName) {
      this.callerIdentityCache.fullName = fullName;
    }
    if (phoneNo) {
      this.callerIdentityCache.phoneNo = phoneNo;
    }
    const dueId =
      this.inputObj?.callingType === 'cube'
        ? this.cubeDialerFlow.sanitizeDueId(source.dueId ?? source.DueId)
        : String(source.dueId || source.DueId || '').trim();
    if (dueId) {
      this.callerIdentityCache.dueId = dueId;
    }
    if (source.custData != null && source.custData !== '') {
      this.callerIdentityCache.custData = source.custData;
    }
  }

  private withCallerIdentity(source: any): any {
    if (!source || typeof source !== 'object') {
      return source;
    }
    const isCentroEarly =
      this.inputObj?.callingType === 'centro' || source.callingType === 'centro';
    if (isCentroEarly) {
      const sourcePhone = this.centroDialerFlow.getPhoneNumber(source);
      const cachePhone = this.callerIdentityCache.phoneNo || '';
      if (sourcePhone && cachePhone && sourcePhone !== cachePhone) {
        return source;
      }
    }
    const isCubeEarly =
      this.inputObj?.callingType === 'cube' || source.callingType === 'cube';
    if (isCubeEarly) {
      const sourcePhone = this.cubeDialerFlow.getPhoneNumber(source);
      const cachePhone = this.callerIdentityCache.phoneNo || '';
      if (sourcePhone && cachePhone && sourcePhone !== cachePhone) {
        return source;
      }
      const legKey = this.cubeDialerFlow.getCallKey(source);
      if (
        legKey &&
        this.callerIdentityCache.legKey &&
        legKey !== this.callerIdentityCache.legKey
      ) {
        return source;
      }
    }
    const ucid = this.ozonetelDialerFlow.getUcid(source);
    if (
      ucid &&
      this.callerIdentityCache.ucid &&
      ucid !== this.callerIdentityCache.ucid
    ) {
      return source;
    }
    const merged = {
      ...this.callerIdentityCache,
      ...source,
    };
    if (
      (merged.custData == null || merged.custData === '') &&
      this.callerIdentityCache.custData != null
    ) {
      merged.custData = this.callerIdentityCache.custData;
    }
    const isCentro = this.inputObj?.callingType === 'centro' || merged.callingType === 'centro';
    const isCube = !isCentro && (this.inputObj?.callingType === 'cube' || merged.callingType === 'cube');
    const phoneNo = isCentro
      ? this.centroDialerFlow.getPhoneNumber(merged)
      : isCube
      ? this.cubeDialerFlow.getPhoneNumber(merged)
      : this.ozonetelDialerFlow.getPhoneNumber(merged);
    const fullName = isCentro
      ? this.centroDialerFlow.resolveFullName(merged)
      : isCube
      ? this.cubeDialerFlow.resolveFullName(merged)
      : this.ozonetelDialerFlow.resolveFullName(merged);
    if (fullName) {
      merged.fullName = fullName;
    } else if (
      this.callerIdentityCache.fullName &&
      !(isCube && String(source.Status || '').toUpperCase() === 'CALLING' && !phoneNo) &&
      (isCentro
        ? (!phoneNo || !this.callerIdentityCache.phoneNo || phoneNo === this.callerIdentityCache.phoneNo)
        : !isCube || !this.callerIdentityCache.phoneNo || phoneNo === this.callerIdentityCache.phoneNo)
    ) {
      merged.fullName = this.callerIdentityCache.fullName;
    }
    if (phoneNo) {
      merged.phoneNo = phoneNo;
    } else if (!isCube && !isCentro && this.callerIdentityCache.phoneNo) {
      merged.phoneNo = this.callerIdentityCache.phoneNo;
    }
    if (isCube) {
      const dueId = this.cubeDialerFlow.sanitizeDueId(merged.dueId ?? merged.DueId);
      if (dueId) {
        merged.dueId = dueId;
        merged.DueId = dueId;
      }
    }
    return merged;
  }

  private applyCallerDisplayFields(target: any, display: any): void {
    if (!target || !display) {
      return;
    }
    const isCentro = target.callingType === 'centro' || display.callingType === 'centro';
    const isCube = !isCentro && (target.callingType === 'cube' || display.callingType === 'cube');
    const merged = isCentro
      ? this.centroDialerFlow.enrichCallDisplayData(
          this.withCallerIdentity({
            ...target,
            ...display,
          })
        )
      : isCube
      ? this.cubeDialerFlow.enrichCallDisplayData(
          this.withCallerIdentity({
            ...target,
            ...display,
          })
        )
      : this.ozonetelDialerFlow.enrichCallDisplayData(
          this.withCallerIdentity({
            ...target,
            ...display,
          })
        );
    const phoneNo = isCentro
      ? this.centroDialerFlow.getPhoneNumber(merged)
      : isCube
      ? this.cubeDialerFlow.getPhoneNumber(merged)
      : merged.phoneNo || merged.phoneNumber;
    if (phoneNo) {
      target.phoneNo = phoneNo;
      target.phoneNumber = phoneNo;
    }
    const fullName = isCentro
      ? this.centroDialerFlow.resolveFullName(merged)
      : isCube
      ? this.cubeDialerFlow.resolveFullName(merged)
      : this.ozonetelDialerFlow.resolveFullName(merged);
    if (fullName) {
      target.fullName = fullName;
    } else if (this.callerIdentityCache.fullName) {
      const cachePhoneOk = isCentro
        ? (!phoneNo || !this.callerIdentityCache.phoneNo || phoneNo === this.callerIdentityCache.phoneNo)
        : !isCube ||
        !phoneNo ||
        !this.callerIdentityCache.phoneNo ||
        phoneNo === this.callerIdentityCache.phoneNo;
      const cacheLegOk =
        !isCube ||
        !this.callerIdentityCache.legKey ||
        this.callerIdentityCache.legKey === this.cubeDialerFlow.getCallKey(merged);
      if (cachePhoneOk && cacheLegOk) {
        target.fullName = this.callerIdentityCache.fullName;
      }
    }
    if (isCentro || isCube) {
      const dueId = (isCentro ? this.centroDialerFlow : this.cubeDialerFlow).sanitizeDueId(
        merged.dueId ?? merged.DueId ?? target.dueId
      );
      if (dueId) {
        target.dueId = dueId;
        target.DueId = dueId;
      }
    }
    if (merged.ucid) {
      target.ucid = merged.ucid;
    }
    if (merged.campaignName) {
      target.campaignName = merged.campaignName;
    }
    if (merged['custData'] != null && merged['custData'] !== '') {
      target.custData = merged['custData'];
    }
    this.rememberCallerIdentity(merged);
  }

  /** Debounced check when connector idle disagrees with widget on-call display. */
  private scheduleReconcileStaleCubeCallDisplay(): void {
    if (this.cubeReconcileTimer) {
      clearTimeout(this.cubeReconcileTimer);
    }
    this.cubeReconcileTimer = setTimeout(() => {
      this.cubeReconcileTimer = null;
      this.reconcileStaleCubeCallDisplay();
    }, 100);
  }

  /** Clears ghost on-call UI when connector reports idle and no live session exists. */
  private reconcileStaleCubeCallDisplay(): void {
    if (!this.isCubeWebphone || !this.inputObj || this.inputObj.callingType !== 'cube') {
      return;
    }
    this.mergeCubeCallContextFromSession();
    const session = this.incomeCallService.getCallingRes();
    if (
      session?.callingType === 'cube' &&
      ['CONNECTED', 'CALLING'].includes(String(session.Status || '')) &&
      !this.isOnCall &&
      !this.isCubeAgentRinging &&
      (session.phoneNo || session.phoneNumber || this.inputObj.phoneNo)
    ) {
      this.applyCubeConnectedWidget('reconcile_session');
      return;
    }
    if (
      this.cubeWrapUpActive ||
      this.cubeConnector.isWrapUpPending() ||
      this.cubeConnector.isCallLegActive() ||
      this.cubeConnector.hasActiveOrWrapUpLeg()
    ) {
      return;
    }
    if (!this.cubeConnector.isAgentLoggedIn()) {
      return;
    }
    const sessionActive = this.cubeConnector.isCallSessionActive();
    const iframeLive = this.cubeConnector.isCubeIframeAgentConnected();
    const awaitingAnswer = this.cubeConnector.isAwaitingAgentAnswer();
    const manualDial =
      this.cubeConnector.isManualDialerCall() || this.inputObj?.callDirection === 'manual';
    const hasCallerInfo = !!(this.inputObj.phoneNo || this.inputObj.fullName || this.inputObj.ucid);
    const staleOnCall =
      this.inputObj.Status === 'CONNECTED' ||
      this.inputObj.Status === 'CALLING' ||
      (hasCallerInfo && this.isOnCall);
    const reconcileKey = `${this.inputObj.Status}|${this.agentStatus}|${sessionActive ? 1 : 0}|${iframeLive ? 1 : 0}|${this.cubeConnector.getCurrentStatus()}|${awaitingAnswer ? 1 : 0}`;
    if (reconcileKey === this.lastCubeReconcileKey) {
      return;
    }
    this.lastCubeReconcileKey = reconcileKey;
    this.cubeLog('reconcileStaleCubeCallDisplay', {
      widgetStatus: this.inputObj.Status,
      agentStatus: this.agentStatus,
      sessionActive,
      iframeLive,
      connectorStatus: this.cubeConnector.getCurrentStatus(),
      hasCallerInfo,
      staleOnCall,
      manualDial,
      awaitingAnswer,
    });
    if (
      this.inputObj.Status === 'CALLING' ||
      this.inputObj.Status === 'CONNECTED' ||
      this.inputObj.Status === 'Disconnected'
    ) {
      return;
    }
    if (
      this.cubeConnector.getCurrentStatus() === 'ready' &&
      this.inputObj.Status === 'CONNECTED' &&
      !sessionActive &&
      !iframeLive &&
      !hasCallerInfo
    ) {
      this.onCubeCallEnded({ reason: 'reconcile-stale' });
      this.cubeConnector.reconcileStaleCall('widget-stale-ready');
      return;
    }
    if (
      (staleOnCall &&
        !sessionActive &&
        !iframeLive &&
        this.agentStatus !== 'BUSY' &&
        this.agentStatus !== 'RINGING') ||
      (this.inputObj.Status === 'Idle' && hasCallerInfo && !sessionActive && !iframeLive)
    ) {
      this.onCubeCallEnded({ reason: 'reconcile-stale-display' });
      this.cubeConnector.reconcileStaleCall('widget-stale-display');
    }
  }

  /**
   * Clears stale caller UI when SDK session no longer matches display.
   * Skips Disconnected + caller info while ozonetelWrapUpActive — disposition panel needs that data.
   */
  private reconcileStaleCallDisplay(): void {
    if (!this.ozonetelSDKCore.isAgentInitialized() || !this.inputObj) {
      return;
    }
    if (this.inputObj.Status === 'CALLING' || this.inputObj.Status === 'CONNECTED') {
      if (this.ozonetelSDKCore.isCallSessionActive() || this.agentStatus === 'BUSY') {
        return;
      }
    }
    const staleOnCall = this.inputObj.Status === 'CONNECTED';
    const hasCallerInfo = !!(this.inputObj.phoneNo || this.inputObj.fullName || this.inputObj.ucid);
    if (
      (staleOnCall && !this.ozonetelSDKCore.isCallSessionActive() && this.agentStatus !== 'BUSY') ||
      (this.inputObj.Status === 'Disconnected' && hasCallerInfo && !this.ozonetelWrapUpActive) ||
      (this.inputObj.Status === 'Idle' && hasCallerInfo && !this.ozonetelSDKCore.isCallSessionActive())
    ) {
      this.clearCallDisplayState();
    }
  }

  // Recover stale SDK wrap-up state after CRM relogin/session restore without active call.
  private async recoverStaleOzonetelWrapUpState(): Promise<void> {
    if (!this.isSdkDialer || this.inputObj?.callingType !== 'ozonetel') {
      return;
    }
    const didRecover = await this.ozonetelSDKCore.clearStaleWrapUpStateIfNoActiveCall();
    if (didRecover) {
      this.resetOzonetelWrapUpState();
      this.clearCallDisplayState();
      this.agentStatus = 'IDLE';
    }
  }

  /**
   * Step 2 of Ozonetel wrap-up — called from DROP event handler after sdk-core handleCallEnded().
   *
   * - Sets ozonetelWrapUpActive (blocks reconcile/clear until disposition done)
   * - Keeps caller display fields; Status → Disconnected
   * - Starts wrap timer (featureList.wrapDuration)
   * - loadOzonetelDispositions() from JSON list (not SDK getDispositions)
   */
  async enterOzonetelWrapUp(eventData?: any): Promise<void> {
    if (!this.inputObj || this.inputObj.callingType !== 'ozonetel' || !this.isSdkDialer) {
      return;
    }
    this.expandWidgetUi();
    this.ozonetelWrapUpActive = true;
    this.stopManualDialConnectWatch();
    this.isMuted = false;
    this.showTimer = false;
    this.timer().stop();
    if (eventData && typeof eventData === 'object') {
      const display = this.ozonetelDialerFlow.enrichCallDisplayData(
        this.withCallerIdentity({ ...this.inputObj, ...eventData })
      );
      this.applyCallerDisplayFields(this.inputObj, display);
    }
    if (this.inputObj) {
      this.inputObj.Status = 'Disconnected';
      this.inputObj.holdCall = false;
      this.inputObj.transferCall = false;
      delete (this.inputObj as any)._isDisconnecting;
      this.inputObj = { ...this.inputObj };
    }
    this.publishCallState();
    this.startWrapUpElapsedTimer();
    this.timer().start();
    void this.loadOzonetelDispositions();
    this.cdr.markForCheck();
  }

  /** Shows disposition panel: Status Disconnected, loads dropdown, starts wrap timer. */
  enterCubeWrapUp(eventData?: unknown): void {
    if (!this.inputObj || this.inputObj.callingType !== 'cube' || !this.isCubeWebphone) {
      return;
    }
    if (this.cubeDummyTransferReleased) {
      this.cubeLog('enterCubeWrapUp', { skip: 'dummy_released' });
      return;
    }
    const reason = String((eventData as { reason?: string })?.reason || '');
    this.cubeDispositionLoading = false;
    this.cubeWrapUpSubmitInFlight = false;
    this.ensureCubeDispositionOptions();
    if (this.cubeWrapUpActive) {
      this.startWrapUpElapsedTimer();
      this.cdr.detectChanges();
      return;
    }
    if (
      !this.cubeConnector.isWrapUpPending() &&
      !this.cubeConnector.canShowDisposition(reason || 'agent_hangup')
    ) {
      this.cubeLog('enterCubeWrapUp', { skip: 'not_eligible', reason });
      return;
    }
    this.cubeLog('enterCubeWrapUp', { phone: this.inputObj?.phoneNo || '', reason });
    this.expandWidgetUi();
    this.cubeWrapUpActive = true;
    if (!this.cubeConnector.isWrapUpPending()) {
      this.cubeConnector.armWrapUpFromUi(
        (eventData as { snapshot?: CubeCallUiState })?.snapshot || this.inputObj
      );
    }
    this.stopManualDialConnectWatch();
    this.isMuted = false;
    this.showTimer = false;
    this.timer().stop();
    const snapshot = (eventData as { snapshot?: CubeCallUiState })?.snapshot;
    if (snapshot && typeof snapshot === 'object') {
      const display = this.cubeDialerFlow.enrichCallDisplayData(
        this.withCallerIdentity({ ...this.inputObj, ...snapshot })
      );
      this.applyCallerDisplayFields(this.inputObj, display);
    } else if (eventData && typeof eventData === 'object') {
      const display = this.cubeDialerFlow.enrichCallDisplayData(
        this.withCallerIdentity({ ...this.inputObj, ...(eventData as object) })
      );
      this.applyCallerDisplayFields(this.inputObj, display);
    }
    this.ensureCubeDispositionOptions();
    if (this.inputObj) {
      this.inputObj.Status = 'Disconnected';
      this.inputObj.holdCall = false;
      this.inputObj.transferCall = false;
      this.inputObj.customerAnswered = false;
      delete (this.inputObj as any)._isDisconnecting;
      this.inputObj = { ...this.inputObj };
    }
    this.agentStatus = 'IDLE';
    this.publishCallState();
    this.startWrapUpElapsedTimer();
    void this.loadCubeDispositions();
    this.logCubeStateSnapshot('enterCubeWrapUp');
    this.cdr.detectChanges();
  }

  /** Refill the widget dropdown if wrap-up opened before the list was ready. */
  private ensureCubeDispositionOptions(): void {
    if (!this.cubeDispositions.length) {
      this.cubeDispositions = this.cubeWrapUp.loadDispositionsSync();
    }
    if (!this.cubeDispositions.length) {
      this.cubeDispositions = [
        { id: 'PTP', reason: 'PTP', label: 'PTP' },
        { id: 'Call back', reason: 'Call back', label: 'Call back' },
        { id: 'Not Reachable', reason: 'Not Reachable', label: 'Not Reachable' },
        { id: 'Paid', reason: 'Paid', label: 'Paid' },
      ];
    }
    if (!this.selectedCubeDisposition && this.cubeDispositions.length > 0) {
      this.selectedCubeDisposition = this.cubeDispositions[0].reason;
    }
    this.cdr.markForCheck();
  }

  async loadCubeDispositions(): Promise<void> {
    if (!this.cubeWrapUpActive) {
      return;
    }
    this.cubeLog('loadCubeDispositions', { start: true });
    this.cubeDispositionError = '';
    const previous = this.cubeDispositions.slice();
    const list = await this.cubeWrapUp.loadDispositions();
    if (!this.cubeWrapUpActive) {
      return;
    }
    this.cubeDispositions = list.length ? list : previous;
    this.ensureCubeDispositionOptions();
    this.cubeLog('loadCubeDispositions', {
      count: this.cubeDispositions.length,
      first: this.cubeDispositions[0]?.reason || '',
    });
    this.logCubeStateSnapshot('loadCubeDispositions');
    this.cdr.detectChanges();
  }

  /** Submits selected disposition to Cube; clears UI on success (manual or wrap timer). */
  async submitCubeDisposition(autoSubmit = false): Promise<void> {
    if (this.cubeConnector.isWrapUpPending() && !this.cubeWrapUpActive) {
      this.cubeWrapUpActive = true;
    }
    if (!this.cubeWrapUpActive || this.cubeWrapUpSubmitInFlight) {
      return;
    }
    const reason = String(this.selectedCubeDisposition || '').trim();
    if (!reason) {
      if (!autoSubmit) {
        this.showErr('Select a disposition', 'Error');
      }
      return;
    }
    this.cubeWrapUpSubmitInFlight = true;
    this.cubeDispositionLoading = true;
    this.cubeLog('submitCubeDisposition', { reason, autoSubmit });
    const timelineDueId = this.inputObj?.dueId;
    const timelinePhone = this.inputObj?.phoneNo;
    const timelineClientId = this.inputObj?.clientId;
    try {
      const result = await this.cubeWrapUp.submitDisposition(reason, this.cubeDispositionComment);
      if (result.success) {
        // this.autoDisposeCubeTimeline(timelineDueId, timelinePhone, timelineClientId);
        this.resetCubeWrapUpState();
        this.clearCubeCallUiOnly('disposition');
        if (!autoSubmit) {
          this.showErr('Call disposed', 'OK');
        }
      } else if (!autoSubmit) {
        this.showErr(result.message || 'Failed to dispose call', 'Error');
      }
    } catch (error: any) {
      if (!autoSubmit) {
        this.showErr(error?.message || 'Failed to dispose call', 'Error');
      }
    } finally {
      this.cubeWrapUpSubmitInFlight = false;
      this.cubeDispositionLoading = false;
      this.cdr.markForCheck();
    }
  }

  /** Clears wrap-up flags, disposition form, and elapsed timer. */
  private resetCubeWrapUpState(): void {
    this.cubeLog('resetCubeWrapUpState', {});
    this.cubeWrapUpActive = false;
    this.selectedCubeDisposition = '';
    this.cubeDispositionComment = '';
    this.cubeDispositionError = '';
    this.cubeWrapUpSubmitInFlight = false;
    this.cubeDispositionLoading = false;
    this.stopWrapUpElapsedTimer();
    this.logCubeStateSnapshot('resetCubeWrapUpState');
  }

  private clearCentroSipEndTimer(): void {
    if (this.centroSipEndTimer) {
      clearTimeout(this.centroSipEndTimer);
      this.centroSipEndTimer = null;
    }
  }

  // Single place that drives Centro dialer call-info UI (status + phone).
  // During wrap-up, never accept a new live call — reject SIP until dispose completes.
  private beginCentroLiveCallUi(status: 'CALLING' | 'CONNECTED'): void {
    if (!this.inputObj || this.inputObj.callingType !== 'centro') {
      return;
    }
    if (this.centroWrapUpActive) {
      console.warn('[CentroUI] blocking new call during wrap-up — dispose required first', {
        status,
        phone: this.centroSip.getRemotePhone() || '',
      });
      this.centroSip.setAutoAnswer(false);
      this.centroSip.rejectIncoming();
      this.centroSipRinging = false;
      this.agentStatus = 'IDLE';
      this.centroStatusDetail = 'Wrap-up — dispose before next call';
      this.cdr.detectChanges();
      return;
    }
    const phone = this.applyCentroSipDisplayPhone(this.centroSip.getRemotePhone());
    if (!this.centroLiveLegEpoch || this.centroUiState.getPhase() === 'idle' || this.centroUiState.getPhase() === 'wrapup') {
      this.centroLiveLegEpoch = this.centroUiState.beginNewLeg(phone);
    }
    if (status === 'CONNECTED') {
      this.centroUiState.markConnected(this.centroLiveLegEpoch);
      this.centroSipRinging = false;
    }
    this.centroRemoteHangup = false;
    this.centroAgentLegLive = true;
    this.centroOutboundActive = true;
    this.expandWidgetUi();
    this.showCentroManualDial = false;
    this.showCentroTools = false;
    const nextPhone = phone
      || String(this.inputObj.phoneNo || '').replace(/\D/g, '').slice(-10)
      || this.centroControlWs.getPhone()
      || this.centroUiState.getLastPhone()
      || '';
    this.inputObj = {
      ...this.inputObj,
      Status: status,
      phoneNo: nextPhone,
      phoneNumber: nextPhone,
      callDirection: this.inputObj.callDirection || (this.centroAutoMode ? 'campaign' : 'manual'),
      holdCall: false,
      transferCall: false,
      customerAnswered: status === 'CONNECTED' ? true : !!this.inputObj.customerAnswered,
    };
    this.agentStatus = status === 'CONNECTED' ? 'ONCALL' : 'RINGING';
    this.centroStatusDetail = status === 'CONNECTED' ? 'On Call' : 'Dialing...';
    if (nextPhone) {
      this.centroControlWs.setPhone(nextPhone);
    }
    console.log('[CentroUI] applyLiveCallUi', {
      status,
      phone: nextPhone,
      epoch: this.centroLiveLegEpoch,
      isOnCall: this.isOnCall,
      wrapUp: this.centroWrapUpActive,
    });
    this.publishCallState();
    if (status === 'CALLING') {
      void this.refreshCentroCallDisplay();
    }
    this.cdr.detectChanges();
  }

  private stopCentroAutoDialForWrapUp(): void {
    // Keep agent Auto/Manual mode as-is on hangup. Block next call by rejecting SIP until dispose.
    this.centroSip.setAutoAnswer(false);
    console.log('[CentroUI] wrap-up: SIP auto-answer off (mode unchanged)', {
      isToggled: this.inputObj?.isToggled === true,
    });
  }

  private restoreCentroAfterWrapUp(): void {
    this.centroSip.setAutoAnswer(true);
    console.log('[CentroUI] wrap-up done: SIP auto-answer on', {
      isToggled: this.inputObj?.isToggled === true,
    });
  }

  private async handleCentroSipLegEnded(fromRemoteEvent = false, legEpoch = 0): Promise<void> {
    if (!this.inputObj || this.inputObj.callingType !== 'centro' || this.centroWrapUpActive) {
      return;
    }
    if (!this.centroUiState.shouldHandleSipEnd(legEpoch || this.centroLiveLegEpoch)) {
      return;
    }
    const uiOnCall = ['CALLING', 'CONNECTED'].includes(String(this.inputObj.Status || ''));
    const forceRemote = fromRemoteEvent || this.centroRemoteHangup;
    if (!this.centroOutboundActive && !uiOnCall && !forceRemote) {
      return;
    }
    if (!forceRemote && (this.centroSip.hasActiveSession() || this.centroSip.isRinging())) {
      this.centroAgentLegLive = true;
      this.cdr.markForCheck();
      return;
    }
    const sipDead = !this.centroSip.hasActiveSession() && !this.centroSip.isRinging();
    if (!forceRemote && !sipDead) {
      return;
    }
    if (!forceRemote && sipDead) {
      try {
        const statusRes: any = await firstValueFrom(
          this.callingService.postCentroSipSync(false, false, true)
        );
        const line = String(statusRes?.lineStatus || '').toUpperCase();
        // Server may still report ONCALL while WaitingDisposition/ids remain — treat browser SIP as source of truth.
        const stillLive = statusRes?.isOnCall === true
          && ['ONCALL', 'MUTE', 'HOLD', 'RINGING', 'DIALING'].includes(line)
          && !statusRes?.remoteEnded;
        if (stillLive && (this.centroSip.hasActiveSession() || this.centroSip.isRinging())) {
          this.cdr.markForCheck();
          return;
        }
      } catch (_e) {}
    }
    this.centroOutboundActive = false;
    this.centroRemoteHangup = false;
    let wrapContext: any = {
      phoneNo: this.inputObj.phoneNo,
      recordId: this.inputObj.recordId,
      crmDataId: this.inputObj.crmDataId,
      reason: 'remote'
    };
    try {
      await firstValueFrom(this.callingService.postCentroLineEvent({ status: 'HANGUP' }));
    } catch (_e) {}
    try {
      const hangupRes: any = await firstValueFrom(
        this.callingService.centroHangupCall({ skipAutoDispose: true })
      );
      if (hangupRes?.resultShort === 'success') {
        wrapContext = { ...wrapContext, ...hangupRes };
      }
    } catch (_e) {}
    if (!wrapContext?.recordId && !wrapContext?.crmDataId) {
      try {
        const ctx: any = await firstValueFrom(this.callingService.centroGetCallContext());
        wrapContext = { ...wrapContext, ...ctx };
      } catch (_e) {}
    }
    this.enterCentroWrapUp(wrapContext, 'remote');
  }

  enterCentroWrapUp(context: any = {}, reason = 'agent_hangup'): void {
    if (!this.inputObj || this.inputObj.callingType !== 'centro') {
      return;
    }
    // If SIP already started next call, never enter wrap-up UI for previous leg.
    if (this.centroSip.isInCall() || this.centroSip.isRinging() || this.centroSipRinging) {
      console.warn('[CentroUI] skip wrap-up — SIP already live again', { reason });
      return;
    }
    if (this.centroWrapUpActive && this.inputObj.Status === 'Disconnected') {
      return;
    }
    this.clearCentroSipEndTimer();
    this.centroAgentLegLive = false;
    this.centroOutboundActive = false;
    this.centroRemoteHangup = false;
    this.centroLiveLegEpoch = 0;
    this.centroWrapUpActive = true;
    this.expandWidgetUi();
    this.centroUiState.markWrapUp();
    this.stopCentroAutoDialForWrapUp();
    this.stopManualDialConnectWatch();
    this.isMuted = false;
    this.showTimer = false;
    this.showCentroManualDial = false;
    this.showCentroTools = false;
    this.timer().stop();
    const enriched = this.centroDialerFlow.enrichFromApiContext(
      this.withCallerIdentity({ ...this.inputObj, ...(context || {}) }),
      context || {}
    );
    this.applyCallerDisplayFields(this.inputObj, enriched);
    const phone = String(
      enriched.phoneNo || this.inputObj.phoneNo || context?.phoneNo || ''
    ).replace(/\D/g, '').slice(-10);
    this.centroWrapUpContext = {
      recordId: String(enriched['recordId'] || context?.['recordId'] || this.inputObj?.['recordId'] || '').trim(),
      crmDataId: String(enriched['crmDataId'] || context?.['crmDataId'] || this.inputObj?.['crmDataId'] || '').trim(),
      crmLeadId: String(enriched['crmLeadId'] || context?.['crmLeadId'] || this.inputObj?.['crmLeadId'] || '').trim(),
      phoneNo: phone,
      callType: String(enriched['CALL_TYPE'] || context?.['callType'] || this.inputObj?.['CALL_TYPE'] || 'MC').trim(),
    };
    this.inputObj = {
      ...this.inputObj,
      Status: 'Disconnected',
      holdCall: false,
      transferCall: false,
      phoneNo: phone || this.inputObj.phoneNo || '',
      fullName: enriched.fullName || this.inputObj.fullName || '',
      recordId: this.centroWrapUpContext.recordId,
      crmDataId: this.centroWrapUpContext.crmDataId,
    };
    delete (this.inputObj as any)._isDisconnecting;
    this.agentStatus = 'IDLE';
    this.centroStatusDetail = 'Wrap-up';
    console.log('[CentroUI] enterWrapUp', {
      reason,
      userContext: this.centroWrapUpContext,
    });
    this.publishCallState();
    this.startWrapUpElapsedTimer();
    this.timer().start();
    void this.loadCentroDispositions(context?.dispositions);
    this.cdr.detectChanges();
  }

  private async enterCentroWrapUpFromCallEnd(reason = 'remote'): Promise<void> {
    if (!this.inputObj || this.inputObj.callingType !== 'centro' || this.centroWrapUpActive) {
      return;
    }
    await this.handleCentroSipLegEnded();
  }

  async loadCentroDispositions(prefetched?: unknown): Promise<void> {
    if (!this.centroWrapUpActive) {
      return;
    }
    this.centroDispositionError = '';
    const mapped = this.centroWrapUp.mapDispositions(prefetched);
    if (mapped.length) {
      this.centroDispositions = mapped;
    } else {
      this.centroDispositions = await this.centroWrapUp.loadDispositions();
    }
    if (!this.selectedCentroDisposition && this.centroDispositions.length > 0) {
      this.selectedCentroDisposition = this.centroDispositions[0].reason;
    }
    this.cdr.markForCheck();
  }

  /**
   * CRM timeline marked disposition while Centro wrap-up was open.
   * Without this, IncomingCallSubject sets Status=Completed, the wrap-up panel hides,
   * but centroWrapUpActive stays true and the widget stuck on "Wrap-up".
   * Reuse submitCentroDisposition() so Centro API dispose + Ready state stay identical to the panel.
   */
  private applyCentroDispositionFromCrm(payload: { disposition: string; remarks?: string }): void {
    if (!this.isCentroDialer || !this.centroWrapUpActive || this.centroWrapUpSubmitInFlight) {
      return;
    }
    const matched = this.centroWrapUp.matchDisposition(payload?.disposition, this.centroDispositions);
    if (!matched) {
      return;
    }
    this.selectedCentroDisposition = matched;
    if (payload?.remarks) {
      this.centroDispositionComment = payload.remarks;
    }
    console.log('[CentroUI] applyCrmDisposition', { matched, wrapUp: this.centroWrapUpActive });
    void this.submitCentroDisposition(true);
  }

  async submitCentroDisposition(autoSubmit = false): Promise<void> {
    if (!this.centroWrapUpActive || this.centroWrapUpSubmitInFlight) {
      return;
    }
    const reason = String(this.selectedCentroDisposition || '').trim();
    if (!reason) {
      if (!autoSubmit) {
        this.showErr('Select a disposition', 'Error');
      }
      return;
    }
    this.centroWrapUpSubmitInFlight = true;
    this.centroDispositionLoading = true;
    const timelineDueId = this.inputObj?.dueId;
    const timelinePhone = this.inputObj?.phoneNo;
    const timelineClientId = this.inputObj?.clientId;
    try {
      const result = await this.centroWrapUp.submitDisposition(
        reason,
        this.centroDispositionComment,
        this.centroWrapUpContext
      );
      if (result.success) {
        await this.centroDialerFlow.openCaseFromCall({
          ...this.inputObj,
          Status: 'CONNECTED',
          customerAnswered: true,
        });
        this.resetCentroWrapUpState();
        this.clearCentroCallUiOnly();
        this.restoreCentroAfterWrapUp();
        if (!autoSubmit) {
          this.showErr('Call disposed', 'OK');
        }
      } else if (!autoSubmit) {
        this.centroDispositionError = result.message || 'Failed to dispose call';
        this.showErr(result.message || 'Failed to dispose call', 'Error');
      }
    } catch (error: any) {
      if (!autoSubmit) {
        this.centroDispositionError = error?.message || 'Failed to dispose call';
        this.showErr(error?.message || 'Failed to dispose call', 'Error');
      }
    } finally {
      this.centroWrapUpSubmitInFlight = false;
      this.centroDispositionLoading = false;
      this.cdr.markForCheck();
    }
  }

  private resetCentroWrapUpState(): void {
    this.centroWrapUpActive = false;
    this.centroDispositions = [];
    this.selectedCentroDisposition = '';
    this.centroDispositionComment = '';
    this.centroDispositionError = '';
    this.centroWrapUpSubmitInFlight = false;
    this.centroAutoDisposeTriggered = false;
    this.centroAgentLegLive = false;
    this.centroOutboundActive = false;
    this.centroRemoteHangup = false;
    this.centroLiveLegEpoch = 0;
    this.centroWrapUpContext = { recordId: '', crmDataId: '', crmLeadId: '', phoneNo: '', callType: '' };
    this.centroUiState.resetAfterDispose();
    this.clearCentroSipEndTimer();
    this.stopWrapUpElapsedTimer();
  }

  private clearCentroCallUiOnly(): void {
    if (this.inputObj?.callingType !== 'centro') {
      return;
    }
    if (this.centroSip.isInCall() || this.centroSip.isRinging() || this.centroSipRinging) {
      console.log('[CentroUI] skip clearCentroCallUiOnly — SIP live');
      return;
    }
    if (this.centroUiState.getPhase() === 'ringing' || this.centroUiState.getPhase() === 'connected') {
      console.log('[CentroUI] skip clearCentroCallUiOnly during live leg');
      return;
    }
    this.centroAgentLegLive = false;
    this.centroOutboundActive = false;
    this.centroRemoteHangup = false;
    this.centroLiveLegEpoch = 0;
    this.centroUiState.resetAfterDispose();
    this.clearCentroSipEndTimer();
    this.clearCallerIdentityCache();
    this.lastCentroCaseSyncKey = '';
    this.lastCentroCaseSyncAt = 0;
    const isToggled = this.inputObj?.isToggled ?? false;
    this.inputObj = {
      ...this.inputObj,
      Status: 'Idle',
      isToggled,
      transferCall: false,
      holdCall: false,
      phoneNo: '',
      fullName: '',
      ucid: '',
      customerAnswered: false,
      recordId: '',
      crmDataId: '',
    };
    delete this.inputObj.dueId;
    delete this.inputObj.DueId;
    this.dialpadNumber = '';
    this.agentStatus = 'IDLE';
    this.centroStatusDetail = 'Ready';
    this.isMuted = false;
    this.showTimer = false;
    this.timer().stop();
    this.timerMinutes = 0;
    this.timerSeconds = 0;
    localStorage.removeItem('incomingCall');
    console.log('[CentroUI] clearCallUiOnly → Idle/Ready');
    this.publishCallState();
    this.cdr.detectChanges();
  }

  private prepareCentroNewCallDisplay(nextPhone?: string): void {
    if (this.inputObj?.callingType !== 'centro') {
      return;
    }
    const incoming = String(nextPhone || '').replace(/\D/g, '').slice(-10);
    const current = String(this.inputObj.phoneNo || '').replace(/\D/g, '').slice(-10);
    const idleUi = ['Idle', 'Disconnected', ''].includes(String(this.inputObj.Status || ''));
    const phoneChanged = incoming.length >= 10 && current.length >= 10 && incoming !== current;
    const newLeg = idleUi || phoneChanged || (!this.centroAgentLegLive && !this.centroWrapUpActive && !!current);
    if (!newLeg && incoming.length >= 10) {
      this.inputObj.phoneNo = incoming;
      this.inputObj.phoneNumber = incoming;
      return;
    }
    if (!newLeg) {
      return;
    }
    if (incoming.length >= 10) {
      this.centroLiveLegEpoch = this.centroUiState.beginNewLeg(incoming);
    }
    this.clearCallerIdentityCache();
    this.lastCentroCaseSyncKey = '';
    this.lastCentroCaseSyncAt = 0;
    this.inputObj.phoneNo = incoming.length >= 10 ? incoming : '';
    this.inputObj.phoneNumber = this.inputObj.phoneNo;
    this.inputObj.fullName = '';
    this.inputObj.ucid = '';
    this.inputObj.clientId = '';
    this.inputObj.recordId = '';
    this.inputObj.crmDataId = '';
    delete this.inputObj.dueId;
    delete this.inputObj.DueId;
    delete this.inputObj.callData;
  }

  private applyCentroSipDisplayPhone(sipPhone?: string): string {
    const digits = String(sipPhone || this.centroSip.getRemotePhone() || '').replace(/\D/g, '').slice(-10);
    const existing = String(this.inputObj?.phoneNo || '').replace(/\D/g, '').slice(-10);
    // Prefer SIP remote; keep existing CRM phone when SIP URI has no usable number yet.
    const phone = digits.length >= 10 ? digits : existing;
    if (phone.length >= 10) {
      this.prepareCentroNewCallDisplay(phone);
      this.inputObj.phoneNo = phone;
      this.inputObj.phoneNumber = phone;
      this.centroControlWs.setPhone(phone);
    }
    return phone;
  }

  private async refreshCentroCallDisplay(): Promise<void> {
    if (this.inputObj?.callingType !== 'centro') {
      return;
    }
    if (!this.canUpdateCallDisplay() && !this.centroSip.isInCall() && !this.centroSip.isRinging() && !this.centroSipRinging) {
      console.log('[CentroUI] refreshCallDisplay skipped', {
        status: this.inputObj?.Status,
        phase: this.centroUiState.getPhase(),
      });
      return;
    }
    try {
      const ctx: any = await firstValueFrom(this.callingService.centroGetCallContext());
      const enriched = this.centroDialerFlow.enrichFromApiContext(
        this.withCallerIdentity({ ...this.inputObj }),
        ctx
      );
      this.applyCallerDisplayFields(this.inputObj, enriched);
      if (enriched.phoneNo) {
        const lookup = await this.centroDialerFlow.lookupCase(
          enriched,
          this.inputObj.Status === 'CALLING' ? 'CALLING' : 'CONNECTED'
        );
        if (lookup) {
          this.applyCallerDisplayFields(this.inputObj, lookup);
        }
      }
      // Keep live Status — context refresh must not wipe CALLING/CONNECTED.
      const liveStatus = this.centroSip.isInCall()
        ? 'CONNECTED'
        : (this.centroSip.isRinging() || this.centroSipRinging ? 'CALLING' : this.inputObj.Status);
      this.inputObj = {
        ...this.inputObj,
        Status: liveStatus,
        phoneNo: this.inputObj.phoneNo || enriched.phoneNo || '',
        phoneNumber: this.inputObj.phoneNo || enriched.phoneNo || '',
      };
      console.log('[CentroUI] refreshCallDisplay', {
        status: this.inputObj.Status,
        phone: this.inputObj.phoneNo || '',
        fullName: this.inputObj.fullName || '',
        dueId: this.inputObj.dueId || '',
      });
      this.publishCallState(false);
      this.cdr.detectChanges();
    } catch (err: any) {
      console.warn('[CentroUI] refreshCallDisplay failed', err?.message || err);
    }
  }

  private mergeCentroCallContextFromSession(): void {
    if (!this.inputObj) {
      return;
    }
    const callRes = this.incomeCallService.getCallingRes();
    if (!callRes || callRes.callingType !== 'centro') {
      return;
    }
    if (callRes.dueId && !this.inputObj.dueId) {
      this.inputObj.dueId = callRes.dueId;
      this.inputObj.DueId = callRes.dueId;
    }
    if (callRes.clientId && !this.inputObj.clientId) {
      this.inputObj.clientId = callRes.clientId;
    }
    if (callRes.fullName && !this.inputObj.fullName) {
      this.inputObj.fullName = callRes.fullName;
    }
    const sessionPhone = String(callRes.phoneNo || '').replace(/\D/g, '').slice(-10);
    const currentPhone = String(this.inputObj.phoneNo || '').replace(/\D/g, '').slice(-10);
    if (sessionPhone.length >= 10 && (!currentPhone || sessionPhone === currentPhone)) {
      this.inputObj.phoneNo = sessionPhone;
    }
    if (callRes.phoneNo && ['CALLING', 'CONNECTED'].includes(String(callRes.Status || ''))) {
      this.centroOutboundActive = true;
    }
    if (!this.inputObj.callDirection) {
      this.inputObj.callDirection = callRes.callDirection || 'manual';
    }
  }

  private applyCentroManualDialResponse(result: any, phoneNo: string): void {
    this.prepareCentroNewCallDisplay(phoneNo);
    this.mergeCentroCallContextFromSession();
    const crmData = result?.callData?.crmRes?.data || result?.callData?.crmRes || {};
    const enriched = this.centroDialerFlow.enrichFromApiContext(
      this.withCallerIdentity({
        ...this.inputObj,
        phoneNo,
        recordId: result?.recordId,
        crmDataId: result?.crmDataId,
        campaignName: result?.campaignName || this.inputObj?.campaignName,
        callData: result?.callData,
        callDirection: 'manual',
        dueId: this.inputObj?.dueId,
        clientId: this.inputObj?.clientId,
        ...crmData,
      }),
      result
    );
    this.applyCallerDisplayFields(this.inputObj, enriched);
    this.centroLiveLegEpoch = this.centroUiState.beginNewLeg(phoneNo);
    this.centroOutboundActive = true;
    this.centroAgentLegLive = true;
    this.expandWidgetUi();
    this.inputObj.Status = 'CALLING';
    this.agentStatus = 'RINGING';
    void this.refreshCentroCallDisplay();
  }

  private async syncCentroCaseFromCall(status = 'CONNECTED'): Promise<void> {
    if (!this.inputObj || this.inputObj.callingType !== 'centro' || this.centroWrapUpActive) {
      return;
    }
    if (status !== 'CONNECTED') {
      return;
    }
    const enriched = this.centroDialerFlow.enrichCallDisplayData({
      ...this.inputObj,
      callDirection: this.inputObj.callDirection || 'manual',
    });
    const key = `${enriched.phoneNo}|${enriched.dueId}|${status}`;
    const now = Date.now();
    if (key && key === this.lastCentroCaseSyncKey && now - this.lastCentroCaseSyncAt < 2500) {
      return;
    }
    try {
      const caseData = await this.centroDialerFlow.openCaseFromCall(
        {
          ...enriched,
          Status: 'CONNECTED',
          customerAnswered: true,
        },
        'CONNECTED'
      );
      if (!caseData) {
        return;
      }
      this.lastCentroCaseSyncKey = key;
      this.lastCentroCaseSyncAt = now;
      this.applyCallerDisplayFields(this.inputObj, caseData);
      this.inputObj = {
        ...this.inputObj,
        ...caseData,
        callingType: 'centro',
        Status: status,
        phoneNo: caseData.phoneNo || this.inputObj.phoneNo || '',
        fullName: caseData.fullName || this.inputObj.fullName || '',
      };
      this.incomeCallService.setCallingRes(this.inputObj);
      try {
        localStorage.setItem('callingType', 'centro');
        localStorage.setItem('incomingCall', 'true');
      } catch (_e) {}
      this.cdr.markForCheck();
    } catch (_e) {}
  }

  private resolveCubeAutoDisposeReason(): string {
    const target = CallingComponent.CUBE_AUTO_DISPOSE_REASON.toLowerCase();
    const match = this.cubeDispositions.find(
      (d) => String(d.reason || '').trim().toLowerCase() === target
    );
    if (match?.reason) {
      return match.reason;
    }
    return this.cubeDispositions[0]?.reason || '';
  }

  /** Step 3 (UI): populate dropdown from S3 dialersDispositionList.json via OzonetelWrapUpService. */
  async loadOzonetelDispositions(): Promise<void> {
    if (!this.ozonetelWrapUpActive) {
      return;
    }
    this.ozonetelDispositionError = '';
    this.ozonetelDispositions = await this.ozonetelWrapUp.loadDispositions();
    if (!this.selectedOzonetelDisposition && this.ozonetelDispositions.length > 0) {
      this.selectedOzonetelDisposition = this.ozonetelDispositions[0].reason;
    }
    this.cdr.markForCheck();
  }

  /**
   * Step 4 (UI): agent Dispose click or autoDisposeCall() on timer expiry.
   * Delegates to OzonetelWrapUpService → sdk-core submitWrapUpDisposition → dc.setDisposition.
   * On success: resetOzonetelWrapUpState + clearCallDisplayState; sdk-core re-arms agent.
   * @param autoSubmit true when wrap timer fired — suppresses snackbars.
   */
  async submitOzonetelDisposition(autoSubmit = false): Promise<void> {
    if (!this.ozonetelWrapUpActive || this.ozonetelWrapUpSubmitInFlight) {
      return;
    }
    const reason = String(this.selectedOzonetelDisposition || '').trim();
    if (!reason) {
      if (!autoSubmit) {
        this.showErr('Select a disposition', 'Error');
      }
      return;
    }
    this.ozonetelWrapUpSubmitInFlight = true;
    this.ozonetelDispositionLoading = true;
    try {
      const result = await this.ozonetelWrapUp.submitDisposition(reason, this.ozonetelDispositionComment);
      if (result.success) {
        this.resetOzonetelWrapUpState();
        this.clearCallDisplayState();
        if (!autoSubmit) {
          this.showErr('Call disposed', 'OK');
        }
      } else if (!autoSubmit) {
        this.showErr(result.message || 'Failed to dispose call', 'Error');
      }
    } catch (error: any) {
      if (!autoSubmit) {
        this.showErr(error?.message || 'Failed to dispose call', 'Error');
      }
    } finally {
      this.ozonetelWrapUpSubmitInFlight = false;
      this.ozonetelDispositionLoading = false;
      this.cdr.markForCheck();
    }
  }

  /** Clears wrap-up UI state after successful disposition or external reset. */
  private resetOzonetelWrapUpState(): void {
    this.ozonetelWrapUpActive = false;
    this.ozonetelDispositions = [];
    this.selectedOzonetelDisposition = '';
    this.ozonetelDispositionComment = '';
    this.ozonetelDispositionError = '';
    this.ozonetelWrapUpSubmitInFlight = false;
    this.stopWrapUpElapsedTimer();
  }

  private startWrapUpElapsedTimer(): void {
    if (this.wrapUpElapsedInterval) {
      return;
    }
    this.wrapUpElapsedSeconds = 0;
    this.ozonetelAutoDisposeTriggered = false;
    this.cubeAutoDisposeTriggered = false;
    this.centroAutoDisposeTriggered = false;
    this.ngZone.run(() => {
      this.wrapUpElapsedInterval = setInterval(() => {
        this.ngZone.run(() => {
          this.wrapUpElapsedSeconds += 1;
          if (
            this.wrapUpElapsedSeconds === CallingComponent.OZONETEL_WRAPUP_AUTO_DISPOSE_SECONDS &&
            this.ozonetelWrapUpActive &&
            !this.ozonetelAutoDisposeTriggered
          ) {
            this.ozonetelAutoDisposeTriggered = true;
            this.autoDisposeCall();
          }
          if (
            this.wrapUpElapsedSeconds === CallingComponent.OZONETEL_WRAPUP_AUTO_DISPOSE_SECONDS &&
            this.cubeWrapUpActive &&
            !this.cubeAutoDisposeTriggered
          ) {
            this.cubeAutoDisposeTriggered = true;
            this.autoDisposeCall();
          }
          if (
            this.wrapUpElapsedSeconds === CallingComponent.OZONETEL_WRAPUP_AUTO_DISPOSE_SECONDS &&
            this.centroWrapUpActive &&
            !this.centroAutoDisposeTriggered
          ) {
            this.centroAutoDisposeTriggered = true;
            this.autoDisposeCall();
          }
          this.cdr.detectChanges();
        });
      }, 1000);
    });
  }

  private stopWrapUpElapsedTimer(): void {
    this.wrapUpElapsedSeconds = 0;
    this.ozonetelAutoDisposeTriggered = false;
    this.cubeAutoDisposeTriggered = false;
    this.centroAutoDisposeTriggered = false;
    if (this.wrapUpElapsedInterval) {
      clearInterval(this.wrapUpElapsedInterval);
      this.wrapUpElapsedInterval = undefined;
    }
  }

  private resolveCentroAutoDisposeReason(): string {
    const target = CallingComponent.CENTRO_AUTO_DISPOSE_REASON.toLowerCase();
    const match = this.centroDispositions.find(
      (d) => String(d.reason || '').trim().toLowerCase() === target
    );
    if (match?.reason) {
      return match.reason;
    }
    return this.centroDispositions[0]?.reason || '';
  }

  /** Resolve "Auto Dispose" from loaded list; fallback to first item if missing. */
  private resolveOzonetelAutoDisposeReason(): string {
    const target = CallingComponent.OZONETEL_AUTO_DISPOSE_REASON.toLowerCase();
    const match = this.ozonetelDispositions.find(
      (d) => String(d.reason || '').trim().toLowerCase() === target
    );
    if (match?.reason) {
      return match.reason;
    }
    return this.ozonetelDispositions[0]?.reason || '';
  }

  /** Safety reset if SDK no longer reports wrap-up pending. */
  private cancelOzonetelWrapUpIfNeeded(): void {
    if (this.ozonetelWrapUpActive && !this.ozonetelWrapUp.isWrapUpActive()) {
      this.resetOzonetelWrapUpState();
    }
  }

  /** Clears retry/transfer delay timers for auto-transfer. */
  private clearCubeAutoTransferTimers(): void {
    this.cubeAutoTransferTimerIds.forEach((id) => clearTimeout(id));
    this.cubeAutoTransferTimerIds = [];
  }

  /** New call leg detected → reset per-leg auto-transfer attempt state. */
  private syncCubeActiveLeg(state: CubeCallUiState): void {
    const legKey = this.resolveCubeAutoTransferCallRef(state);
    const phoneKey = this.cubeDialerFlow.getPhoneNumber(state);
    const nextKey = phoneKey || legKey;
    if (!nextKey || nextKey === 'active-leg') {
      return;
    }
    if (this.cubeActiveLegKey === nextKey) {
      return;
    }
    const prevKey = this.cubeActiveLegKey;
    const transferArmed =
      this.cubeAutoTransferLegAttempted ||
      this.cubeAutoTransferTotalSends > 0 ||
      this.cubeAutoTransferExhausted ||
      this.cubeAutoTransferPendingRelease ||
      this.cubeDummyTransferReleased ||
      !!this.cubeAutoTransferRunner ||
      this.cubeConnector.isCubeTransferDispatched();
    const liveCall =
      this.cubeConnector.isCallSessionActive() ||
      this.inputObj?.Status === 'CALLING' ||
      this.inputObj?.Status === 'CONNECTED' ||
      state?.Status === 'CALLING' ||
      state?.Status === 'CONNECTED';
    if (transferArmed || liveCall) {
      this.cubeLog('syncCubeActiveLeg', {
        prev: prevKey || '(none)',
        next: nextKey,
        keepAttempts: true,
        transferArmed,
        liveCall,
        sends: this.cubeAutoTransferTotalSends,
      });
      this.cubeActiveLegKey = nextKey;
      return;
    }
    this.cubeLog('syncCubeActiveLeg', { prev: prevKey || '(none)', next: nextKey });
    this.cubeActiveLegKey = nextKey;
    this.clearCallerIdentityCache();
    this.resetCubeAutoTransferSession();
    if (phoneKey && prevKey && phoneKey !== prevKey && this.inputObj?.callingType === 'cube') {
      this.inputObj.holdCall = false;
      this.inputObj.fullName = '';
      this.inputObj.dueId = undefined;
      this.inputObj.clientId = undefined;
      this.lastCubeSyncKey = '';
    }
  }

  /** Handles connector callEnded$: wrap-up entry, blind-transfer release, or full UI reset. */
  private onCubeCallEnded(payload?: unknown): void {
    const reason = String((payload as { reason?: string })?.reason || 'callEnded');
    const via = String((payload as { via?: string })?.via || '');
    this.cubeLog('onCubeCallEnded', { reason, via, inProgress: this.cubeCallLegResetInProgress });
    if (this.cubeCallLegResetInProgress) {
      return;
    }
    if (reason === 'blind_transfer' || via === 'release_dummy') {
      this.cubeDummyTransferReleased = true;
      this.cubeAutoTransferRouting = false;
      this.cubeAutoTransferTargetLabel = '';
      this.cubeConnector.setTransferRouting(false);
      this.clearCubeCallUiOnly(reason);
      this.cdr.markForCheck();
      return;
    }
    if (this.cubeWrapUpActive && reason !== 'disposition') {
      return;
    }
    if (this.cubeConnector.isWrapUpPending() && reason !== 'disposition') {
      if (!this.cubeWrapUpActive) {
        this.enterCubeWrapUp(payload);
      }
      return;
    }
    const spuriousEnd =
      reason === 'idle-sync' ||
      reason === 'reconcile-iframe-idle' ||
      reason === 'reconcile-stale' ||
      reason === 'reconcile-stale-display' ||
      reason === 'iframe_idle_flush' ||
      reason === 'connector-ready' ||
      reason === 'residual_idle' ||
      reason === 'widget_iframe_idle' ||
      reason === 'widget-iframe-idle' ||
      reason === 'widget-stale-ready' ||
      reason === 'widget-stale-display';
    if (spuriousEnd) {
      const stillLive =
        this.cubeConnector.hasActiveOrWrapUpLeg() ||
        this.cubeConnector.isCallSessionActive() ||
        this.cubeConnector.isAwaitingAgentAnswer() ||
        this.cubeConnector.isManualDialerCall() ||
        this.cubeConnector.isCubeIframeAgentConnected() ||
        this.inputObj?.Status === 'CALLING' ||
        this.inputObj?.Status === 'CONNECTED' ||
        this.inputObj?.Status === 'Disconnected';
      if (stillLive) {
        this.cubeLog('onCubeCallEnded', { skip: 'still_live', reason });
        return;
      }
      if (this.inputObj?.Status === 'Idle' && !this.inputObj?.phoneNo) {
        return;
      }
    }
    if (reason === 'disposition') {
      this.cubeCallLegResetInProgress = true;
      try {
        this.cubeCallEndHandledAt = Date.now();
        this.resetCubeWrapUpState();
        this.clearCubeAutoTransferTimers();
        this.stopCubeAutoTransfer(reason);
        this.resetCubeAutoTransferSession();
        this.clearAllCubeDialerCaches(reason);
        this.clearCubeCallUiOnly(reason);
      } finally {
        this.cubeCallLegResetInProgress = false;
      }
      return;
    }
    const hadConnectedCall = this.cubeConnector.wasCallConnected();
    const agentEnded = reason === 'agent_hangup' || reason === 'ui_arm';
    if (this.cubeConnector.canShowDisposition(reason) && !this.cubeDummyTransferReleased) {
      this.enterCubeWrapUp(payload || { ...this.inputObj, reason });
      return;
    }
    if (
      !hadConnectedCall &&
      (this.cubeConnector.isRingingUnanswered() ||
        this.inputObj?.Status === 'CALLING' ||
        this.cubeConnector.isCallLegActive())
    ) {
      this.cubeLog('onCubeCallEnded', { skip: 'still_ringing', reason });
      return;
    }
    if (agentEnded && !hadConnectedCall) {
      this.cubeLog('onCubeCallEnded', { skip: 'agent_end_no_connect', reason });
    }
    this.cubeCallLegResetInProgress = true;
    try {
      this.cubeCallEndHandledAt = Date.now();
      this.clearCubeAutoTransferTimers();
      this.stopCubeAutoTransfer(reason);
      this.resetCubeAutoTransferSession();
      this.cubeConferenceDialStarted = false;
      this.cubeSelectedTransferAgent = '';
      this.cubeConnector.clearRingState();
      this.cubeConnector.setTransferRouting(false);
      this.clearAllCubeDialerCaches(reason);
      this.clearCubeCallUiOnly(reason);
      this.lastCubeReconcileKey = '';
    } finally {
      this.cubeCallLegResetInProgress = false;
    }
  }

  /** Wipes connector caches and widget caller identity after leg ends. */
  private clearAllCubeDialerCaches(source = 'clear'): void {
    this.cubeLog('clearAllCubeDialerCaches', { source });
    this.lastCubeSyncKey = '';
    this.lastCubeReconcileKey = '';
    this.lastCubeCaseSyncKey = '';
    this.lastCubeCaseSyncAt = 0;
    this.lastCaseSyncKey = '';
    this.lastCaseSyncAt = 0;
    this.lastAutoUnholdUcid = '';
    this.cubeActiveLegKey = '';
    this.callerIdentityCache = {};
    this.cubeCampaignAgentsCacheKey = '';
    this.cubeCampaignAgentsCache = [];
    this.cubeConnector.clearCallSessionCaches();
  }

  /** AgentId + login campaign from localStorage remarks.cubeDetails. */
  private getCubeLoginAgentAndCampaign(): { agentId: string; loginCampaign: string } {
    const details = this.getCubeDetailsFromRemarks() || {};
    const loginCampaign = String(
      details.CampaignId ||
        details.campaignId ||
        details.CampaignID ||
        details.campaignID ||
        details.Campaign ||
        details.campaign ||
        ''
    ).trim();
    const agentId = String(details.AgentId || details.agentId || details.agentID || '').trim();
    return { agentId, loginCampaign };
  }

  /**
   * Dummy → real auto-transfer target.
   * Fetches campaign agents (treated as "online"), then picks a JSON activeUser from that list.
   * An idle real user is used only if this API returns their AgentId.
   */
  private async resolveCubeAutoTransferProfileOnline(): Promise<CubeAutoTransferProfile> {
    const { agentId, loginCampaign } = this.getCubeLoginAgentAndCampaign();
    console.log('[CubeAutoTransfer] resolve online profile', { dummyAgentId: agentId, loginCampaign });
    const stub = resolveCubeAutoTransferProfile(agentId, loginCampaign);
    if (!stub.loginCampaign || !stub.targetCampaign) {
      console.log('[CubeAutoTransfer] resolve online skipped — dummy/campaign not configured', stub);
      return stub;
    }
    if (
      this.cubeAutoTransferResolvedTarget &&
      this.cubeAutoTransferResolvedCampaign &&
      this.normalizeCampaignName(this.cubeAutoTransferResolvedCampaign) ===
        this.normalizeCampaignName(stub.targetCampaign)
    ) {
      console.log('[CubeAutoTransfer] using cached real target', {
        targetAgentId: this.cubeAutoTransferResolvedTarget,
        targetCampaign: this.cubeAutoTransferResolvedCampaign,
      });
      return {
        enabled: true,
        targetAgentId: this.cubeAutoTransferResolvedTarget,
        targetCampaign: this.cubeAutoTransferResolvedCampaign,
        loginCampaign: stub.loginCampaign,
      };
    }
    const agents = await this.fetchCubeAgentsForCampaign(stub.targetCampaign, 'autoTransfer');
    const onlineIds = agents.map((a) => a.AgentId).filter(Boolean);
    console.log('[CubeAutoTransfer] campaign agent API (online list for idle/real pick)', {
      targetCampaign: stub.targetCampaign,
      count: onlineIds.length,
      onlineIds,
    });
    const profile = resolveCubeAutoTransferProfile(agentId, loginCampaign, onlineIds);
    if (profile.enabled) {
      this.cubeAutoTransferResolvedCampaign = profile.targetCampaign;
      this.cubeAutoTransferResolvedTarget = profile.targetAgentId;
    }
    return profile;
  }

  private isCubeManualCall(eventData?: any): boolean {
    return (
      this.cubeConnector.isManualDialerCall() ||
      eventData?.callDirection === 'manual' ||
      this.inputObj?.callDirection === 'manual'
    );
  }

  private isCubeOutboundAutoTransferBlocked(eventData?: any): boolean {
    return this.isCubeManualCall(eventData) || this.cubeConnector.isAgentOriginatedOutbound();
  }

  /** True when logged-in dummy agent receives a call on a configured JSON campaign. */
  private isCubeCampaignAutoTransferCall(eventData?: any): boolean {
    if (!this.isCubeWebphone || !this.inputObj) {
      return false;
    }
    if (this.isCubeOutboundAutoTransferBlocked(eventData)) {
      return false;
    }
    const { agentId, loginCampaign } = this.getCubeLoginAgentAndCampaign();
    if (!isCubeAutoTransferDummyEligible(agentId, loginCampaign)) {
      return false;
    }
    const route = resolveCubeAutoTransferProfile(agentId, loginCampaign);
    if (!route.loginCampaign) {
      return false;
    }
    const sourceCampaign = this.resolveCubeConnectedCampaignName(eventData);
    const ok =
      !!sourceCampaign &&
      this.isCubeAutoTransferSourceCampaign(sourceCampaign) &&
      this.normalizeCampaignName(sourceCampaign) === this.normalizeCampaignName(route.loginCampaign);
    return ok;
  }

  /** Starts dummy → real auto-transfer if this campaign call is eligible and not already sent. */
  private queueCubeAutoTransfer(eventData: any): void {
    if (!this.isCubeWebphone) {
      return;
    }
    if (this.isCubeOutboundAutoTransferBlocked(eventData)) {
      console.log('[CubeAutoTransfer] queue skip: outbound/manual call');
      this.cubeLog('queueCubeAutoTransfer', { skip: 'outbound_call' });
      return;
    }
    if (!this.isCubeCampaignAutoTransferCall(eventData)) {
      console.log('[CubeAutoTransfer] queue skip: not dummy campaign source');
      this.cubeLog('queueCubeAutoTransfer', { skip: 'not_campaign_json_source' });
      return;
    }
    if (shouldUseCubeSdk() && !this.isDummyReadyForSdkRedirect()) {
      console.log('[CubeAutoTransfer] queue wait: dummy has not accepted yet', {
        status: this.inputObj?.Status,
      });
      this.cubeLog('queueCubeAutoTransfer', { skip: 'wait_dummy_connected' });
      return;
    }
    if (this.cubeDummyTransferReleased) {
      console.log('[CubeAutoTransfer] queue skip: dummy already released');
      this.cubeLog('queueCubeAutoTransfer', { skip: 'dummy_released' });
      return;
    }
    if (this.shouldRetrySdkRedirectAfterFailedHop()) {
      console.log('[CubeAutoTransfer] retry: dummy still on call after earlier hop');
      this.unlockCubeAutoTransferForRetry();
    }
    if (this.cubeAutoTransferExhausted) {
      console.log('[CubeAutoTransfer] queue skip: already exhausted this leg');
      this.cubeLog('queueCubeAutoTransfer', { skip: 'exhausted' });
      return;
    }
    if (this.cubeConnector.isCubeTransferDispatched() || this.cubeAutoTransferPendingRelease) {
      console.log('[CubeAutoTransfer] queue skip: transfer already dispatched');
      this.cubeLog('queueCubeAutoTransfer', { skip: 'already_dispatched' });
      return;
    }
    if (this.cubeAutoTransferTotalSends >= CallingComponent.CUBE_AUTO_TRANSFER_MAX_ATTEMPTS) {
      this.cubeAutoTransferExhausted = true;
      console.log('[CubeAutoTransfer] queue skip: max sends', this.cubeAutoTransferTotalSends);
      this.cubeLog('queueCubeAutoTransfer', { skip: 'max_sends', sends: this.cubeAutoTransferTotalSends });
      return;
    }
    if (this.cubeAutoTransferLegAttempted) {
      console.log('[CubeAutoTransfer] queue skip: already attempted this leg');
      this.cubeLog('queueCubeAutoTransfer', { skip: 'leg_attempted' });
      return;
    }
    if (this.cubeAutoTransferRunner) {
      console.log('[CubeAutoTransfer] queue skip: runner already active');
      this.cubeLog('queueCubeAutoTransfer', { skip: 'runner_active' });
      return;
    }
    console.log('[CubeAutoTransfer] queue start — dummy will try real/idle activeUser');
    this.cubeLog('queueCubeAutoTransfer', { start: true, sends: this.cubeAutoTransferTotalSends });
    this.cubeAutoTransferRunner = this.runCubeDummyToActiveAutoTransfer(eventData).finally(() => {
      this.cubeAutoTransferRunner = null;
      console.log('[CubeAutoTransfer] queue done', { sends: this.cubeAutoTransferTotalSends });
      this.cubeLog('queueCubeAutoTransfer', { done: true, sends: this.cubeAutoTransferTotalSends });
    });
  }

  private isDummyReadyForSdkRedirect(): boolean {
    return this.inputObj?.Status === 'CONNECTED' || this.cubeConnector.isCallConnected();
  }

  private dummyStillHoldingAutoTransferCall(): boolean {
    if (this.cubeDummyTransferReleased || this.cubeAutoTransferPendingRelease) {
      return false;
    }
    const status = this.inputObj?.Status;
    if (status === 'Idle' || status === 'Disconnected') {
      return false;
    }
    return (
      this.cubeConnector.isCallSessionActive() &&
      (this.isDummyReadyForSdkRedirect() || status === 'CALLING')
    );
  }

  private shouldRetrySdkRedirectAfterFailedHop(): boolean {
    return (
      shouldUseCubeSdk() &&
      this.dummyStillHoldingAutoTransferCall() &&
      this.cubeAutoTransferTotalSends < CallingComponent.CUBE_AUTO_TRANSFER_MAX_ATTEMPTS
    );
  }

  private unlockCubeAutoTransferForRetry(): void {
    this.cubeAutoTransferExhausted = false;
    this.cubeAutoTransferLegAttempted = false;
    this.cubeAutoTransferPendingRelease = false;
    this.cubeConnector.clearTransferDispatchForRetry();
  }

  /** Forces full call-leg reset: caches, UI, auto-transfer session. */
  private hardResetCubeCallLeg(source = 'reset'): void {
    this.cubeLog('hardResetCubeCallLeg', { source });
    if (this.cubeCallLegResetInProgress) {
      return;
    }
    this.cubeCallLegResetInProgress = true;
    try {
      this.clearCubeAutoTransferTimers();
      this.stopCubeAutoTransfer(source);
      this.resetCubeAutoTransferSession();
      this.cubeActiveLegKey = '';
      this.cubeDummyTransferReleased = false;
      this.cubeConferenceDialStarted = false;
      this.cubeSelectedTransferAgent = '';
      this.lastCubeCaseSyncKey = '';
      this.lastCubeCaseSyncAt = 0;
      this.lastCubeSyncKey = '';
      this.cubeConnector.clearRingState();
      this.clearCubeCallUiOnly(source);
      this.cubeConnector.hardResetCallState(source);
    } finally {
      this.cubeCallLegResetInProgress = false;
    }
  }

  /** Clears transfer routing UI without marking session exhausted (e.g. connector-ready cleanup). */
  private cancelCubeAutoTransferRouting(source = 'cancel'): void {
    this.cubeLog('cancelCubeAutoTransferRouting', { source });
    this.cubeAutoTransferRouting = false;
    this.cubeAutoTransferTargetLabel = '';
    this.cubeConnector.setTransferRouting(false);
  }

  /** Stops auto-transfer for this leg; sets exhausted only after real attempts or explicit failure. */
  private stopCubeAutoTransfer(source = 'stop', markExhausted = true, recordAttempted = false): void {
    this.cubeLog('stopCubeAutoTransfer', {
      source,
      sends: this.cubeAutoTransferTotalSends,
      exhausted: this.cubeAutoTransferExhausted,
      markExhausted,
      recordAttempted,
    });
    if (markExhausted || this.cubeAutoTransferTotalSends > 0) {
      this.cubeAutoTransferExhausted = true;
    }
    this.cubeAutoTransferRouting = false;
    this.cubeAutoTransferTargetLabel = '';
    this.cubeConnector.setTransferRouting(false);
    if (!recordAttempted) {
      return;
    }
    const targetCampaign =
      this.cubeAutoTransferResolvedCampaign || this.cubeAutoTransferPendingCampaign;
    const targetAgentId =
      this.cubeAutoTransferResolvedTarget || this.cubeAutoTransferPendingTarget;
    const callRef = this.resolveCubeAutoTransferCallRef(this.inputObj);
    if (callRef && targetCampaign && targetAgentId) {
      this.autoTransferAttemptedKeys.add(
        this.buildCubeAutoTransferKey(callRef, targetCampaign, targetAgentId)
      );
    }
  }

  /** Resets per-leg transfer counters when a new call leg (phone ref) begins. */
  private resetCubeAutoTransferSession(): void {
    this.cubeLog('resetCubeAutoTransferSession', { leg: this.cubeActiveLegKey });
    this.cubeAutoTransferExhausted = false;
    this.cubeAutoTransferLegAttempted = false;
    this.cubeAutoTransferTotalSends = 0;
    this.cubeAutoTransferRouting = false;
    this.cubeAutoTransferTargetLabel = '';
    this.cubeDummyTransferReleased = false;
    this.cubeAutoTransferPendingRelease = false;
    this.cubeAutoTransferPendingKey = '';
    this.cubeAutoTransferPendingCampaign = '';
    this.cubeAutoTransferPendingTarget = '';
    this.cubeAutoTransferResolvedCampaign = '';
    this.cubeAutoTransferResolvedTarget = '';
    this.autoTransferAttemptedKeys.clear();
    this.autoTransferInFlightKeys.clear();
    this.cubeAutoTransferWaitKeys.clear();
    this.cubeAutoTransferSendCounts.clear();
    this.cubeCampaignAgentsCacheKey = '';
    this.cubeCampaignAgentsCache = [];
  }

  /** Clears widget caller display; skipped during wrap-up unless disposition submitted. */
  private clearCubeCallUiOnly(source = 'clear'): void {
    if (
      this.inputObj?.Status === 'Idle' &&
      !this.inputObj?.phoneNo &&
      !this.inputObj?.fullName &&
      this.agentStatus === 'IDLE'
    ) {
      this.cubeLog('clearCubeCallUiOnly', { source, skip: 'already_idle' });
      return;
    }
    this.cubeLog('clearCubeCallUiOnly', {
      source,
      prevStatus: this.inputObj?.Status,
      prevPhone: this.inputObj?.phoneNo || '',
    });
    this.clearAllCubeDialerCaches(source);
    const isToggled = this.inputObj?.isToggled ?? false;
    if (this.inputObj?.callingType === 'cube') {
      this.inputObj = {
        ...this.cubeDialerFlow.toCallingState({}, 'Idle'),
        isToggled,
        callingType: 'cube',
        transferCall: false,
        customerAnswered: false,
        phoneNo: '',
        phoneNumber: '',
        fullName: '',
        holdCall: false,
        dueId: undefined,
        clientId: undefined,
        ucid: undefined,
        campaignName: '',
      };
      delete (this.inputObj as any).RedirectToAgentId;
      delete (this.inputObj as any).RedirectToCampaignId;
      this.agentStatus = 'IDLE';
    }
    this.bumpCallUiEpoch();
    this.stopManualDialConnectWatch();
    this.callData = null;
    this.isMuted = false;
    this.showTimer = false;
    this.fullScreen = true;
    this.showBody = false;
    this.timer().stop();
    this.timerMinutes = 0;
    this.timerSeconds = 0;
    delete (this.inputObj as any)._isDisconnecting;
    localStorage.removeItem('incomingCall');
    this.publishCallState();
    this.cdr.markForCheck();
  }

  private clearCallDisplayState(): void {
    const isToggled = this.inputObj?.isToggled ?? false;
    if (this.inputObj?.callingType === 'ozonetel') {
      const base = this.ozonetelDialerFlow.toIdleCallingState(this.inputObj);
      this.inputObj = { ...base, isToggled, transferCall: false };
    } else if (this.inputObj?.callingType === 'cube') {
      this.inputObj = {
        ...this.cubeDialerFlow.toCallingState(this.inputObj, 'Idle'),
        isToggled,
        transferCall: false,
        customerAnswered: false,
        phoneNo: '',
      };
      this.agentStatus = 'IDLE';
    } else if (this.inputObj?.callingType === 'centro') {
      if (this.centroWrapUpActive) {
        return;
      }
      this.inputObj = {
        ...this.inputObj,
        Status: 'Idle',
        isToggled,
        transferCall: false,
        holdCall: false,
        phoneNo: '',
        fullName: '',
        ucid: '',
        customerAnswered: false,
      };
      this.dialpadNumber = '';
    } else {
      this.inputObj = { ...this.inputObj, Status: 'Idle', isToggled, transferCall: false };
    }
    this.bumpCallUiEpoch();
    this.stopManualDialConnectWatch();
    this.clearCallerIdentityCache();
    this.callData = null;
    this.lastAutoUnholdUcid = '';
    this.lastCaseSyncKey = '';
    this.lastCaseSyncAt = 0;
    this.cubeAutoTransferRouting = false;
    this.cubeAutoTransferTargetLabel = '';
    this.lastCubeSyncKey = '';
    this.lastCubeCaseSyncKey = '';
    this.lastCubeCaseSyncAt = 0;
    this.isMuted = false;
    this.showTimer = false;
    this.fullScreen = true;
    this.showBody = false;
    this.timer().stop();
    this.timerMinutes = 0;
    this.timerSeconds = 0;
    delete (this.inputObj as any)._isDisconnecting;
    this.publishCallState();
  }

  private applyOzonetelCallingState(callData: any, status: string) {
    if (!this.inputObj || !this.canUpdateCallDisplay()) {
      return;
    }

    if (status === 'CONNECTED' || status === 'CALLING' || status === 'RINGING') {
      this.expandWidgetUi();
    }

    const merged = this.ozonetelDialerFlow.enrichCallDisplayData(
      this.withCallerIdentity({
        ...this.inputObj,
        ...(callData || {}),
      })
    );

    const nextInputObj = {
      ...this.inputObj,
      Status: status,
      callingType: 'ozonetel',
    };

    const existingName = this.ozonetelDialerFlow.resolveFullName(this.inputObj);

    [
      'dueId',
      'DueId',
      'phoneNo',
      'phoneNumber',
      'ucid',
      'did',
      'communicationDetailId',
      'commDetId',
      'clientId',
      'campaignName',
    ].forEach((key) => {
      if (merged?.[key] !== undefined && merged?.[key] !== null && merged?.[key] !== '') {
        nextInputObj[key] = merged[key];
      }
    });

    const incomingName = this.ozonetelDialerFlow.resolveFullName(merged);
    const resolvedName = incomingName || existingName;
    if (resolvedName) {
      nextInputObj.fullName = resolvedName;
      this.rememberCallerIdentity({ ...merged, fullName: resolvedName });
    } else if (
      nextInputObj.fullName &&
      String(nextInputObj.fullName).trim().toLowerCase() === 'unknown'
    ) {
      delete nextInputObj.fullName;
    }

    this.inputObj = nextInputObj;
  }

  // Fetch call data from SDK
  async fetchCallData() {
    if (!this.ozonetelSDKCore.isAgentInitialized() || !this.canUpdateCallDisplay()) {
      return;
    }
    const epoch = this.callUiEpoch;
    try {
      const data = await this.ozonetelSDKCore.getCallData();
      if (epoch !== this.callUiEpoch || !this.canUpdateCallDisplay()) {
        return;
      }
      if (!data || !this.ozonetelSDKCore.isLiveCallData(data)) {
        if (this.inputObj?.Status === 'CALLING' && this.inputObj?.phoneNo) {
          return;
        }
        if (!this.ozonetelSDKCore.isCallSessionActive()) {
          this.callData = null;
          return;
        }
      }
      this.callData = data;
      if (this.inputObj && this.callData) {
          const display = this.ozonetelDialerFlow.enrichCallDisplayData(
            this.withCallerIdentity({
              ...this.inputObj,
              ...this.callData,
            })
          );
          this.applyCallerDisplayFields(this.inputObj, display);
          if (display.campaignName || this.callData.campaignName || this.callData.campignId) {
            this.inputObj.campaignName =
              display.campaignName || this.callData.campaignName || this.callData.campignId;
          }
          if (['CALLING', 'CONNECTED'].includes(this.inputObj.Status)) {
            this.inputObj = { ...this.inputObj };
            this.publishCallState(false);
          }
          if (this.inputObj.Status === 'CONNECTED') {
            void this.ensureTransferLegUnheld(this.callData);
            // Auto-transfer runs after live call data is available (campaign, ucid, did).
            void this.maybeAutoTransferConnectedCall(display);
          }
        }
      } catch (e) {
        console.warn('[CallingWidget] Could not fetch call data:', e);
      }
  }

  private async ensureTransferLegUnheld(data: any): Promise<void> {
    if (
      !this.ozonetelSDKCore.isAgentInitialized() ||
      !this.inputObj ||
      this.inputObj.Status !== 'CONNECTED'
    ) {
      return;
    }
    const isTransfer =
      this.inputObj.transferCall || this.ozonetelTransfer.isTransferredCall(data);
    if (!isTransfer) {
      return;
    }
    const d = data || {};
    const ucid = String(d?.ucid || d?.UCID || this.inputObj?.ucid || '').trim();
    if (this.autoUnholdInFlight || (ucid && ucid === this.lastAutoUnholdUcid)) {
      return;
    }

    this.autoUnholdInFlight = true;
    try {
      for (let i = 0; i < 8; i++) {
        const result = await this.ozonetelSDKCore.forceUnholdActiveCall();
        if (result?.success) {
          this.inputObj.holdCall = false;
          this.inputObj = { ...this.inputObj };
          if (ucid) {
            this.lastAutoUnholdUcid = ucid;
          }
          return;
        }
        if (i < 7) {
          await new Promise((r) => setTimeout(r, 700 + i * 350));
        }
      }
    } catch (e) {
      console.warn('[CallingWidget] Auto-unhold for connected transfer leg failed:', e);
    } finally {
      this.autoUnholdInFlight = false;
    }
  }

  // UI Helper Methods
  get isBreakActive(): boolean {
    if (this.inputObj?.callingType === 'cube' && this.isCubeWebphone) {
      return !!(this.inputObj?.pauseCall || this.cubeConnector.isAgentOnBreak());
    }
    return !!this.inputObj?.pauseCall;
  }

  getStatusClass(): string {
    if (this.isBreakActive || this.agentStatus === 'PAUSED') return 'status-break';
    if (this.agentStatus === 'NOT_READY') return 'status-not-ready';
    if (
      this.agentStatus === 'DISCONNECTED' ||
      this.agentStatus === 'ERROR' ||
      this.agentStatus === 'UNKNOWN' ||
      (this.inputObj?.callingType === 'cube' &&
        (this.cubeConnector.getCurrentStatus() === 'failed' ||
          this.cubeConnector.getCurrentStatus() === 'logged_out'))
    ) {
      return 'status-not-ready';
    }
    if (this.inputObj?.callingType === 'cube') {
      if (this.isCubeAutoTransferRouting) return 'status-calling';
      if (this.inputObj?.Status === 'CONNECTED') return 'status-connected';
      if (this.inputObj?.Status === 'CALLING' || this.agentStatus === 'RINGING') return 'status-calling';
    }
    if (this.agentStatus === 'BUSY' && (this.isOnCall || this.inputObj?.callingType === 'cube')) return 'status-connected';

    // Then check call status
    switch (this.inputObj?.Status) {
      case 'CALLING': return 'status-calling';
      case 'CONNECTED': return 'status-connected';
      case 'Disconnected': return 'status-disconnected';
      case 'Break': return 'status-break';
      case 'Idle': return 'status-idle';
      default: return 'status-idle';
    }
  }

  getStatusText(): string {
    if (this.inputObj?.callingType === 'centro') {
      if (this.agentStatus === 'ERROR') {
        return this.centroStatusDetail || 'Centro connect failed';
      }
      if (this.agentStatus === 'DISCONNECTED') {
        return this.centroStatusDetail || 'Not connected';
      }
      if (this.agentStatus === 'CONNECTING...' || !this.centroReady) {
        return this.centroStatusDetail || 'Connecting to Centro...';
      }
      if (this.agentStatus === 'NOT_READY' || !this.centroBrowserSipReady) {
        return this.centroStatusDetail || 'SIP not registered';
      }
      if (this.centroWrapUpActive && !this.centroSip.isInCall() && !this.centroSipRinging) {
        if (this.inputObj?.pauseCall || this.agentStatus === 'PAUSED') {
          return `Wrap-up · ${this.inputObj?.breakValue || 'On break'}`;
        }
        return 'Wrap-up';
      }
      if (this.inputObj?.pauseCall || this.agentStatus === 'PAUSED') {
        return this.inputObj?.breakValue || 'On break';
      }
      if (this.centroSip.isInCall() || this.inputObj?.Status === 'CONNECTED') {
        return this.inputObj.holdCall ? 'On Hold' : 'On Call';
      }
      if (this.centroSip.isRinging() || this.centroSipRinging || this.inputObj?.Status === 'CALLING') {
        return 'Dialing...';
      }
      return this.centroStatusDetail || 'Ready';
    }

    if (this.inputObj?.callingType === 'cube') {
      if (this.agentStatus === 'ERROR' || this.cubeConnector.getCurrentStatus() === 'failed') {
        return 'Login failed';
      }
      if (this.agentStatus === 'DISCONNECTED' || this.cubeConnector.getCurrentStatus() === 'logged_out') {
        return 'Not logged in';
      }
      if (this.agentStatus === 'CONNECTING...' || this.cubeConnector.getCurrentStatus() === 'logging_in') {
        return 'Connecting...';
      }
      if (this.cubeConnector.isAnswerInFlight()) {
        return 'Connecting...';
      }
      if (
        this.inputObj?.Status === 'CONNECTED' ||
        this.cubeConnector.isCallConnected() ||
        this.cubeConnector.isCubeIframeAgentConnected() ||
        this.cubeConnector.isAnswerInFlight() ||
        (this.cubeConnector.getCurrentStatus() === 'on_call' &&
          (this.cubeConnector.callState$.getValue()?.Status === 'CONNECTED' ||
            this.cubeConnector.isCallLegActive() ||
            !!this.inputObj?.phoneNo))
      ) {
        return this.inputObj?.holdCall ? 'On Hold' : 'On Call';
      }
      if (
        this.cubeConnector.isAwaitingAgentAnswer() &&
        this.cubeConnector.getCurrentStatus() !== 'on_call' &&
        !this.cubeConnector.isAnswerInFlight()
      ) {
        if (this.cubeWrapUpActive || this.cubeConnector.isWrapUpPending()) {
          return 'Call Ended';
        }
        if (this.isCubeAutoTransferRouting) {
          return this.cubeAutoTransferTargetLabel
            ? `Transferring to ${this.cubeAutoTransferTargetLabel}...`
            : 'Transferring...';
        }
        return 'Answer your dialer';
      }
      if (this.isCubeAutoTransferRouting) {
        return this.cubeAutoTransferTargetLabel
          ? `Transferring to ${this.cubeAutoTransferTargetLabel}...`
          : 'Transferring...';
      }
      if (this.inputObj?.pauseCall || this.inputObj?.Status === 'Break' || this.agentStatus === 'PAUSED') {
        return this.inputObj?.breakValue || 'On Break';
      }
      if (this.inputObj?.Status) {
        switch (this.inputObj.Status) {
          case 'CALLING':
            if (this.isOnCall && !this.isCubeAgentRinging) {
              return 'On Call';
            }
            return this.inputObj?.customerAnswered ? 'Customer answered — answer your dialer' : 'Dialing customer...';
          case 'CONNECTED':
            return this.inputObj?.holdCall ? 'On Hold' : 'On Call';
          case 'Disconnected': return this.cubeWrapUpActive ? 'Call Ended' : 'Call Ended';
        }
      }
      if (this.cubeConnector.isAgentLoggedIn() || cubeConnectorStatusIsLoggedIn(this.cubeConnector.getCurrentStatus())) {
        if (this.agentStatus === 'NOT_READY') {
          return 'Not Ready';
        }
        return 'Ready';
      }
      switch (this.agentStatus) {
        case 'NOT_READY': return 'Not Ready';
        case 'RINGING': return this.inputObj?.customerAnswered ? 'Answer your dialer' : 'Dialing customer...';
        case 'BUSY': return 'On Call';
        case 'PAUSED': return 'On Break';
        case 'CONNECTING...': return 'Connecting...';
        case 'ERROR': return 'Login failed';
        case 'DISCONNECTED': return 'Not logged in';
        case 'UNKNOWN': return 'Connecting...';
        case 'IDLE': return 'Ready';
        default:
          return 'Connecting...';
      }
    }

    if (this.agentStatus === 'DISCONNECTED') return 'Not Connected';
    if (this.agentStatus === 'CONNECTING...') return 'Connecting...';
    if (this.agentStatus === 'ERROR') return 'Connection Error';
    if (this.agentStatus === 'UNKNOWN') return 'Initializing...';

    // Show break status
    if (this.inputObj?.pauseCall || this.inputObj?.Status === 'Break' || this.agentStatus === 'PAUSED') {
      return this.inputObj?.breakValue || 'On Break';
    }

    // Show call status
    if (this.showOzonetelDispositionPanel || this.showCubeDispositionPanel || this.showCentroDispositionPanel) {
      return 'Wrap-up';
    }
    if (this.inputObj?.Status) {
      switch (this.inputObj.Status) {
        case 'CALLING': return this.withTransferredSuffix('Calling...');
        case 'CONNECTED': return this.withTransferredSuffix('On Call');
        case 'Disconnected': return 'Call Ended';
      }
    }

    // Show agent status from SDK
    switch (this.agentStatus) {
      case 'NOT_READY': return 'Not Ready';
      case 'IDLE': return 'Ready';
      case 'BUSY': return this.isOnCall ? 'On Call' : 'Ready';
      case 'PAUSED': return 'On Break';
      default: return 'Connected';
    }
  }

  private withTransferredSuffix(text: string): string {
    if (this.inputObj?.transferCall) {
      return `${text} · Transferred`;
    }
    return text;
  }

  private async releaseAgentAfterTransfer(): Promise<void> {
    if (!this.isOnCall) {
      this.pendingTransferReleaseBypass = false;
      return;
    }
    // Read-and-clear keeps bypass scoped to this release attempt only.
    const skipWrapUpForTransferRelease = this.pendingTransferReleaseBypass;
    this.pendingTransferReleaseBypass = false;
    try {
      // Use transfer-aware hangup so Agent A is released without entering wrap-up.
      await this.ozonetelSDKCore.hangupCall({ skipWrapUpForTransferRelease });
    } catch (e) {
      console.warn('[CallingWidget] Post-transfer agent release failed:', e);
    }
    this.clearCallDisplayState();
  }

  async transferCall() {
    const target = String(this.inputObj?.RedirectToAgentId || '').trim();
    if (!target) {
      this.showErr('Select an agent to transfer', 'Error');
      return;
    }
    this.loader = true;
    try {
      const result = await this.ozonetelTransfer.warmTransferToAgent(
        target,
        this.inputObj,
        this.diallerController,
        this.extensionNumbers
      );
      if (result.success) {
        this.inputObj.transferCall = true;
        this.inputObj = { ...this.inputObj };
        this.showErr(result.message, 'OK');
        this.saveDiallingObj();
        if (result.releaseAgentA) {
          // Arm one-shot bypass before delayed Agent A release.
          this.pendingTransferReleaseBypass = true;
          setTimeout(() => void this.releaseAgentAfterTransfer(), result.releaseDelayMs ?? 4000);
        }
      } else {
        this.showErr(result.message, 'Error');
      }
    } catch (e: any) {
      this.showErr(e?.message || 'Error while transferring the call', 'Error');
    } finally {
      this.loader = false;
    }
  }

  getBreakIcon(breakName: string): string {
    if (this.inputObj?.callingType === 'cube') {
      return getCubeBreakIcon(breakName);
    }
    const icons: { [key: string]: string } = {
      'DND': 'do_not_disturb_on',
      'Tea Break': 'local_cafe',
      'Lunch Break': 'restaurant',
      'Bio Break': 'wc',
      'Training': 'school',
      'Meeting': 'groups',
      'Other': 'more_horiz'
    };
    return icons[breakName] || 'free_breakfast';
  }

  // Call Control Methods
  async endCall() {
    if (this.inputObj?.callingType === 'ozonetel' && this.ozonetelSDKCore.isAgentInitialized()) {
      try {
        this.loader = true;
        const result = await this.ozonetelSDKCore.hangupCall();

        if (result?.success) {
          this.showErr(result?.alreadyEnded ? 'Call already ended' : 'Call ended', 'OK');
        } else {
          const msg = String(result?.message || result?.resp || '').toLowerCase();
          if (!/not found|no active|no call|already|invalid|disconnect/i.test(msg)) {
            this.showErr(result?.message || 'Failed to end call', 'Error');
          }
        }
      } catch (e: any) {
        if (!this.ozonetelWrapUpActive) {
          this.clearCallDisplayState();
        }
        this.showErr(e.message || 'Error ending call', 'Error');
      } finally {
        this.loader = false;
      }
    } else if (this.inputObj?.callingType === 'cube' && this.isCubeWebphone) {
      this.loader = true;
      const ok = this.cubeConnector.hangup();
      this.loader = false;
      if (ok) {
        this.enterCubeWrapUp({
          ...(this.inputObj || {}),
          reason: 'agent_hangup',
          snapshot: this.inputObj,
        });
        this.ensureCubeDispositionOptions();
        this.cdr.detectChanges();
      } else {
        this.showErr('Failed to end call', 'Error');
      }
    } else if (this.inputObj?.callingType === 'cube' && this.diallerController) {
      this.loader = true;
      this.diallerController.dropCall().subscribe(
        (res: any) => {
          this.loader = false;
          if (res?.resultShort === 'failure') {
            this.showErr(res.resultLong || 'Failed to end call', 'Error');
            return;
          }
          this.showErr('Call ended', 'OK');
          this.inputObj.Status = 'Disconnected';
          this.inputObj.holdCall = false;
        },
        () => {
          this.loader = false;
          this.showErr('Error ending call', 'Error');
        }
      );
    } else if (this.inputObj?.callingType === 'centro' && this.diallerController) {
      if (this.centroWrapUpActive) {
        this.showErr('Complete call disposition first', 'Error');
        return;
      }
      this.loader = true;
      void firstValueFrom(this.callingService.postCentroLineEvent({ status: 'HANGUP' })).finally(() => {
        this.diallerController.dropCall().subscribe(
          (res: any) => {
            this.loader = false;
            this.centroSip.hangupLocal();
            this.centroAgentLegLive = false;
            if (res?.resultShort === 'failure') {
              this.showErr(res.resultLong || 'Failed to end call', 'Error');
              return;
            }
            this.enterCentroWrapUp(res, 'agent_hangup');
          },
          () => {
            this.loader = false;
            this.centroSip.hangupLocal();
            this.centroAgentLegLive = false;
            this.centroOutboundActive = false;
            this.showErr('Error ending call', 'Error');
          }
        );
      });
    } else {
      this.stopCall();
    }
  }

  async holdCall() {
    if (this.inputObj?.callingType === 'cube' && this.isCubeWebphone) {
      if (!['CALLING', 'CONNECTED'].includes(this.inputObj.Status)) {
        this.showErr('Hold is available during an active call', 'Error');
        return;
      }
      this.loader = true;
      const ok = await this.cubeConnector.holdCall();
      this.loader = false;
      if (ok) {
        this.inputObj.holdCall = true;
        this.showErr('Call on hold', 'OK');
      } else {
        this.showErr('Failed to hold call', 'Error');
      }
    } else if (this.inputObj?.callingType === 'ozonetel' && this.ozonetelSDKCore.isAgentInitialized()) {
      try {
        this.loader = true;
        const result = await this.ozonetelSDKCore.holdCall();
        this.loader = false;
        if (result?.success) {
          this.inputObj.holdCall = true;
          this.showErr('Call on hold', 'OK');
        } else {
          this.showErr(result?.message || 'Failed to hold call', 'Error');
        }
      } catch (e: any) {
        this.loader = false;
        this.showErr(e.message || 'Error holding call', 'Error');
      }
    } else if (this.inputObj?.callingType === 'centro') {
      if (!this.centroSip.isInCall()) {
        this.showErr('Hold is available during an active call', 'Error');
        return;
      }
      if (!this.centroSip.hold()) {
        this.showErr('Hold failed — no active SIP call', 'Error');
        return;
      }
      this.inputObj.holdCall = true;
      this.saveDiallingObj();
      this.cdr.markForCheck();
    } else if (this.diallerController) {
      this.diallerController.holdCall().subscribe(
        (res: any) => {
          if (res.resultShort === 'failure') {
            this.showErr(res.resultLong, 'Error');
          } else {
            this.inputObj.holdCall = true;
            this.showErr(res.resultLong, 'OK');
          }
          this.saveDiallingObj();
        },
        (err: any) => this.showErr('Error while holding the call', 'Error')
      );
    }
  }

  async unholdCall() {
    if (this.inputObj?.callingType === 'cube' && this.isCubeWebphone) {
      this.loader = true;
      const ok = await this.cubeConnector.unholdCall();
      this.loader = false;
      if (ok) {
        this.inputObj.holdCall = false;
        this.showErr('Call resumed', 'OK');
      } else {
        this.showErr('Failed to resume call', 'Error');
      }
    } else if (this.inputObj?.callingType === 'ozonetel' && this.ozonetelSDKCore.isAgentInitialized()) {
      try {
        this.loader = true;
        const result = await this.ozonetelSDKCore.unHoldCall();
        this.loader = false;
        if (result?.success) {
          this.inputObj.holdCall = false;
          this.showErr('Call resumed', 'OK');
        } else {
          this.showErr(result?.message || 'Failed to resume call', 'Error');
        }
      } catch (e: any) {
        this.loader = false;
        this.showErr(e.message || 'Error resuming call', 'Error');
      }
    } else if (this.inputObj?.callingType === 'centro') {
      if (!this.centroSip.unhold()) {
        this.showErr('Resume failed — no active SIP call', 'Error');
        return;
      }
      this.inputObj.holdCall = false;
      this.saveDiallingObj();
      this.cdr.markForCheck();
    } else if (this.diallerController) {
      this.diallerController.unholdCall().subscribe(
        (res: any) => {
          if (res.resultShort === 'failure') {
            this.showErr(res.resultLong, 'Error');
          } else {
            this.inputObj.holdCall = false;
            this.showErr(res.resultLong, 'OK');
          }
          this.saveDiallingObj();
        },
        (err: any) => this.showErr('Error while unholding the call', 'Error')
      );
    }
  }

  async toggleMute() {
    if (this.inputObj?.callingType === 'cube' && this.isCubeWebphone) {
      if (this.isMuted) {
        const ok = await this.cubeConnector.unmute();
        if (ok) {
          this.isMuted = false;
          this.showErr('Unmuted', 'OK');
        } else {
          this.showErr('Failed to unmute', 'Error');
        }
      } else {
        const ok = await this.cubeConnector.mute();
        if (ok) {
          this.isMuted = true;
          this.showErr('Muted', 'OK');
        } else {
          this.showErr('Failed to mute', 'Error');
        }
      }
    } else if (this.inputObj?.callingType === 'ozonetel' && this.ozonetelSDKCore.isAgentInitialized()) {
      try {
        if (this.isMuted) {
          const result = await this.ozonetelSDKCore.unMuteCall();
          if (result?.success) {
            this.isMuted = false;
            this.showErr('Unmuted', 'OK');
          } else {
            this.showErr('Failed to unmute', 'Error');
          }
        } else {
          const result = await this.ozonetelSDKCore.muteCall();
          if (result?.success) {
            this.isMuted = true;
            this.showErr('Muted', 'OK');
          } else {
            this.showErr('Failed to mute', 'Error');
          }
        }
      } catch (e: any) {
        this.showErr(e.message || 'Error toggling mute', 'Error');
      }
    } else if (this.inputObj?.callingType === 'centro') {
      if (!this.centroSip.isInCall()) {
        this.showErr('Mute is available during an active call', 'Error');
        return;
      }
      const nextMuted = !this.isMuted;
      if (!this.centroSip.setMuted(nextMuted)) {
        this.showErr('Mute failed — no active SIP media', 'Error');
        return;
      }
      this.isMuted = nextMuted;
      this.saveDiallingObj();
      this.cdr.markForCheck();
    }
  }

  // Dialpad Methods
  toggleDialpad() {
    this.showDialpad = !this.showDialpad;
  }

  onDialpadKey(key: string) {
    this.dialpadNumber += key;

    if (this.isOnCall && this.inputObj?.callingType === 'cube' && this.isCubeWebphone) {
      if (!this.cubeConnector.sendDtmf(key)) {
        console.warn('[CallingWidget] Cube DTMF failed:', key);
      }
      return;
    }

    if (this.isOnCall && this.ozonetelSDKCore.isAgentInitialized()) {
      this.ozonetelSDKCore.sendDTMF(key).catch(e => {
        console.warn('[CallingWidget] DTMF error:', e);
      });
    }
  }

  toggleSdkManualDial() {
    this.showSdkManualDial = !this.showSdkManualDial;
    this.showCentroManualDial = false;
    this.expandWidgetUi();
    if (!this.showSdkManualDial) {
      this.sdkDialNumber = '';
    }
  }

  /** Opens/closes Cube manual dial pad in widget. */
  toggleCubeManualDial() {
    this.showCubeManualDial = !this.showCubeManualDial;
    this.showCubeTools = false;
    this.showCentroManualDial = false;
    this.expandWidgetUi();
    if (!this.showCubeManualDial) {
      this.dialpadNumber = '';
    }
  }

  toggleCentroManualDial() {
    this.showCentroManualDial = !this.showCentroManualDial;
    this.showSdkManualDial = false;
    this.showCubeManualDial = false;
    this.showCubeTools = false;
    this.expandWidgetUi();
    if (!this.showCentroManualDial) {
      this.dialpadNumber = '';
    }
  }

  answerCentroSipCall() {
    if (!this.centroSip.answerIncoming()) {
      this.showErr('Failed to answer SIP call (media/SDP). Check rtpengine.', 'Error');
      return;
    }
    this.centroSipRinging = false;
    this.inputObj.Status = 'CONNECTED';
    this.agentStatus = 'ONCALL';
    this.cdr.markForCheck();
  }

  rejectCentroSipCall() {
    this.centroSip.rejectIncoming();
    this.centroSipRinging = false;
    this.inputObj.Status = 'Idle';
    this.agentStatus = 'IDLE';
    this.cdr.markForCheck();
  }

  private ensureCentroSipReadyForDial(): boolean {
    const sipOk = this.centroSip.isRegistered() || this.centroBrowserSipReady;
    if (!sipOk) {
      this.showErr('SIP not registered — wait for connect, then dial', 'Error');
      return false;
    }
    this.centroBrowserSipReady = true;
    return true;
  }

  centroManualDialCall() {
    if (!this.dialpadNumber) {
      this.showErr('Please enter a number', 'Error');
      return;
    }
    if (this.centroWrapUpActive) {
      this.showErr('Complete call disposition first', 'Error');
      return;
    }
    if (!this.ensureCentroSipReadyForDial()) {
      return;
    }
    if (this.centroReady && this.diallerController) {
      this.mergeCentroCallContextFromSession();
      this.makeManualCall();
      return;
    }
    if (!this.diallerController) {
      this.showErr('Centro dialer not ready', 'Error');
      return;
    }
    this.loader = true;
    const ctrl = this.diallerController as CentroController;
    const dial = async () => {
      try {
        if (this.centroAutoMode) {
          await firstValueFrom(this.callingService.centroManualModeStop());
          this.inputObj.isToggled = false;
        }
        await firstValueFrom(
          this.callingService.getCentroSipStatus(this.centroSip.isRegistered())
        );
        const phoneNo = this.dialpadNumber;
        const result: any = await firstValueFrom(ctrl.manualOutboundCall({ phoneNo }));
        this.loader = false;
        if (result?.resultShort === 'success') {
          this.showErr(result?.resultLong || 'Call initiated', 'OK');
          this.applyCentroManualDialResponse(result, phoneNo);
          this.inputObj.Status = 'CALLING';
          this.showCentroManualDial = false;
          this.dialpadNumber = '';
          this.saveDiallingObj();
        } else {
          this.showErr(result?.resultLong || 'Failed to initiate call', 'Error');
        }
        this.cdr.markForCheck();
      } catch (err: any) {
        this.loader = false;
        const msg = err?.error?.resultLong || err?.message || 'Failed to initiate call';
        this.showErr(msg, 'Error');
        this.cdr.markForCheck();
      }
    };
    ctrl.login().subscribe({
      next: (loginRes: any) => {
        if (loginRes?.resultShort !== 'success') {
          this.loader = false;
          this.handleCentroConnectError(null, loginRes);
          return;
        }
        ctrl.activate({ browserControlWs: true }).subscribe({
          next: () => {
            this.finishCentroBootstrap(ctrl, undefined, loginRes);
            void dial();
          },
          error: (err: any) => {
            this.loader = false;
            this.handleCentroConnectError(err);
          },
        });
      },
      error: (err: any) => {
        this.loader = false;
        this.handleCentroConnectError(err);
      },
    });
  }

  centroFreeAgentAndRetry() {
    if (this.centroFreeAgentLoading) {
      return;
    }
    this.centroFreeAgentLoading = true;
    this.callingService.centroFreeAgent(this.centroPendingUserStatusId || undefined).subscribe({
      next: (res: any) => {
        this.centroFreeAgentLoading = false;
        if (res?.resultShort === 'success') {
          this.centroRequiresFreeAgent = false;
          this.centroPendingUserStatusId = '';
          this.showErr(res.resultLong || 'Agent session freed', 'OK');
          this.centroBootstrapStarted = false;
          this.initCentroAgentStatus();
        } else {
          this.showErr(res?.resultLong || 'Free agent failed', 'Error');
        }
        this.cdr.markForCheck();
      },
      error: (err: any) => {
        this.centroFreeAgentLoading = false;
        const msg = err?.error?.resultLong || err?.message || 'Free agent failed';
        this.showErr(msg, 'Error');
        this.cdr.markForCheck();
      },
    });
  }

  /** Opens/closes transfer/conference tools panel. */
  toggleCubeTools() {
    this.showCubeTools = !this.showCubeTools;
    this.showCubeManualDial = false;
    this.expandWidgetUi();
    if (this.showCubeTools) {
      this.cubeToolsTab = 'transfer';
      this.refreshCubeTransferAgents();
    }
  }

  /** Reloads agent list for manual blind transfer target picker. */
  refreshCubeTransferAgents() {
    if (!this.isCubeWebphone) {
      return;
    }
    this.cubeTransferAgentsLoading = true;
    void this.cubeConnector.fetchTransferAgents().then((agents) => {
      this.cubeTransferAgents = this.normalizeCubeTransferAgents(agents);
      this.cubeTransferAgentsLoading = false;
      if (!this.cubeSelectedTransferAgent && this.cubeTransferAgents.length === 1) {
        this.cubeSelectedTransferAgent = this.cubeTransferAgents[0].AgentId;
      } else if (
        this.cubeSelectedTransferAgent &&
        !this.cubeTransferAgents.some((a) => a.AgentId === this.cubeSelectedTransferAgent)
      ) {
        this.cubeSelectedTransferAgent = '';
      }
      this.cdr.markForCheck();
    });
  }

  private normalizeCubeTransferAgents(agents: CubeTransferAgent[]): CubeTransferAgent[] {
    const seen = new Set<string>();
    const out: CubeTransferAgent[] = [];
    for (const agent of agents || []) {
      const id = String(agent?.AgentId || '').trim();
      if (!id) {
        continue;
      }
      const key = id.toLowerCase();
      if (seen.has(key)) {
        continue;
      }
      seen.add(key);
      out.push({
        AgentId: id,
        Extension: String(agent.Extension || '').trim(),
        label: String(agent.label || id).trim() || id,
      });
    }
    out.sort((a, b) => a.AgentId.localeCompare(b.AgentId, undefined, { sensitivity: 'base' }));
    return out;
  }

  setCubeToolsTab(tab: 'transfer' | 'conference') {
    this.cubeToolsTab = tab;
  }

  onCubeConferenceKey(key: string) {
    if (key === 'backspace') {
      this.cubeConferenceNumber = this.cubeConferenceNumber.slice(0, -1);
      return;
    }
    if (this.cubeConferenceNumber.length >= 10) {
      return;
    }
    this.cubeConferenceNumber += key;
  }

  /** User taps Answer while agent leg is ringing (campaign inbound). */
  answerCubeCall() {
    if (!this.isCubeWebphone) {
      return;
    }
    if (this.cubeConnector.answer()) {
      this.syncCubeCallState(this.cubeConnector.callState$.getValue());
      this.cdr.markForCheck();
    } else {
      this.showErr('Failed to answer', 'Error');
    }
  }

  /** User ends call from widget; connector hangup then wrap-up if required. */
  disposeCubeCall() {
    if (!this.isCubeWebphone) {
      return;
    }
    if (this.cubeWrapUpActive) {
      void this.submitCubeDisposition(false);
      return;
    }
    const disposition = (this.cubeDisposition || 'No Requirment').trim();
    if (this.cubeConnector.dispose(disposition, true)) {
      this.showErr('Call disposed', 'OK');
      this.isMuted = false;
    } else {
      this.showErr('Failed to dispose call', 'Error');
    }
  }

  /** Manual agent hop from tools panel — CubeConnector.redirect(agentId) */
  async transferCubeCall() {
    const target = (this.cubeSelectedTransferAgent || this.cubeTransferNumber || '').trim();
    if (!this.isCubeWebphone || !target) {
      this.showErr('Select an agent to transfer to', 'Error');
      return;
    }
    const selected = this.cubeTransferAgents.find(
      (a) => String(a.AgentId || '').toLowerCase() === target.toLowerCase()
    );
    this.loader = true;
    const ok = await this.cubeConnector.redirect(target, {
      extension: String(selected?.Extension || '').trim(),
    });
    this.loader = false;
    if (ok) {
      this.showErr(`Transferring to ${target}`, 'OK');
      this.showCubeTools = false;
    } else {
      this.showErr('Failed to transfer', 'Error');
    }
  }

  async conferenceCubeCall() {
    const number = String(this.cubeConferenceNumber || '').replace(/\D/g, '').slice(-10);
    if (!this.isCubeWebphone || number.length < 10) {
      this.showErr('Enter a valid 10-digit number', 'Error');
      return;
    }
    this.loader = true;
    const ok = await this.cubeConnector.conference(number);
    this.loader = false;
    if (ok) {
      this.cubeConferenceDialStarted = true;
      this.cubeToolsTab = 'conference';
      this.showErr('Dialling 3rd party — merge when they answer', 'OK');
    } else {
      this.showErr('Failed to dial 3rd party', 'Error');
    }
  }

  async mergeCubeCall() {
    if (!this.isCubeWebphone) {
      return;
    }
    this.loader = true;
    const ok = await this.cubeConnector.mergeCall();
    this.loader = false;
    if (ok) {
      this.cubeConferenceDialStarted = false;
      this.showErr('Calls merged', 'OK');
    } else {
      this.showErr('Failed to merge calls', 'Error');
    }
  }

  toggleCentroTools(): void {
    if (!this.isCentroDialer) return;
    this.showCentroTools = !this.showCentroTools;
    this.showCentroManualDial = false;
    this.expandWidgetUi();
    if (this.showCentroTools) {
      this.centroToolsTab = 'transfer';
      void this.refreshCentroTransferAgents();
    }
  }

  setCentroToolsTab(tab: 'transfer' | 'conference'): void {
    this.centroToolsTab = tab;
  }

  async refreshCentroTransferAgents(): Promise<void> {
    if (!this.isCentroDialer || !this.diallerController) return;
    const ctrl = this.diallerController as CentroController;
    const campaignName = String(this.inputObj?.campaignName || '').trim();
    if (!campaignName) return;
    this.centroTransferAgentsLoading = true;
    try {
      const res: any = await firstValueFrom(ctrl.getCampaignAgents(campaignName));
      this.centroTransferAgents = Array.isArray(res?.agents) ? res.agents : [];
      if (!this.centroSelectedTransferAgent && this.centroTransferAgents.length === 1) {
        this.centroSelectedTransferAgent = this.centroTransferAgents[0].AgentId;
      }
    } catch (_e) {
      this.centroTransferAgents = [];
    } finally {
      this.centroTransferAgentsLoading = false;
      this.cdr.markForCheck();
    }
  }

  get isCentroTransferEnabled(): boolean {
    return this.isCentroDialer && this.isOnCall && this.agentStatus === 'ONCALL';
  }

  get isCentroConferenceMergeReady(): boolean {
    return this.isCentroTransferEnabled && this.centroConferenceDialStarted;
  }

  async transferCentroCall(): Promise<void> {
    const target = (this.centroSelectedTransferAgent || '').trim();
    if (!this.isCentroDialer || !target || !this.diallerController) {
      this.showErr('Select an agent to transfer to', 'Error');
      return;
    }
    const ctrl = this.diallerController as CentroController;
    const selected = this.centroTransferAgents.find(
      (a) => String(a.AgentId || '').toLowerCase() === target.toLowerCase()
    );
    this.loader = true;
    try {
      const res: any = await firstValueFrom(
        ctrl.transferCall({
          targetAgentId: target,
          targetExtension: String(selected?.Extension || '').trim(),
          transferType: 'attendant',
        })
      );
      if (res?.resultShort === 'success') {
        this.showErr(`Transferring to ${target}`, 'OK');
        this.showCentroTools = false;
      } else {
        this.showErr(res?.resultLong || 'Failed to transfer', 'Error');
      }
    } catch (err: any) {
      this.showErr(err?.error?.resultLong || err?.message || 'Failed to transfer', 'Error');
    } finally {
      this.loader = false;
      this.cdr.markForCheck();
    }
  }

  async conferenceCentroCall(): Promise<void> {
    const number = String(this.centroConferenceNumber || '').replace(/\D/g, '').slice(-10);
    if (!this.isCentroDialer || number.length < 10 || !this.diallerController) {
      this.showErr('Enter a valid 10-digit number', 'Error');
      return;
    }
    const ctrl = this.diallerController as CentroController;
    this.loader = true;
    try {
      const res: any = await firstValueFrom(ctrl.conferenceCall(number));
      if (res?.resultShort === 'success') {
        this.centroConferenceDialStarted = true;
        this.centroToolsTab = 'conference';
        this.showErr('Dialling 3rd party — merge when they answer', 'OK');
      } else {
        this.showErr(res?.resultLong || 'Failed to dial 3rd party', 'Error');
      }
    } catch (err: any) {
      this.showErr(err?.error?.resultLong || err?.message || 'Failed to dial 3rd party', 'Error');
    } finally {
      this.loader = false;
      this.cdr.markForCheck();
    }
  }

  async mergeCentroCall(): Promise<void> {
    if (!this.isCentroDialer || !this.diallerController) return;
    const ctrl = this.diallerController as CentroController;
    this.loader = true;
    try {
      const res: any = await firstValueFrom(ctrl.mergeCall());
      if (res?.resultShort === 'success') {
        this.centroConferenceDialStarted = false;
        this.showErr('Calls merged', 'OK');
      } else {
        this.showErr(res?.resultLong || 'Failed to merge calls', 'Error');
      }
    } catch (err: any) {
      this.showErr(err?.error?.resultLong || err?.message || 'Failed to merge calls', 'Error');
    } finally {
      this.loader = false;
      this.cdr.markForCheck();
    }
  }

  onCentroConferenceKey(key: string): void {
    const digits = String(this.centroConferenceNumber || '').replace(/\D/g, '');
    if (key === 'back') {
      this.centroConferenceNumber = digits.slice(0, -1);
      return;
    }
    if (digits.length >= 10) return;
    this.centroConferenceNumber = digits + key;
  }

  private isCentroCampaignAutoTransferCall(): boolean {
    if (!this.isCentroDialer || !this.inputObj) return false;
    const profile = getCentroAutoTransferProfile();
    if (!profile.enabled) return false;
    const sourceCampaign = String(this.inputObj.campaignName || '').trim();
    return (
      !!sourceCampaign &&
      isCentroAutoTransferSourceCampaign(sourceCampaign) &&
      this.normalizeCampaignName(sourceCampaign) === this.normalizeCampaignName(profile.loginCampaign)
    );
  }

  private queueCentroAutoTransfer(): void {
    if (!this.isCentroCampaignAutoTransferCall()) return;
    if (
      this.centroAutoTransferExhausted ||
      this.centroAutoTransferTotalSends >= CallingComponent.CENTRO_AUTO_TRANSFER_MAX_ATTEMPTS ||
      this.centroAutoTransferRunner
    ) {
      return;
    }
    this.centroAutoTransferRunner = this.maybeAutoTransferCentroConnectedCall().finally(() => {
      this.centroAutoTransferRunner = null;
    });
  }

  private async maybeAutoTransferCentroConnectedCall(): Promise<void> {
    if (!this.isCentroDialer || !this.diallerController || !this.inputObj) return;
    if (this.inputObj.transferCall || this.centroAutoTransferExhausted) return;
    if (this.agentStatus !== 'ONCALL' && this.inputObj.Status !== 'CONNECTED') return;
    const profile = getCentroAutoTransferProfile();
    if (!profile.enabled || !profile.targetAgentId || !profile.targetCampaign) return;
    const ctrl = this.diallerController as CentroController;
    this.centroAutoTransferRouting = true;
    this.centroAutoTransferTargetLabel = profile.targetAgentId;
    this.cdr.markForCheck();
    try {
      const agentsRes: any = await firstValueFrom(
        ctrl.getCampaignAgents(profile.targetCampaign, { mode: 'autoTransfer' })
      );
      const agents = Array.isArray(agentsRes?.agents) ? agentsRes.agents : [];
      const needle = profile.targetAgentId.toLowerCase();
      const resolved =
        agents.find((a: any) => String(a?.AgentId || '').toLowerCase() === needle) ||
        agents.find((a: any) => String(a?.Extension || '').toLowerCase() === needle) ||
        null;
      const targetAgentId = String(resolved?.AgentId || profile.targetAgentId).trim();
      const targetExtension = String(resolved?.Extension || '').trim();
      const dialTarget = targetExtension || targetAgentId;
      const res: any = await firstValueFrom(
        ctrl.transferCall({
          targetAgentId,
          targetExtension,
          transferType: 'blind',
          targetPhone: dialTarget,
        })
      );
      this.centroAutoTransferTotalSends += 1;
      if (res?.resultShort === 'success') {
        this.inputObj = { ...this.inputObj, transferCall: true };
        this.centroAutoTransferExhausted = true;
      }
    } catch (_e) {
      if (this.centroAutoTransferTotalSends >= CallingComponent.CENTRO_AUTO_TRANSFER_MAX_ATTEMPTS) {
        this.centroAutoTransferExhausted = true;
      }
    } finally {
      this.centroAutoTransferRouting = false;
      this.cdr.markForCheck();
    }
  }

  toggleCubeAutoAnswer() {
    if (!this.isCubeWebphone) {
      return;
    }
    this.cubeAutoAnswer = !this.cubeAutoAnswer;
    if (this.cubeConnector.setAutoAnswer(this.cubeAutoAnswer)) {
      this.showErr(this.cubeAutoAnswer ? 'Auto-answer on' : 'Auto-answer off', 'OK');
    } else {
      this.cubeAutoAnswer = !this.cubeAutoAnswer;
      this.showErr('Failed to set auto-answer', 'Error');
    }
  }

  get showCubeLoginRetry(): boolean {
    if (!this.isCubeWebphone) {
      return false;
    }
    if (this.cubeConnector.isCubeSessionReady()) {
      return false;
    }
    if (this.inputObj?.Status === 'CONNECTED' && this.cubeConnector.isCallConnected()) {
      return false;
    }
    const st = this.cubeConnector.getCurrentStatus();
    return (
      st === 'failed' ||
      st === 'logged_out' ||
      this.agentStatus === 'ERROR' ||
      this.agentStatus === 'DISCONNECTED'
    );
  }

  get showCubeReconnectPanel(): boolean {
    if (!this.isCubeWebphone) {
      return false;
    }
    if (this.cubeConnector.isCubeSessionReady()) {
      return false;
    }
    const st = this.cubeConnector.getCurrentStatus();
    if (st === 'logging_in' || this.agentStatus === 'CONNECTING...' || this.loader) {
      return false;
    }
    const authLost =
      st === 'failed' ||
      st === 'logged_out' ||
      this.agentStatus === 'ERROR' ||
      this.agentStatus === 'DISCONNECTED' ||
      !this.cubeConnector.isAgentLoggedIn();
    if (authLost && (this.isOnCall || this.inputObj?.Status === 'CONNECTED' || this.inputObj?.Status === 'CALLING')) {
      return true;
    }
    if (this.inputObj?.Status === 'CONNECTED' && this.cubeConnector.isCallConnected()) {
      return false;
    }
    return authLost;
  }

  get cubeLoginErrorMessage(): string {
    return this.cubeConnector.getLastLoginError() || 'Cube login failed. Tap Retry to reconnect.';
  }

  async cubeForceLogin() {
    if (!this.isCubeWebphone) {
      return;
    }
    this.loader = true;
    this.agentStatus = 'CONNECTING...';
    this.lastCubeSyncKey = '';
    this.inputObj = {
      ...(this.inputObj || {}),
      callingType: 'cube',
      Status: 'Idle',
      customerAnswered: false,
      phoneNo: '',
      holdCall: false,
      pauseCall: false,
    };
    this.cdr.markForCheck();
    const ok = await this.cubeConnector.forceLogin();
    this.loader = false;
    if (!ok) {
      this.agentStatus = 'ERROR';
    }
    this.showErr(
      ok ? 'Reconnecting to Cube…' : (this.cubeLoginErrorMessage || 'Login failed'),
      ok ? 'OK' : 'Error'
    );
    this.cdr.markForCheck();
  }

  cubeLogout() {
    if (!this.isCubeWebphone) {
      return;
    }
    if (this.cubeConnector.logout()) {
      this.agentStatus = 'DISCONNECTED';
      this.inputObj.pauseCall = false;
      this.inputObj.isToggled = false;
      this.showErr('Logged out', 'OK');
      this.saveDiallingObj();
    } else {
      this.showErr('Logout failed', 'Error');
    }
  }

  refreshCubeAgentStatus() {
    if (!this.isCubeWebphone || !this.diallerController) {
      return;
    }
    this.loader = true;
    this.diallerController.getAgentStatus().subscribe(
      (res: any) => {
        this.loader = false;
        if (res?.resultShort === 'failure') {
          this.showErr(res.resultLong || 'Status unavailable', 'Error');
          return;
        }
        const status = res?.status || res?.data?.Activity || res?.resultLong;
        this.showErr(`Agent status: ${status}`, 'OK');
      },
      () => {
        this.loader = false;
        this.showErr('REST agent status failed (connector session may not have AuthId)', 'Error');
      }
    );
  }

  onSdkDialKey(key: string) {
    this.sdkDialNumber += key;
  }

  private getSdkCampaignName(): string {
    const remarks = localStorage.getItem('remarks');
    if (!remarks) {
      return '';
    }
    try {
      const remarksObj = JSON.parse(remarks);
      const campaignName = remarksObj?.ozonetelDetails?.campaignName;
      if (campaignName) {
        return campaignName.split('~')[0];
      }
    } catch (e) {
      console.warn('[CallingWidget] Error parsing remarks:', e);
    }
    return '';
  }

  sdkManualDialCall() {
    if (!this.sdkDialNumber) {
      this.showErr('Please enter a number', 'Error');
      return;
    }
    if (this.ozonetelWrapUpActive) {
      this.showErr('Complete call disposition first', 'Error');
      return;
    }
    if (this.isOnCall) {
      this.showErr('Already on a call', 'Error');
      return;
    }

    const campaignName = this.getSdkCampaignName();
    if (!campaignName) {
      this.showErr('Campaign not configured', 'Error');
      return;
    }

    this.loader = true;
    this.ozonetelService.sdkAgentManualDial({
      phoneNumber: this.sdkDialNumber,
      campaignName
    }).subscribe({
      next: (result: any) => {
        this.loader = false;
        if (result?.resultShort === 'success') {
          this.showErr('Call initiated', 'OK');
          this.stripCallDisplayFields(this.inputObj);
          this.inputObj.phoneNo = this.sdkDialNumber;
          this.inputObj.Status = 'CALLING';
          this.inputObj.transferCall = false;
          this.inputObj = { ...this.inputObj };
          delete (this.inputObj as any)._isDisconnecting;
          this.publishCallState();
          this.startManualDialConnectWatch();
          this.showSdkManualDial = false;
          this.sdkDialNumber = '';
        } else {
          this.handleOutboundDialFailure(result?.resultLong || 'Failed to initiate call');
        }
      },
      error: (error) => {
        this.loader = false;
        const msg =
          error?.error?.resultLong || error?.error?.message || error?.message || 'Failed to initiate call';
        this.handleOutboundDialFailure(msg);
      }
    });
  }

  private isManualDialApiError(result: any): boolean {
    if (!result || typeof result !== 'object') {
      return true;
    }
    const status = String(result.status ?? result.Status ?? '').toLowerCase();
    if (['error', 'exception', 'failed', 'failure'].includes(status)) {
      return true;
    }
    const msg = String(result.message ?? result.resp ?? result.resultLong ?? '').toLowerCase();
    return (
      msg.includes('valid campaign') ||
      msg.includes('invalid campaign') ||
      msg.includes('invalid agent') ||
      msg.includes('not logged') ||
      msg.includes('failed')
    );
  }

  private handleOutboundDialFailure(message: string): void {
    this.ozonetelSDKCore.cancelManualDialAttempt();
    this.stopManualDialConnectWatch();
    this.showDialpad = false;
    this.showSdkManualDial = false;
    if (!this.ozonetelSDKCore.isCallSessionActive()) {
      this.clearCallDisplayState();
    } else if (this.inputObj?.Status === 'CALLING') {
      this.clearCallDisplayState();
    }
    if (message) {
      this.showErr(message, 'Error');
    }
  }

  async makeManualCall() {
    if (!this.dialpadNumber) {
      this.showErr('Please enter a number', 'Error');
      return;
    }

    if (this.inputObj?.callingType === 'cube' && this.isCubeWebphone) {
      if (this.cubeWrapUpActive) {
        this.showErr('Complete call disposition first', 'Error');
        return;
      }
      const number = this.dialpadNumber;
      this.loader = true;
      this.inputObj.callDirection = 'manual';
      const ok = this.cubeConnector.makeCall(number, {
        phoneNo: number,
        callDirection: 'manual',
        fullName: this.inputObj?.fullName || '',
        dueId: this.inputObj?.dueId,
        clientId: this.inputObj?.clientId,
      });
      this.loader = false;
      if (ok) {
        this.showErr('Call initiated', 'OK');
        this.showCubeManualDial = false;
        this.dialpadNumber = '';
      } else {
        this.showErr('Failed to initiate call', 'Error');
      }
      return;
    }

    if (this.inputObj?.callingType === 'cube' && this.diallerController) {
      this.loader = true;
      this.diallerController.manualOutboundCall({
        PhoneNo: this.dialpadNumber,
        Name: this.inputObj?.fullName || '',
        ClientId: this.inputObj?.clientId || '',
      }).subscribe(
        (result: any) => {
          this.loader = false;
          if (result?.resultShort === 'success') {
            this.showErr('Call initiated — answer your extension phone', 'OK');
            this.inputObj.phoneNo = this.dialpadNumber;
            this.inputObj.Status = 'CALLING';
            this.showDialpad = false;
            this.dialpadNumber = '';
            this.saveDiallingObj();
          } else {
            this.showErr(result?.resultLong || 'Failed to initiate call', 'Error');
          }
        },
        (error) => {
          this.loader = false;
          const msg = error?.error?.resultLong || error?.error?.message || error?.message || 'Failed to initiate call';
          this.showErr(msg, 'Error');
        }
      );
      return;
    }

    if (this.inputObj?.callingType === 'centro' && this.diallerController) {
      if (this.centroWrapUpActive) {
        this.showErr('Complete call disposition first', 'Error');
        return;
      }
      if (!this.centroReady) {
        this.showErr('Centro agent is not ready yet', 'Error');
        return;
      }
      if (!this.ensureCentroSipReadyForDial()) {
        return;
      }
      this.mergeCentroCallContextFromSession();
      this.loader = true;
      try {
        if (this.centroAutoMode) {
          await firstValueFrom(this.callingService.centroManualModeStop());
          this.inputObj.isToggled = false;
        }
        await firstValueFrom(
          this.callingService.getCentroSipStatus(this.centroSip.isRegistered())
        );
        const phoneNo = this.dialpadNumber;
        const result: any = await firstValueFrom(
          this.diallerController.manualOutboundCall({ phoneNo })
        );
        this.loader = false;
        if (result?.resultShort === 'success') {
          const lineOk = result?.callData?.dialRes?.data?.line1Connected;
          this.showErr(
            lineOk ? 'Call initiated' : 'Dial sent — answer the SIP call in this browser',
            'OK'
          );
          this.applyCentroManualDialResponse(result, phoneNo);
          this.inputObj.Status = 'CALLING';
          this.showDialpad = false;
          this.showCentroManualDial = false;
          this.dialpadNumber = '';
          this.saveDiallingObj();
        } else {
          this.showErr(result?.resultLong || 'Failed to initiate call', 'Error');
        }
      } catch (error: any) {
        this.loader = false;
        const msg = error?.error?.resultLong || error?.error?.message || error?.message || 'Failed to initiate call';
        this.showErr(msg, 'Error');
      }
      this.cdr.markForCheck();
      return;
    }

    // Get campaign ID from localStorage
    const remarks = localStorage.getItem('remarks');
    let campaignId = '';

    if (remarks) {
      try {
        const remarksObj = JSON.parse(remarks);
        const ozonetelDetails = remarksObj?.ozonetelDetails;
        if (ozonetelDetails?.campaignName) {
          campaignId = ozonetelDetails.campaignName.split('~')[0];
        }
      } catch (e) {
        console.warn('[CallingWidget] Error parsing remarks:', e);
      }
    }

    if (!campaignId) {
      this.showErr('Campaign not configured', 'Error');
      return;
    }

    try {
      this.loader = true;
      await this.ozonetelSDKCore.ensureAgentReadyForManualDial();
      const result = await this.ozonetelSDKCore.initManualCall(campaignId, this.dialpadNumber);

      if (this.isManualDialApiError(result)) {
        const errorMsg = result?.message || result?.resp || result?.resultLong || 'Failed to initiate call';
        this.handleOutboundDialFailure(errorMsg);
        return;
      }

      if (result?.status === 'Queued' || result?.resp?.includes('Queued')) {
        this.showErr('Call initiated', 'OK');
        this.stripCallDisplayFields(this.inputObj);
        this.inputObj.phoneNo = this.dialpadNumber;
        this.inputObj.Status = 'CALLING';
        this.inputObj.transferCall = false;
        this.inputObj = { ...this.inputObj };
        delete (this.inputObj as any)._isDisconnecting;
        this.publishCallState();
        this.startManualDialConnectWatch();
        this.showDialpad = false;
        this.dialpadNumber = '';
      } else {
        this.handleOutboundDialFailure(result?.message || result?.resp || 'Failed to initiate call');
      }
    } catch (e: any) {
      this.handleOutboundDialFailure(e.message || 'Error making call');
    } finally {
      this.loader = false;
    }
  }

  // Agent State Methods
  async toggleAgentStatus() {
    if (this.inputObj?.callingType === 'ozonetel' && this.ozonetelSDKCore.isAgentInitialized()) {
      if (this.ozonetelWrapUpActive) {
        this.showErr('Complete call disposition first', 'Error');
        return;
      }
      // Don't allow toggling if agent is on a call
      if (this.agentStatus === 'BUSY' || this.isOnCall) {
        this.showErr('Cannot change status while on a call', 'Error');
        return;
      }

      try {
        this.loader = true;

        if (this.agentStatus === 'IDLE') {
          const result = await this.ozonetelSDKCore.setAgentMode('INBOUND', 'NOT_READY');
          this.loader = false;
          if (result?.success || result?.agentStatus === 'NOT_READY' || result?.resp === 'Success') {
            this.agentStatus = 'NOT_READY';
            this.showErr('Agent set to Not Ready', 'OK');
          } else {
            this.showErr(result?.message || 'Failed to set not ready', 'Error');
          }
        } else {
          const ready = await this.ozonetelSDKCore.setAgentInboundReady();
          this.loader = false;
          if (ready) {
            this.agentStatus = 'IDLE';
            this.inputObj.pauseCall = false;
            if (this.inputObj.Status !== 'CALLING' && this.inputObj.Status !== 'CONNECTED') {
              this.inputObj.Status = 'Idle';
            }
            this.showErr('Agent is ready - You will now receive calls', 'OK');
          } else {
            this.showErr('Failed to set ready', 'Error');
          }
        }
      } catch (e: any) {
        this.loader = false;
        this.showErr(e.message || 'Error toggling agent status', 'Error');
      }
    } else if (this.inputObj?.callingType === 'cube' && this.isCubeWebphone) {
      if (this.cubeWrapUpActive) {
        this.showErr('Complete call disposition first', 'Error');
        return;
      }
      if (this.isOnCall || this.agentStatus === 'BUSY') {
        this.showErr('Cannot change status while on a call', 'Error');
        return;
      }
      if (!this.cubeConnector.isAgentLoggedIn()) {
        this.showErr('Cube webphone is not logged in yet', 'Error');
        return;
      }
      if (this.cubeConnector.isAgentOnBreak() || this.agentStatus === 'PAUSED' || this.inputObj?.pauseCall) {
        this.cubeConnector.breakEnd().then((ok) => {
          if (ok) {
            this.agentStatus = 'IDLE';
            this.inputObj.isToggled = false;
            this.inputObj.pauseCall = false;
            if (this.inputObj.Status !== 'CALLING' && this.inputObj.Status !== 'CONNECTED') {
              this.inputObj.Status = 'Idle';
            }
            this.showErr('Agent is ready', 'OK');
            this.saveDiallingObj();
          } else {
            this.showErr('Failed to set ready', 'Error');
          }
        });
      } else if (this.agentStatus === 'IDLE') {
        this.cubeConnector.breakStart('Meeting Break').then((ok) => {
          if (ok) {
            this.agentStatus = 'PAUSED';
            this.inputObj.isToggled = false;
            this.inputObj.pauseCall = true;
            this.inputObj.Status = 'Break';
            this.inputObj.breakValue = 'Meeting Break';
            this.showErr('Agent set to Not Ready', 'OK');
            this.saveDiallingObj();
          } else {
            this.showErr('Failed to set not ready', 'Error');
          }
        });
      } else {
        this.cubeConnector.breakEnd().then((ok) => {
          if (ok) {
            this.agentStatus = 'IDLE';
            this.inputObj.isToggled = false;
            this.inputObj.pauseCall = false;
            if (this.inputObj.Status !== 'CALLING' && this.inputObj.Status !== 'CONNECTED') {
              this.inputObj.Status = 'Idle';
            }
            this.showErr('Agent is ready', 'OK');
            this.saveDiallingObj();
          } else {
            this.showErr('Failed to set ready', 'Error');
          }
        });
      }
    } else if (this.inputObj?.callingType === 'cube' && this.diallerController) {
      if (this.isOnCall || this.agentStatus === 'BUSY') {
        this.showErr('Cannot change status while on a call', 'Error');
        return;
      }
      if (this.inputObj.isToggled) {
        this.toggleStopMode();
        this.agentStatus = 'NOT_READY';
      } else {
        this.toggleStartMode();
        this.agentStatus = 'IDLE';
      }
    } else {
      this.showErr('Agent not initialized', 'Error');
    }
  }

  async setAgentReady() {
    if (this.inputObj?.callingType === 'ozonetel' && this.ozonetelSDKCore.isAgentInitialized()) {
      try {
        this.loader = true;
        const ready = await this.ozonetelSDKCore.setAgentInboundReady();
        this.loader = false;
        if (ready) {
          this.agentStatus = 'IDLE';
          this.inputObj.pauseCall = false;
          this.inputObj.Status = 'Idle';
          this.showErr('Agent is ready - You will now receive calls', 'OK');
        } else {
          this.showErr('Failed to set ready', 'Error');
        }
      } catch (e: any) {
        this.loader = false;
        this.showErr(e.message || 'Error setting agent ready', 'Error');
      }
    } else {
      this.resumeCall();
    }
  }

  // Break Methods
  pauseAPICall(type: string) {
    this.inputObj.breakValue = type;
    this.loader = true;

    if (this.inputObj?.callingType === 'ozonetel' && this.ozonetelSDKCore.isAgentInitialized()) {
      this.ozonetelSDKCore.setPauseState(type, 'INBOUND').then(result => {
        this.loader = false;
        if (result?.success) {
          this.inputObj.Status = 'Break';
          this.inputObj.pauseCall = true;
          this.agentStatus = 'PAUSED';
          this.showErr(`On ${type}`, 'OK');
        } else {
          this.inputObj.pauseCall = false;
          this.showErr(result?.message || 'Failed to set break', 'Error');
        }
        this.saveDiallingObj();
      }).catch(e => {
        this.loader = false;
        this.inputObj.pauseCall = false;
        this.showErr(e.message || 'Error setting break', 'Error');
      });
    } else if (this.inputObj?.callingType === 'cube' && this.isCubeWebphone) {
      const applyBreak = () => {
        this.cubeConnector.breakStart(type).then((ok) => {
          this.loader = false;
          if (ok) {
            this.inputObj.Status = 'Break';
            this.inputObj.pauseCall = true;
            this.inputObj.isToggled = false;
            this.agentStatus = 'PAUSED';
            this.showErr(`On ${type}`, 'OK');
          } else {
            this.inputObj.pauseCall = false;
            this.showErr('Failed to set break', 'Error');
          }
          this.saveDiallingObj();
        });
      };
      if (this.cubeConnector.isAgentOnBreak()) {
        this.cubeConnector.breakEnd().then((ended) => {
          if (!ended) {
            this.loader = false;
            this.showErr('Failed to change break', 'Error');
            return;
          }
          applyBreak();
        });
      } else {
        applyBreak();
      }
    } else if (this.inputObj?.callingType === 'centro' && this.diallerController) {
      this.diallerController.pauseCall({ breakType: type }).subscribe(
        (res: any) => {
          this.loader = false;
          if (res.resultShort === 'failure') {
            this.inputObj.pauseCall = false;
            this.showErr(res.resultLong, 'Error');
          } else {
            this.inputObj.pauseCall = true;
            this.inputObj.breakValue = type;
            this.agentStatus = 'PAUSED';
            this.centroStatusDetail = type || 'On break';
            this.centroSip.setAutoAnswer(false);
            // Keep Auto/Manual toggle as-is — Break is separate from Manual mode.
            if (!this.centroWrapUpActive) {
              this.inputObj.Status = 'Break';
            }
            this.showErr(res.resultLong || `On ${type}`, 'OK');
          }
          this.publishCallState();
          this.saveDiallingObj();
          this.cdr.detectChanges();
        },
        (err: any) => {
          this.loader = false;
          this.inputObj.pauseCall = false;
          this.showErr(err?.error?.resultLong || 'Error setting break', 'Error');
        }
      );
    } else if (this.diallerController) {
      this.diallerController.pauseCall({ breakType: type }).subscribe(
        (res: any) => {
          this.loader = false;
          if (res.resultShort === 'failure') {
            this.inputObj.pauseCall = false;
            this.showErr(res.resultLong, 'Error');
          } else {
            this.inputObj.Status = 'Break';
            this.inputObj.pauseCall = true;
            this.showErr(res.resultLong, 'OK');
          }
          this.saveDiallingObj();
        },
        (err: any) => {
          this.loader = false;
          this.inputObj.pauseCall = false;
          this.showErr(err?.error?.resultLong || 'Error setting break', 'Error');
        }
      );
    }
  }

  resumeCall() {
    this.loader = true;

    if (this.inputObj?.callingType === 'cube' && this.isCubeWebphone) {
      if (this.cubeConnector.isAgentOnBreak() || this.inputObj?.pauseCall) {
        this.cubeConnector.breakEnd().then((ok) => {
          this.loader = false;
          if (ok) {
            this.inputObj.pauseCall = false;
            this.inputObj.Status = 'Idle';
            this.agentStatus = 'IDLE';
            this.inputObj.breakValue = '';
            this.showErr('Break ended', 'OK');
          } else {
            this.showErr('Failed to resume', 'Error');
          }
          this.saveDiallingObj();
        });
        return;
      }
    }

    if (this.inputObj?.callingType === 'ozonetel' && this.ozonetelSDKCore.isAgentInitialized()) {
      this.ozonetelSDKCore.setAgentInboundReady().then(ready => {
        this.loader = false;
        if (ready) {
          this.inputObj.pauseCall = false;
          this.inputObj.Status = 'Idle';
          this.agentStatus = 'IDLE';
          this.inputObj.breakValue = '';
          this.showErr('Break ended', 'OK');
        } else {
          this.showErr('Failed to resume', 'Error');
        }
        this.saveDiallingObj();
      }).catch(e => {
        this.loader = false;
        this.showErr(e.message || 'Error resuming', 'Error');
      });
    } else if (this.inputObj?.callingType === 'cube' && this.isCubeWebphone) {
      this.cubeConnector.breakEnd().then((ok) => {
        this.loader = false;
        if (ok) {
          this.inputObj.pauseCall = false;
          this.inputObj.Status = 'Idle';
          this.agentStatus = 'IDLE';
          this.inputObj.breakValue = '';
          this.showErr('Break ended', 'OK');
        } else {
          this.showErr('Failed to resume', 'Error');
        }
        this.saveDiallingObj();
      });
    } else if (this.inputObj?.callingType === 'centro' && this.diallerController) {
      this.diallerController.resumeCall().subscribe(
        (res: any) => {
          this.loader = false;
          if (res?.resultShort === 'failure') {
            this.showErr(res.resultLong || 'Failed to resume', 'Error');
            return;
          }
          this.inputObj.pauseCall = false;
          this.inputObj.breakValue = '';
          if (!this.centroWrapUpActive) {
            this.inputObj.Status = 'Idle';
            this.agentStatus = 'IDLE';
            this.centroStatusDetail = 'Ready';
            this.centroSip.setAutoAnswer(true);
          } else {
            this.agentStatus = 'IDLE';
            this.centroStatusDetail = 'Wrap-up';
          }
          this.showErr(res?.resultLong || 'Break ended', 'OK');
          this.publishCallState();
          this.saveDiallingObj();
          this.cdr.detectChanges();
        },
        (err: any) => {
          this.loader = false;
          this.showErr(err?.error?.resultLong || 'Error resuming', 'Error');
        }
      );
    } else if (this.diallerController) {
      this.diallerController.resumeCall().subscribe(
        (res: any) => {
          this.loader = false;
          if (res.resultShort === 'failure') {
            this.showErr(res.resultLong, 'Error');
          } else {
            this.inputObj.pauseCall = false;
            this.inputObj.Status = 'Idle';
            this.inputObj.breakValue = '';
            this.showErr(res.resultLong, 'OK');
          }
          this.saveDiallingObj();
        },
        (err: any) => {
          this.loader = false;
          this.showErr(err?.error?.resultLong || 'Error resuming', 'Error');
        }
      );
    } else {
      this.loader = false;
    }
  }

  // Legacy Methods (for compatibility)
  toggleStartMode(): void {
    if (this.inputObj?.callingType === 'centro') {
      if (this.centroWrapUpActive) {
        this.showErr('Complete call disposition before enabling auto dial', 'Error');
        return;
      }
      const leaveBreakThenStart = () => {
        this.diallerController?.toggleStartMode().subscribe(
          (res: any) => {
            if (res.resultShort === 'failure') {
              this.showErr(res.resultLong, 'Error');
            } else {
              this.inputObj.isToggled = true;
              this.inputObj.pauseCall = false;
              this.inputObj.breakValue = '';
              if (this.inputObj.Status === 'Break') {
                this.inputObj.Status = 'Idle';
              }
              this.agentStatus = 'IDLE';
              this.centroStatusDetail = 'Ready';
              this.centroSip.setAutoAnswer(true);
              this.showErr(res.resultLong, 'OK');
            }
            this.publishCallState();
            this.saveDiallingObj();
            this.cdr.detectChanges();
          },
          () => this.showErr('Error toggling start mode', 'Error')
        );
      };
      if (this.inputObj.pauseCall || this.agentStatus === 'PAUSED') {
        this.diallerController?.resumeCall().subscribe({
          next: () => leaveBreakThenStart(),
          error: () => leaveBreakThenStart(),
        });
        return;
      }
      leaveBreakThenStart();
      return;
    }
    this.diallerController?.toggleStartMode().subscribe(
      (res: any) => {
        if (res.resultShort === 'failure') {
          this.showErr(res.resultLong, 'Error');
        } else {
          this.inputObj.isToggled = true;
          this.showErr(res.resultLong, 'OK');
        }
        this.saveDiallingObj();
      },
      () => this.showErr('Error toggling start mode', 'Error')
    );
  }

  toggleStopMode(): void {
    this.diallerController?.toggleStopMode().subscribe(
      (res: any) => {
        if (res.resultShort === 'failure') {
          this.showErr(res.resultLong, 'Error');
        } else {
          this.inputObj.isToggled = false;
          this.showErr(res.resultLong, 'OK');
        }
        this.saveDiallingObj();
      },
      () => this.showErr('Error toggling stop mode', 'Error')
    );
  }

  gotToTimeline() {
    if (this.inputObj?.callingType === 'ozonetel' && this.ozonetelDialerFlow.openCase({
      ...this.inputObj,
      Status: this.inputObj.Status === 'Idle' ? 'CONNECTED' : this.inputObj.Status,
    })) {
      return;
    }

    if (this.inputObj?.callingType === 'cube' && this.cubeDialerFlow.openCase({
      ...this.inputObj,
      Status: this.inputObj.Status === 'Idle' ? 'CONNECTED' : this.inputObj.Status,
    })) {
      return;
    }

    if (this.inputObj?.callingType === 'centro' && this.centroDialerFlow.openCase({
      ...this.inputObj,
      Status: this.inputObj.Status === 'Idle' ? 'CONNECTED' : this.inputObj.Status,
      customerAnswered: true,
    })) {
      return;
    }

    const dueId = this.cubeDialerFlow.sanitizeDueId(this.inputObj?.dueId);
    if (dueId) {
      this.router.navigate(['/timeline', dueId]);
    }
  }

  stopCall() {
    this.onActions(true);
    this.callingService.stopCall().subscribe(
      (res: any) => this.showErr(res.message, 'OK'),
      () => this.showErr('Error while stopping the call', 'Error')
    );
  }

  toggleCollpse() {
    this.fullScreen = !this.fullScreen;
  }

  toggleBody() {
    this.showBody = !this.showBody;
  }

  private expandWidgetUi(): void {
    this.fullScreen = true;
    this.showBody = true;
  }

  // Utility Methods
  getAgentIds() {
    if (this.inputObj?.callingType !== 'ozonetel') {
      this.extensionNumbers = [];
      return;
    }
    void this.refreshTransferAgents();
  }

  async refreshTransferAgents(): Promise<void> {
    let selfAgentId = '';
    try {
      const dbConfig = await this.ozonetelSDKCore.getAgentConfigFromDB();
      selfAgentId = dbConfig?.ozonetelDetails?.agentId || '';
    } catch {
      selfAgentId = '';
    }
    this.extensionNumbers = await this.ozonetelTransfer.loadTransferTargets(selfAgentId);
  }

  onTransferMenuOpened(): void {
    this.transferAgentSearch = '';
    void this.refreshTransferAgents();
  }

  get filteredTransferAgents(): any[] {
    const query = this.transferAgentSearch.trim().toLowerCase();
    if (!query) {
      return this.extensionNumbers;
    }
    return this.extensionNumbers.filter((agent) => {
      const label = String(agent.label || agent.AgentId || '').toLowerCase();
      const id = String(agent.transferTo || agent.AgentId || '').toLowerCase();
      return label.includes(query) || id.includes(query);
    });
  }

  selectTransferAgent(agent: any): void {
    this.inputObj.RedirectToAgentId = agent.transferTo || agent.AgentId;
  }

  isTransferAgentSelected(agent: any): boolean {
    const selected = String(this.inputObj?.RedirectToAgentId || '').trim();
    const value = String(agent.transferTo || agent.AgentId || '').trim();
    return !!selected && selected === value;
  }

  /** Polls SDK session while widget shows CALLING — promotes to CONNECTED when leg goes BUSY. */
  private startManualDialConnectWatch(): void {
    this.stopManualDialConnectWatch();
    const epoch = this.callUiEpoch;
    let attempts = 0;
    const tick = () => {
      if (epoch !== this.callUiEpoch || this.inputObj?.Status !== 'CALLING') {
        return;
      }
      void this.tryPromoteManualDialToConnected(epoch, () => {
        attempts += 1;
        if (attempts >= 90) {
          this.handleOutboundDialFailure('Call did not connect');
          return;
        }
        this.manualDialWatchTimer = setTimeout(tick, 500);
      });
    };
    this.manualDialWatchTimer = setTimeout(tick, 500);
  }

  private async tryPromoteManualDialToConnected(
    epoch: number,
    onPending: () => void
  ): Promise<void> {
    if (epoch !== this.callUiEpoch || this.inputObj?.Status !== 'CALLING') {
      return;
    }
    if (!this.ozonetelSDKCore.isCallSessionActive()) {
      onPending();
      return;
    }
    try {
      const data = await this.ozonetelSDKCore.getCallData();
      if (epoch !== this.callUiEpoch || this.inputObj?.Status !== 'CALLING') {
        return;
      }
      if (!data || !this.ozonetelSDKCore.isLiveCallData(data)) {
        onPending();
        return;
      }
      if (this.inputObj) {
        delete (this.inputObj as any)._isDisconnecting;
        this.inputObj.Status = 'CONNECTED';
        this.applyCallerDisplayFields(
          this.inputObj,
          this.ozonetelDialerFlow.enrichCallDisplayData({
            ...this.inputObj,
            ...data,
          })
        );
        this.inputObj = { ...this.inputObj };
        this.agentStatus = 'BUSY';
        this.publishCallState();
        void this.fetchCallData();
      }
    } catch {
      onPending();
    }
  }

  private stopManualDialConnectWatch(): void {
    if (this.manualDialWatchTimer) {
      clearTimeout(this.manualDialWatchTimer);
      this.manualDialWatchTimer = null;
    }
  }

  // ---------------------------------------------------------------------------
  // Auto call transfer (Ozonetel SDK + Cube webphone)
  //
  // Ozonetel (JSON — ozonetel-auto-transfer-config.json):
  //   campaigns + dummyUsers (logged-in agentId) + activeUsers (destination; random if 2+)
  //   → same-campaign warm transfer. No DB isCallTransfer / toTranfer dependency.
  // Cube (cube-auto-transfer-config.json):
  //   dummyUsers + source campaign → targetCampaign + activeUsers (random if 2+).
  //   remarks.cubeDetails supplies logged-in AgentId + CampaignId only.
  // Manual transfer UI is unchanged.
  // ---------------------------------------------------------------------------

  /** Parses true-like values (legacy helpers). */
  private parseBooleanFlag(value: any): boolean {
    if (typeof value === 'boolean') {
      return value;
    }
    const normalized = String(value ?? '').trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes';
  }

  /** Reads ozonetelDetails cached in localStorage remarks (synced from user profile on SDK init). */
  private getOzonetelDetailsFromRemarks(): any {
    const remarks = localStorage.getItem('remarks');
    if (!remarks) {
      return null;
    }
    try {
      return JSON.parse(remarks)?.ozonetelDetails || null;
    } catch {
      return null;
    }
  }

  /** Normalizes Ozonetel campaign strings: trim, take segment before "~", lowercase. */
  private normalizeCampaignName(value: any): string {
    const raw = String(value ?? '').trim();
    if (!raw) {
      return '';
    }
    return raw.split('~')[0].trim().toLowerCase();
  }

  /** Parses remarks.cubeDetails from localStorage for login credentials. */
  private getCubeDetailsFromRemarks(): any {
    const remarks = localStorage.getItem('remarks');
    if (!remarks) {
      return null;
    }
    try {
      return JSON.parse(remarks)?.cubeDetails || null;
    } catch {
      return null;
    }
  }

  /** Best-effort source campaign name for auto-transfer eligibility checks. */
  private resolveCubeConnectedCampaignName(eventData: any): string {
    const candidates = [
      eventData?.campaignName,
      eventData?.campaign_name,
      eventData?.CampaignName,
      eventData?.campaign,
      eventData?.campaignId,
      eventData?.CampaignId,
      this.callData?.campaignName,
      this.inputObj?.campaignName,
      this.inputObj?.campaign_name,
      this.inputObj?.campaignId,
      this.inputObj?.CampaignId,
    ];
    const profile = getCubeAutoTransferProfile();
    if (profile.loginCampaign) {
      candidates.push(profile.loginCampaign);
    }
    for (const candidate of candidates) {
      const normalized = this.normalizeCampaignName(candidate);
      if (normalized && this.isCubeAutoTransferSourceCampaign(normalized)) {
        return normalized;
      }
    }
    return '';
  }

  private isCubeAutoTransferSourceCampaign(campaignName: string): boolean {
    return isCubeJsonSourceCampaign(this.normalizeCampaignName(campaignName));
  }

  private buildCubeAutoTransferKey(callRef: string, targetCampaign: string, targetAgentId: string): string {
    return `cube::${callRef}::${targetCampaign}::${targetAgentId}`;
  }

  private resolveCubeAutoTransferCallRef(eventData: any): string {
    const candidates = [
      eventData?.phoneNo,
      eventData?.phoneNumber,
      this.inputObj?.phoneNo,
      this.inputObj?.phoneNumber,
      eventData?.clientId,
      this.inputObj?.clientId,
      eventData?.dueId,
      this.inputObj?.dueId,
    ];
    for (const candidate of candidates) {
      const raw = String(candidate || '').trim();
      if (!raw) {
        continue;
      }
      const digits = raw.replace(/\D/g, '');
      if (digits.length >= 10) {
        return digits.slice(-10);
      }
      return raw;
    }
    return 'active-leg';
  }

  /** When blind transfer sent, waits for dummy leg end then completes UI cleanup. */
  private maybeCompletePendingCubeAutoTransferRelease(source = 'pending'): void {
    if (!this.cubeAutoTransferPendingRelease || this.cubeDummyTransferReleased) {
      return;
    }
    if (!this.cubeConnector.isCubeTransferDispatched()) {
      return;
    }
    if (this.cubeConnector.isCallSessionActive()) {
      return;
    }
    const transferKey = this.cubeAutoTransferPendingKey;
    const targetCampaign = this.cubeAutoTransferPendingCampaign;
    const target = this.cubeAutoTransferPendingTarget;
    if (!transferKey) {
      return;
    }
    this.cubeAutoTransferPendingRelease = false;
    this.cubeAutoTransferPendingKey = '';
    this.cubeAutoTransferPendingCampaign = '';
    this.cubeAutoTransferPendingTarget = '';
    this.completeCubeAutoTransfer(transferKey, targetCampaign, target);
  }

  /** Stores pending blind-transfer state until iframe confirms dummy leg released. */
  private markCubeBlindTransferPending(
    transferKey: string,
    targetCampaign: string,
    target: string
  ): void {
    this.cubeAutoTransferExhausted = true;
    this.autoTransferAttemptedKeys.add(transferKey);
    this.cubeAutoTransferPendingRelease = true;
    this.cubeAutoTransferPendingKey = transferKey;
    this.cubeAutoTransferPendingCampaign = targetCampaign;
    this.cubeAutoTransferPendingTarget = target;
    this.cubeAutoTransferRouting = false;
    this.cubeAutoTransferTargetLabel = '';
    this.cubeConnector.setTransferRouting(false);
  }

  /** Dummy agent: hangup + clear UI after blind auto-transfer (no disposition). */
  private releaseCubeAgentAfterTransfer(source = 'post_transfer'): void {
    if (
      this.cubeDummyTransferReleased &&
      this.inputObj?.Status === 'Idle' &&
      !this.inputObj?.phoneNo &&
      !this.inputObj?.fullName &&
      !this.cubeConnector.isCallSessionActive()
    ) {
      return;
    }
    this.cubeLog('releaseCubeAgentAfterTransfer', { source });
    this.cubeDummyTransferReleased = true;
    this.cubeAutoTransferRouting = false;
    this.cubeAutoTransferTargetLabel = '';
    this.cubeConnector.setTransferRouting(false);
    this.cubeConnector.releaseAfterBlindTransfer();
    this.clearCubeCallUiOnly(source);
    this.agentStatus = 'IDLE';
    this.cdr.markForCheck();
  }

  /** Final auto-transfer success: emit transferCompleted$, reset routing UI. */
  private completeCubeAutoTransfer(
    transferKey: string,
    targetCampaign: string,
    target: string
  ): void {
    if (!this.inputObj) {
      return;
    }
    this.cubeAutoTransferPendingRelease = false;
    this.cubeAutoTransferPendingKey = '';
    this.cubeAutoTransferPendingCampaign = '';
    this.cubeAutoTransferPendingTarget = '';
    this.cubeAutoTransferExhausted = true;
    this.autoTransferAttemptedKeys.add(transferKey);
    this.cubeConnector.setTransferRouting(false);
    this.cubeAutoTransferRouting = false;
    this.cubeAutoTransferTargetLabel = '';
    if (this.cubeDummyTransferReleased) {
      return;
    }
    this.cubeLog('completeCubeAutoTransfer', { transferKey, targetCampaign, target });
    this.releaseCubeAgentAfterTransfer('auto_transfer');
  }

  private finalizeCubeAutoTransferSuccess(
    transferKey: string,
    targetCampaign: string,
    target: string
  ): void {
    this.completeCubeAutoTransfer(transferKey, targetCampaign, target);
  }

  private async fetchCubeAgentsForCampaign(
    campaignId: string,
    mode?: string
  ): Promise<CubeTransferAgent[]> {
    const campaign = String(campaignId || '').trim();
    if (!campaign) {
      return [];
    }
    const cacheKey = `${campaign}|${mode || ''}`;
    if (cacheKey === this.cubeCampaignAgentsCacheKey && this.cubeCampaignAgentsCache.length) {
      return this.cubeCampaignAgentsCache;
    }
    try {
      const res = await firstValueFrom(
        this.callingService.getCubeCampaignAgents(campaign, mode ? { mode } : undefined)
      ) as { agents?: CubeTransferAgent[]; resultShort?: string };
      if (String(res?.resultShort || '').toLowerCase() === 'failure') {
        return [];
      }
      const agents = (Array.isArray(res?.agents) ? res.agents : []).map((a) => ({
        AgentId: String(a?.AgentId || '').trim(),
        Extension: String(a?.Extension || '').trim(),
        label: String(a?.label || a?.AgentId || '').trim(),
      })).filter((a) => !!a.AgentId);
      this.cubeCampaignAgentsCacheKey = cacheKey;
      this.cubeCampaignAgentsCache = agents;
      return agents;
    } catch {
      return [];
    }
  }

  /**
   * Cube campaign auto-transfer: dummy receives call → pick online activeUser → CubeConnector.redirect().
   * Real/idle active user is chosen in resolveCubeAutoTransferProfileOnline().
   */
  private async runCubeDummyToActiveAutoTransfer(eventData: any): Promise<void> {
    if (!this.isCubeWebphone || !this.inputObj) {
      return;
    }
    if (this.isCubeOutboundAutoTransferBlocked(eventData)) {
      console.log('[CubeAutoTransfer] run skip: outbound/manual');
      this.cubeLog('runCubeDummyToActiveAutoTransfer', { skip: 'outbound_call' });
      return;
    }
    if (
      this.cubeDummyTransferReleased ||
      this.cubeAutoTransferExhausted ||
      this.cubeConnector.isCallCleanupActive() ||
      this.cubeAutoTransferTotalSends >= CallingComponent.CUBE_AUTO_TRANSFER_MAX_ATTEMPTS
    ) {
      console.log('[CubeAutoTransfer] run skip: guarded', {
        exhausted: this.cubeAutoTransferExhausted,
        sends: this.cubeAutoTransferTotalSends,
        dummyReleased: this.cubeDummyTransferReleased,
      });
      this.cubeLog('runCubeDummyToActiveAutoTransfer', {
        skip: 'guarded',
        exhausted: this.cubeAutoTransferExhausted,
        sends: this.cubeAutoTransferTotalSends,
        dummyReleased: this.cubeDummyTransferReleased,
      });
      return;
    }
    if (!this.isCubeCampaignAutoTransferCall(eventData)) {
      console.log('[CubeAutoTransfer] run skip: not eligible campaign/dummy');
      this.cubeLog('runCubeDummyToActiveAutoTransfer', { skip: 'not_eligible_campaign' });
      return;
    }
    if (
      !this.cubeConnector.isCallSessionActive() ||
      this.cubeConnector.isTransferBlocked() ||
      this.inputObj.Status === 'Idle' ||
      this.inputObj.Status === 'Disconnected'
    ) {
      console.log('[CubeAutoTransfer] run skip: session not live', { status: this.inputObj.Status });
      this.cubeLog('runCubeDummyToActiveAutoTransfer', {
        skip: 'session_not_active',
        status: this.inputObj.Status,
      });
      return;
    }
    const profile = await this.resolveCubeAutoTransferProfileOnline();
    if (!profile.enabled || !profile.targetAgentId || !profile.targetCampaign) {
      console.log('[CubeAutoTransfer] run skip: no idle/online real user to transfer to', {
        loginCampaign: profile.loginCampaign,
        targetCampaign: profile.targetCampaign,
        targetAgentId: profile.targetAgentId,
        enabled: profile.enabled,
      });
      this.cubeLog('runCubeDummyToActiveAutoTransfer', {
        skip: 'no_online_active_target',
        loginCampaign: profile.loginCampaign,
        targetCampaign: profile.targetCampaign,
      });
      this.retainCubeCallOnDummyAfterTransferFailure('no_online_target');
      return;
    }
    console.log('[CubeAutoTransfer] run transferring dummy → real user', {
      targetAgentId: profile.targetAgentId,
      targetCampaign: profile.targetCampaign,
      dummyStatus: this.inputObj.Status,
    });
    this.cubeAutoTransferResolvedCampaign = profile.targetCampaign;
    this.cubeAutoTransferResolvedTarget = profile.targetAgentId;
    if (this.cubeConnector.isTransferRouting() && this.autoTransferInFlightKeys.size > 0) {
      this.cubeAutoTransferRouting = true;
      this.cubeAutoTransferTargetLabel = profile.targetAgentId;
      this.cdr.markForCheck();
      return;
    }
    const awaiting = this.cubeConnector.isAwaitingAgentAnswer();
    const onOffer =
      this.inputObj.Status === 'CALLING' &&
      (!!this.inputObj.customerAnswered || awaiting);
    const onConnected = this.inputObj.Status === 'CONNECTED' && !awaiting;
    const dummyConnected =
      this.cubeConnector.isCallConnected() ||
      this.cubeConnector.isCubeIframeAgentConnected() ||
      this.cubeConnector.isAgentLegConnected();
    const sdkHop = shouldUseCubeSdk();
    if (sdkHop && !this.isDummyReadyForSdkRedirect()) {
      console.log('[CubeAutoTransfer] run wait: dummy not connected yet', {
        status: this.inputObj.Status,
      });
      this.cubeLog('runCubeDummyToActiveAutoTransfer', { skip: 'wait_dummy_connected' });
      return;
    }
    const blindOffer = sdkHop ? false : !dummyConnected || onOffer;
      if (!sdkHop && !onOffer && !onConnected && !dummyConnected) {
      console.log('[CubeAutoTransfer] run skip: dummy not on offer/connected', {
        status: this.inputObj.Status,
        onOffer,
        onConnected,
        dummyConnected,
      });
      this.cubeLog('runCubeDummyToActiveAutoTransfer', { skip: 'not_on_offer_or_connected' });
      return;
    }
    if (this.inputObj?.transferCall) {
      return;
    }
    const sourceCampaign = this.resolveCubeConnectedCampaignName(eventData);
    if (!this.isCubeAutoTransferSourceCampaign(sourceCampaign)) {
      return;
    }
    const callRef = this.resolveCubeAutoTransferCallRef(eventData);
    const transferKey = this.buildCubeAutoTransferKey(
      callRef,
      profile.targetCampaign,
      profile.targetAgentId
    );
    if (
      this.autoTransferAttemptedKeys.has(transferKey) ||
      this.cubeAutoTransferWaitKeys.has(transferKey)
    ) {
      return;
    }
    if (this.autoTransferInFlightKeys.has(transferKey)) {
      return;
    }
    const priorSends = this.cubeAutoTransferSendCounts.get(transferKey) || 0;
    if (
      priorSends >= CallingComponent.CUBE_AUTO_TRANSFER_MAX_ATTEMPTS ||
      this.cubeAutoTransferTotalSends >= CallingComponent.CUBE_AUTO_TRANSFER_MAX_ATTEMPTS
    ) {
      this.retainCubeCallOnDummyAfterTransferFailure('max_attempts');
      return;
    }
    this.cubeAutoTransferLegAttempted = true;
    if (this.cubeConnector.isCubeTransferDispatched() && this.cubeAutoTransferPendingRelease) {
      return;
    }
    this.autoTransferInFlightKeys.add(transferKey);
    try {
    if (!dummyConnected && !blindOffer) {
      this.cubeAutoTransferWaitKeys.add(transferKey);
      try {
      const waitStarted = Date.now();
      const waitMs = 18000;
      while (Date.now() - waitStarted < waitMs) {
        await new Promise((r) => setTimeout(r, 500));
        if (
          this.cubeConnector.isCallConnected() ||
          this.cubeConnector.isCubeIframeAgentConnected() ||
          this.cubeConnector.isAgentLegConnected()
        ) {
          break;
        }
        if (
          !this.cubeConnector.isCallSessionActive() ||
          this.cubeConnector.isTransferBlocked() ||
          this.inputObj?.Status === 'Idle' ||
          this.inputObj?.Status === 'Disconnected' ||
          this.cubeAutoTransferExhausted
        ) {
          this.retainCubeCallOnDummyAfterTransferFailure('wait_session_ended');
          return;
        }
      }
      } finally {
        this.cubeAutoTransferWaitKeys.delete(transferKey);
      }
      if (
        !this.cubeConnector.isCallConnected() &&
        !this.cubeConnector.isCubeIframeAgentConnected() &&
        !this.cubeConnector.isAgentLegConnected()
      ) {
        this.retainCubeCallOnDummyAfterTransferFailure('connect_wait_timeout');
        return;
      }
    }
    if (
      this.cubeAutoTransferExhausted ||
      this.cubeAutoTransferTotalSends >= CallingComponent.CUBE_AUTO_TRANSFER_MAX_ATTEMPTS
    ) {
      this.retainCubeCallOnDummyAfterTransferFailure('pre_send_max');
      return;
    }
    this.cubeAutoTransferRouting = true;
    this.cubeAutoTransferTargetLabel = profile.targetAgentId;
    this.cubeConnector.setTransferRouting(true);
    if (this.inputObj) {
      this.inputObj = { ...this.inputObj, holdCall: false };
    }
    this.cdr.markForCheck();
      await new Promise((r) => setTimeout(r, sdkHop ? 800 : 400));
      if (
        !this.cubeConnector.isCallSessionActive() ||
        this.cubeConnector.isTransferBlocked() ||
        this.inputObj?.Status === 'Idle' ||
        this.inputObj?.Status === 'Disconnected'
      ) {
        this.retainCubeCallOnDummyAfterTransferFailure('pre_send_session_ended');
        return;
      }
      this.cubeConnector.setTransferRouting(true);
      let target = profile.targetAgentId;
      let extension = '';
      const agents = await this.fetchCubeAgentsForCampaign(profile.targetCampaign, 'autoTransfer');
      const needle = profile.targetAgentId.toLowerCase();
      const resolved =
        agents.find((a) => String(a?.AgentId || '').toLowerCase() === needle) ||
        agents.find((a) => String(a?.Extension || '').toLowerCase() === needle) ||
        agents.find((a) => String(a?.label || '').toLowerCase() === needle) ||
        agents.find((a) => String(a?.label || '').toLowerCase().includes(needle)) ||
        null;
      if (resolved) {
        target = String(resolved.AgentId || profile.targetAgentId).trim();
        extension = String(resolved.Extension || '').trim();
        this.cubeAutoTransferTargetLabel = target;
        this.cubeAutoTransferResolvedTarget = target;
      } else if (agents.length) {
        console.warn('[CallingWidget] Cube auto transfer target not on dest campaign', {
          configured: profile.targetAgentId,
          campaign: profile.targetCampaign,
          available: agents.map((a) => a.AgentId),
        });
      }
      // Agent hop: CubeConnector.redirect(agentId) — same API as index2.html connector.redirect(number).
      const sendRedirect = async (agentId: string, ext = '', allowOffering = false) =>
        this.cubeConnector.redirect(agentId, {
          extension: ext,
          campaignId: profile.targetCampaign,
          allowOffering: allowOffering || blindOffer,
        });

      let ok = false;
      const retryDelaysMs = [0, 1200, 2400];
      for (let attempt = 1; attempt <= CallingComponent.CUBE_AUTO_TRANSFER_MAX_ATTEMPTS; attempt++) {
        if (
          this.cubeAutoTransferExhausted ||
          this.cubeAutoTransferTotalSends >= CallingComponent.CUBE_AUTO_TRANSFER_MAX_ATTEMPTS
        ) {
          break;
        }
        const delay = retryDelaysMs[attempt - 1];
        if (delay > 0) {
          await new Promise((r) => setTimeout(r, delay));
        }
        if (
          this.cubeDummyTransferReleased ||
          this.cubeAutoTransferPendingRelease ||
          (this.autoTransferAttemptedKeys.has(transferKey) && blindOffer)
        ) {
          ok = true;
          break;
        }
        if (
          !this.cubeConnector.isCallSessionActive() ||
          this.cubeConnector.isTransferBlocked() ||
          this.inputObj?.Status === 'Idle' ||
          this.inputObj?.Status === 'Disconnected'
        ) {
          ok = this.cubeAutoTransferPendingRelease || this.cubeConnector.isCubeTransferDispatched();
          break;
        }
        if (this.inputObj?.transferCall) {
          ok = true;
          break;
        }
        if (this.cubeConnector.isTransferInFlight()) {
          await new Promise((r) => setTimeout(r, 1500));
          if (this.cubeAutoTransferPendingRelease) {
            ok = true;
            break;
          }
          if (this.cubeConnector.isCallCleanupActive() || !this.cubeConnector.isCallSessionActive()) {
            break;
          }
          if (this.cubeAutoTransferTotalSends >= CallingComponent.CUBE_AUTO_TRANSFER_MAX_ATTEMPTS) {
            this.cubeAutoTransferExhausted = true;
            break;
          }
          continue;
        }
        this.cubeAutoTransferTotalSends += 1;
        this.cubeAutoTransferSendCounts.set(transferKey, this.cubeAutoTransferTotalSends);
        if (this.cubeAutoTransferTotalSends >= CallingComponent.CUBE_AUTO_TRANSFER_MAX_ATTEMPTS) {
          this.cubeAutoTransferExhausted = true;
        }
        if (this.cubeAutoTransferTotalSends > CallingComponent.CUBE_AUTO_TRANSFER_MAX_ATTEMPTS) {
          this.cubeAutoTransferExhausted = true;
          break;
        }
        console.log('[CubeAutoTransfer] SDK redirect attempt', {
          from: sourceCampaign,
          toCampaign: profile.targetCampaign,
          toAgent: target,
          extension,
          foundOnDestList: !!resolved,
          attempt: this.cubeAutoTransferTotalSends,
          maxAttempts: CallingComponent.CUBE_AUTO_TRANSFER_MAX_ATTEMPTS,
          blindOffer,
          dummyConnected:
            this.cubeConnector.isCallConnected() ||
            this.cubeConnector.isCubeIframeAgentConnected(),
        });
        ok = await sendRedirect(target, extension, blindOffer);
        console.log('[CubeAutoTransfer] redirect() returned', { ok, toAgent: target, blindOffer });
        if (ok && sdkHop) {
          await new Promise((r) => setTimeout(r, 1000));
          if (this.dummyStillHoldingAutoTransferCall()) {
            console.log('[CubeAutoTransfer] redirect invoked but dummy still on call', {
              toAgent: target,
              status: this.inputObj?.Status,
            });
            this.cubeConnector.clearTransferDispatchForRetry();
            ok = false;
          }
        }
        if (ok && blindOffer) {
          this.markCubeBlindTransferPending(transferKey, profile.targetCampaign, target);
          ok = true;
          break;
        }
        if (ok) {
          this.cubeAutoTransferExhausted = true;
          break;
        }
      }
      if (this.cubeAutoTransferTotalSends >= CallingComponent.CUBE_AUTO_TRANSFER_MAX_ATTEMPTS) {
        this.cubeAutoTransferExhausted = true;
      }
      if (!target) {
        this.cubeConnector.setTransferRouting(false);
        this.cubeAutoTransferRouting = false;
        this.cubeAutoTransferTargetLabel = '';
        return;
      }
      if (ok && this.inputObj && !blindOffer) {
        this.completeCubeAutoTransfer(transferKey, profile.targetCampaign, target);
      } else if (ok && blindOffer && this.cubeAutoTransferPendingRelease) {
        this.maybeCompletePendingCubeAutoTransferRelease('blind_offer_sent');
      } else if (!ok) {
        this.retainCubeCallOnDummyAfterTransferFailure('send_failed');
        console.warn(
          '[CallingWidget] Cube auto transfer failed for',
          target,
          profile.targetCampaign,
          '(dummy keeps call)'
        );
      }
    } catch (error: any) {
      this.retainCubeCallOnDummyAfterTransferFailure('error');
      console.warn('[CallingWidget] Cube auto transfer failed:', error?.message || error);
    } finally {
      this.autoTransferInFlightKeys.delete(transferKey);
      this.cdr.markForCheck();
    }
  }

  /** Transfer not completed — stop routing UI and keep call on dummy agent. */
  private retainCubeCallOnDummyAfterTransferFailure(reason = 'failed'): void {
    this.cubeLog('retainCubeCallOnDummyAfterTransferFailure', { reason });
    console.log('[CubeAutoTransfer] dummy keeps call', { reason });
    if (this.shouldRetrySdkRedirectAfterFailedHop()) {
      this.unlockCubeAutoTransferForRetry();
      this.cubeAutoTransferRouting = false;
      this.cubeAutoTransferTargetLabel = '';
      this.cubeConnector.setTransferRouting(false);
      this.cdr.markForCheck();
      return;
    }
    this.cubeAutoTransferLegAttempted = true;
    this.cubeAutoTransferExhausted = true;
    this.cubeAutoTransferRouting = false;
    this.cubeAutoTransferTargetLabel = '';
    this.cubeConnector.setTransferRouting(false);
    this.cubeConnector.resolveAwaitingForConnectedState();
    this.cdr.markForCheck();
  }

  /**
   * Resolves the active call's campaign from SDK event data, cached callData,
   * widget state, then profile fallback (getSdkCampaignName).
   */
  private resolveConnectedCampaignName(eventData: any): string {
    const candidates = [
      eventData?.campaignName,
      eventData?.CampaignName,
      eventData?.campaign,
      eventData?.campignName,
      eventData?.campignId,
      eventData?.campaignId,
      eventData?.campId,
      this.callData?.campaignName,
      this.callData?.campignId,
      this.callData?.campaignId,
      this.inputObj?.campaignName,
      this.inputObj?.campignId,
      this.getSdkCampaignName(),
    ];
    for (const candidate of candidates) {
      const normalized = this.normalizeCampaignName(candidate);
      if (normalized) {
        return normalized;
      }
    }
    return '';
  }

  /** True when normalized campaign is listed in ozonetel-auto-transfer-config.json campaigns. */
  private isAutoTransferEligibleCampaign(campaignName: string): boolean {
    const normalized = this.normalizeCampaignName(campaignName);
    if (!normalized) {
      return false;
    }
    return getOzonetelAutoTransferCampaigns().some(
      (allowed) => this.normalizeCampaignName(allowed) === normalized
    );
  }

  /** Merges widget, SDK getCallData, and event fields needed for transfer API (ucid, did, extension). */
  private buildAutoTransferInput(eventData: any, liveCallData: any): any {
    const merged = {
      ...(this.inputObj || {}),
      ...(liveCallData || {}),
      ...(eventData || {}),
    };
    const ucid = merged.ucid || merged.UCID || merged.monitorUcid;
    const did = merged.did || merged.DID || merged.callerID || merged.callerId;
    const agentPhoneName =
      merged.agentPhoneName ||
      merged.phoneName ||
      merged.agentExtension ||
      merged.extension ||
      merged.Extension;
    return {
      ...merged,
      ucid,
      did,
      agentPhoneName,
    };
  }

  /** Idempotency key: one auto-transfer attempt per call leg (ucid) and target agent. */
  private buildAutoTransferKey(ucid: string, targetAgentId: string): string {
    return `${ucid}::${targetAgentId}`;
  }

  /**
   * Ozonetel automatic warm transfer (S3 per-campaign config — not DB isCallTransfer/toTranfer):
   * 1) Call status is CONNECTED
   * 2) S3 config has at least one campaign with dummyUsers + activeUsers
   * 3) Resolved campaign is configured in S3 campaigns map
   * 4) Logged-in agentId is in that campaign's dummyUsers
   * 5) UCID present and this leg has not been attempted yet
   * 6) Destination picked from that campaign's activeUsers (random if 2+; prefer online)
   * 7) Target agent is online in Ozonetel transfer list
   * On success, mirrors manual transfer post-actions (flag, save, optional release).
   * Cube auto-transfer uses runCubeDummyToActiveAutoTransfer — do not mix paths.
   */
  private async maybeAutoTransferConnectedCall(eventData: any): Promise<void> {
    if (!this.inputObj || this.inputObj.Status !== 'CONNECTED') {
      return;
    }
    if (!isOzonetelAutoTransferConfigReady()) {
      return;
    }
    let liveCallData: any = this.callData;
    if (this.ozonetelSDKCore.isAgentInitialized()) {
      try {
        liveCallData = await this.ozonetelSDKCore.getCallData();
        this.callData = liveCallData;
      } catch {
      }
    }
    const mergedEvent = this.buildAutoTransferInput(eventData, liveCallData);
    const campaignName = this.resolveConnectedCampaignName(mergedEvent);
    if (!this.isAutoTransferEligibleCampaign(campaignName)) {
      return;
    }
    const selfAgentId = String(this.getOzonetelDetailsFromRemarks()?.agentId || '').trim();
    if (!isOzonetelAutoTransferDummyAgent(selfAgentId, campaignName)) {
      return;
    }
    const ucid = String(mergedEvent?.ucid || mergedEvent?.UCID || '').trim();
    if (!ucid) {
      return;
    }
    // One auto-transfer attempt per call leg (destination chosen from activeUsers after list refresh).
    const transferKey = this.buildAutoTransferKey(ucid, 'auto');
    if (
      this.autoTransferAttemptedKeys.has(transferKey) ||
      this.autoTransferInFlightKeys.has(transferKey)
    ) {
      return;
    }
    this.autoTransferInFlightKeys.add(transferKey);
    try {
      await this.refreshTransferAgents();
      const onlineIds = (this.extensionNumbers || []).map((agent: any) =>
        String(agent?.AgentId || agent?.agentId || agent?.transferTo || '').trim()
      );
      const targetAgentId = pickOzonetelAutoTransferTarget(onlineIds, campaignName);
      if (!targetAgentId) {
        return;
      }
      const resolved = await this.ozonetelTransfer.resolveTransferTargetOnline(
        targetAgentId,
        this.extensionNumbers
      );
      if (!resolved) {
        console.warn(
          '[CallingWidget] Auto transfer target is not online in Ozonetel transfer list:',
          targetAgentId
        );
        return;
      }
      this.autoTransferAttemptedKeys.add(transferKey);
      const transferTo = resolved.transferTo || resolved.AgentId;
      const result = await this.ozonetelTransfer.warmTransferToAgent(
        transferTo,
        mergedEvent,
        this.diallerController,
        this.extensionNumbers
      );
      if (result.success && this.inputObj) {
        this.inputObj.transferCall = true;
        this.inputObj.RedirectToAgentId = transferTo;
        this.inputObj = { ...this.inputObj };
        this.saveDiallingObj();
        if (result.releaseAgentA) {
          // Auto-transfer follows same Agent A release bypass behavior as manual transfer.
          this.pendingTransferReleaseBypass = true;
          setTimeout(() => void this.releaseAgentAfterTransfer(), result.releaseDelayMs ?? 4000);
        }
      } else if (!result.success) {
        this.autoTransferAttemptedKeys.delete(transferKey);
        console.warn('[CallingWidget] Auto transfer skipped/failed:', result.message);
      }
    } catch (error: any) {
      this.autoTransferAttemptedKeys.delete(transferKey);
      console.warn('[CallingWidget] Auto transfer failed:', error?.message || error);
    } finally {
      this.autoTransferInFlightKeys.delete(transferKey);
    }
  }

  showErr(msg1: string, msg2: string) {
    this.snackbar.open(msg1, msg2, { duration: 4000 });
  }

  saveDiallingObj() {
    this.incomeCallService.setCallingRes(this.inputObj);
  }

  onActions(flag?: boolean) {
    this.onAction.emit(flag);
  }

  timer() {
    // Wrap timer: featureList.wrapDuration drives ACW countdown; expiry calls autoDisposeCall().
    const start = () => {
      const featureList = this.userService.getFeatureList();
      if (featureList?.wrapDuration) {
        if (!this.timerInterval && !this.showTimer) {
          this.showTimer = true;
          this.timerMinutes = Math.floor(featureList.wrapDuration / 60);
          this.timerSeconds = featureList.wrapDuration - this.timerMinutes * 60;
          this.timerInterval = setInterval(() => {
            this.timerSeconds -= 1;
            if (this.timerSeconds < 0 && this.showTimer) {
              this.timerMinutes -= 1;
              if (this.timerMinutes < 0) {
                this.autoDisposeCall();
                this.incomeCallService.IncomingCallSubject.next({ timerFlag: true });
                stop();
              } else {
                this.timerSeconds = 59;
              }
            }
          }, 1000);
        }
      }
    };

    const stop = () => {
      this.showTimer = false;
      this.timerMinutes = 0;
      this.timerSeconds = 0;
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = undefined;
      }
    };

    return { start, stop };
  }

  /**
   * Wrap timer expiry handler. Ozonetel SDK path: auto-submit "Auto Dispose" disposition.
   * Other dialers: legacy diallerController.autoDisposeCall API unchanged.
   */
  autoDisposeCall() {
    if (
      this.centroWrapUpActive &&
      this.inputObj?.callingType === 'centro'
    ) {
      const autoReason = this.resolveCentroAutoDisposeReason();
      if (autoReason) {
        this.selectedCentroDisposition = autoReason;
      }
      if (this.selectedCentroDisposition) {
        void this.submitCentroDisposition(true);
        this.incomeCallService.IncomingCallSubject.next({ timerFlag: true });
        return;
      }
    }
    if (
      this.cubeWrapUpActive &&
      this.isCubeWebphone &&
      this.inputObj?.callingType === 'cube'
    ) {
      const autoReason = this.resolveCubeAutoDisposeReason();
      if (autoReason) {
        this.selectedCubeDisposition = autoReason;
      }
      if (this.selectedCubeDisposition) {
        void this.submitCubeDisposition(true);
        this.incomeCallService.IncomingCallSubject.next({ timerFlag: true });
        return;
      }
    }
    if (
      this.ozonetelWrapUpActive &&
      this.isSdkDialer &&
      this.inputObj?.callingType === 'ozonetel'
    ) {
      // Auto-submit uses campaign disposition "Auto Dispose" when present in the list.
      const autoReason = this.resolveOzonetelAutoDisposeReason();
      if (autoReason) {
        this.selectedOzonetelDisposition = autoReason;
      }
      if (this.selectedOzonetelDisposition) {
        void this.submitOzonetelDisposition(true);
        this.incomeCallService.IncomingCallSubject.next({ timerFlag: true });
        return;
      }
    }

    const postObj: any = {
      dueId: this.inputObj.dueId,
      DefaulterPhoneNo: this.inputObj.phoneNo,
      clientId: this.inputObj.clientId
    };

    const commId = this.userService.getCallCommunicationDetailId();
    if (commId) {
      postObj.CommunicationDetailId = commId;
    }

    this.diallerController?.autoDisposeCall(postObj).subscribe();
  }

  // Used to mark timeline "Auto Dispose" after call is auto disposed from dialer
  private autoDisposeCentroTimeline(
    dueId = this.inputObj?.dueId,
    phoneNo = this.inputObj?.phoneNo,
    clientId = this.inputObj?.clientId
  ): void {
    if (!dueId) {
      return;
    }
    const postObj: any = {
      dueId,
      DefaulterPhoneNo: phoneNo,
      clientId,
    };
    const commId = this.userService.getCallCommunicationDetailId();
    if (commId) {
      postObj.CommunicationDetailId = commId;
    }
    this.callingService.autoDisposeCall(postObj).subscribe();
  }

  // Used to mark timeline "Auto Dispose" after call is auto disposed from dialer
  private autoDisposeCubeTimeline(
    dueId = this.inputObj?.dueId,
    phoneNo = this.inputObj?.phoneNo,
    clientId = this.inputObj?.clientId
  ): void {
    if (!dueId) {
      return;
    }
    const postObj: any = {
      dueId,
      DefaulterPhoneNo: phoneNo,
      clientId,
    };
    const commId = this.userService.getCallCommunicationDetailId();
    if (commId) {
      postObj.CommunicationDetailId = commId;
    }
    this.callingService.autoDisposeCall(postObj).subscribe();
  }
}
